(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bC.ba === region.cv.ba)
	{
		return 'on line ' + region.bC.ba;
	}
	return 'on lines ' + region.bC.ba + ' through ' + region.cv.ba;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ew,
		impl.fr,
		impl.fh,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bX: func(record.bX),
		b5: record.b5,
		b1: record.b1
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bX;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.b5;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.b1) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ew,
		impl.fr,
		impl.fh,
		function(sendToApp, initialModel) {
			var view = impl.fx;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ew,
		impl.fr,
		impl.fh,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.b2 && impl.b2(sendToApp)
			var view = impl.fx;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.d1);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.G) && (_VirtualDom_doc.title = title = doc.G);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.eU;
	var onUrlRequest = impl.eV;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		b2: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.$7 === next.$7
							&& curr.cI === next.cI
							&& curr.df.a === next.df.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ew: function(flags)
		{
			return A3(impl.ew, flags, _Browser_getUrl(), key);
		},
		fx: impl.fx,
		fr: impl.fr,
		fh: impl.fh
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { es: 'hidden', d6: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { es: 'mozHidden', d6: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { es: 'msHidden', d6: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { es: 'webkitHidden', d6: 'webkitvisibilitychange' }
		: { es: 'hidden', d6: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		dy: _Browser_getScene(),
		dP: {
			dS: _Browser_window.pageXOffset,
			dT: _Browser_window.pageYOffset,
			dR: _Browser_doc.documentElement.clientWidth,
			cG: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		dR: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		cG: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			dy: {
				dR: node.scrollWidth,
				cG: node.scrollHeight
			},
			dP: {
				dS: node.scrollLeft,
				dT: node.scrollTop,
				dR: node.clientWidth,
				cG: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			dy: _Browser_getScene(),
			dP: {
				dS: x,
				dT: y,
				dR: _Browser_doc.documentElement.clientWidth,
				cG: _Browser_doc.documentElement.clientHeight
			},
			ek: {
				dS: x + rect.left,
				dT: y + rect.top,
				dR: rect.width,
				cG: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.eJ) { flags += 'm'; }
	if (options.d5) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.p) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.s),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.s);
		} else {
			var treeLen = builder.p * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.v) : builder.v;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.p);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.s) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.s);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{v: nodeList, p: (len / $elm$core$Array$branchFactor) | 0, s: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {cA: fragment, cI: host, e0: path, df: port_, $7: protocol, dp: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Main$Flags = function (pageUrl) {
	return function (translations) {
		return function (overrideLocale) {
			return function (isRTL) {
				return function (windowWidth) {
					return function (windowHeight) {
						return function (gallery) {
							return function (testing) {
								return function (isEnterprise) {
									return function (isReadOnly) {
										return function (token) {
											return function (allTemplates) {
												return function (hasRelatedSolutions) {
													return function (userPrivileges) {
														return function (suppress_solutionDiagramFeature_announcement) {
															return {az: allTemplates, T: gallery, ad: hasRelatedSolutions, aT: isEnterprise, aE: isRTL, aF: isReadOnly, aH: overrideLocale, dc: pageUrl, av: suppress_solutionDiagramFeature_announcement, aX: testing, aw: token, n: translations, an: userPrivileges, ay: windowHeight, K: windowWidth};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Card$BaseType = {$: 0};
var $author$project$Card$Model = function (id) {
	return function (title) {
		return function (snippet) {
			return function (description) {
				return function (url) {
					return function (itemUrl) {
						return function (thumbnailUrl) {
							return function (tryitUrl) {
								return function (typeKeywords) {
									return function (learnMoreUrl) {
										return function (createdMs) {
											return function (created) {
												return function (modified) {
													return function (numViews) {
														return function (tags) {
															return function (categories) {
																return function (licenseInfo) {
																	return function (deployCommonId) {
																		return function (deployVersion) {
																			return function (canDelete) {
																				return function (canDeploy) {
																					return function (templateInfo) {
																						return function (relatedItems) {
																							return function (preview) {
																								return function (isListeningForPreviewImagesMouseMove) {
																									return function (dragHorizOffset) {
																										return function (isDraggingPreviewImages) {
																											return function (currentPreviewImage) {
																												return function (deployPercentage) {
																													return function (deletePercentage) {
																														return function (sourcePortalUrl) {
																															return function (knownToBePublicSource) {
																																return function (waitId) {
																																	return function (relatedSolutions) {
																																		return function (cardType) {
																																			return function (showDiagramButtonVisible) {
																																				return function (highlight_new_feature) {
																																					return {bh: canDelete, bJ: canDeploy, ap: cardType, aP: categories, bi: created, bK: createdMs, co: currentPreviewImage, cr: deletePercentage, a6: deployCommonId, a7: deployPercentage, bl: deployVersion, bM: description, cu: dragHorizOffset, bT: highlight_new_feature, aa: id, cN: isDraggingPreviewImages, cO: isListeningForPreviewImagesMouseMove, aq: itemUrl, bq: knownToBePublicSource, bV: learnMoreUrl, bW: licenseInfo, bt: modified, b$: numViews, dj: preview, dq: relatedItems, dr: relatedSolutions, b3: showDiagramButtonVisible, aW: snippet, b4: sourcePortalUrl, b7: tags, dL: templateInfo, aj: thumbnailUrl, G: title, b9: tryitUrl, ca: typeKeywords, cb: url, cc: waitId};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Card$defaultTemplateInfo = {cl: '', cJ: $elm$core$Set$empty, dk: $elm$core$Set$empty, dO: _List_Nil};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Card$PartialItem = F4(
	function (itemName, itemType, owner, modified) {
		return {ez: itemName, cQ: itemType, bt: modified, eZ: owner};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Card$partialItemDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Card$PartialItem,
	A2($elm$json$Json$Decode$field, 'itemName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'itemType', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'owner', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'modified', $elm$json$Json$Decode$string));
var $author$project$Card$Preview = F3(
	function (name, format, alt) {
		return {dX: alt, er: format, cX: name};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Card$previewDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'alt',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'format',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Card$Preview))));
var $author$project$Card$TemplateInfo = F4(
	function (ids, privileges, userOptions, configureLearnMore) {
		return {cl: configureLearnMore, cJ: ids, dk: privileges, dO: userOptions};
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Card$setDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Set$fromList,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Card$UserOption = F3(
	function (id, props, accordionDisplay) {
		return {dV: accordionDisplay, aa: id, e6: props};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Card$UserProp = function (autoSelect) {
	return function (id) {
		return function (itemType) {
			return function (label) {
				return function (prop) {
					return function (_default) {
						return function (value) {
							return function (responseValue) {
								return function (choices) {
									return function (valueType) {
										return function (attributes) {
											return function (validation) {
												return function (valid) {
													return function (validId) {
														return function (srSearchText) {
															return function (outType) {
																return function (loading) {
																	return function (tooltip) {
																		return function (name) {
																			return function (title) {
																				return function (itemUrl) {
																					return {dZ: attributes, d_: autoSelect, d9: choices, ef: _default, aa: id, cQ: itemType, aq: itemUrl, eB: label, eE: loading, cX: name, eY: outType, e5: prop, e9: responseValue, ff: srSearchText, G: title, fn: tooltip, fs: valid, ft: validId, fu: validation, fv: value, fw: valueType};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Card$propDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'itemUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tooltip',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'loading',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'outType',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'srSearchText',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'validId',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'valid',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'validation',
										$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'attributes',
											$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'valueType',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'choices',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'responseValue',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'value',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'default',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'prop',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'label',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'itemType',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'id',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'autoSelect',
																					$elm$json$Json$Decode$bool,
																					$elm$json$Json$Decode$succeed($author$project$Card$UserProp))))))))))))))))))))));
var $author$project$Card$userOptionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Card$UserOption,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'props',
		$elm$json$Json$Decode$list($author$project$Card$propDecoder)),
	A2($elm$json$Json$Decode$field, 'accordionDisplay', $elm$json$Json$Decode$bool));
var $author$project$Card$userOptionsDecoder = $elm$json$Json$Decode$list($author$project$Card$userOptionDecoder);
var $author$project$Card$templateInfoDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Card$TemplateInfo,
	A2($elm$json$Json$Decode$field, 'ids', $author$project$Card$setDecoder),
	A2($elm$json$Json$Decode$field, 'privileges', $author$project$Card$setDecoder),
	A2($elm$json$Json$Decode$field, 'userOptions', $author$project$Card$userOptionsDecoder),
	A2($elm$json$Json$Decode$field, 'configureLearnMore', $elm$json$Json$Decode$string));
var $author$project$Card$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'highlight_new_feature',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'showDiagramButtonVisible',
		$elm$json$Json$Decode$bool,
		false,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$author$project$Card$BaseType,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'relatedSolutions',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'waitId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'knownToBePublicSource',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sourcePortalUrl',
							$elm$json$Json$Decode$string,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								0.0,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									0.0,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										0,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											false,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
												0,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													false,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'preview',
														$elm$json$Json$Decode$list($author$project$Card$previewDecoder),
														_List_Nil,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'relatedItems',
															$elm$json$Json$Decode$list($author$project$Card$partialItemDecoder),
															_List_Nil,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'templateInfos',
																$author$project$Card$templateInfoDecoder,
																$author$project$Card$defaultTemplateInfo,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'canDeploy',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'canDelete',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'deployVersion',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'deployCommonId',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'licenseInfo',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'categories',
																						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'tags',
																							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'numViews',
																								$elm$json$Json$Decode$int,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'modified',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'created',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'createdMs',
																											$elm$json$Json$Decode$int,
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'learnMoreUrl',
																												$elm$json$Json$Decode$string,
																												'',
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'typeKeywords',
																													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'tryitUrl',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'thumbnailUrl',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'itemUrl',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'url',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'description',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'snippet',
																																			$elm$json$Json$Decode$string,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'title',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'id',
																																					$elm$json$Json$Decode$string,
																																					$elm$json$Json$Decode$succeed($author$project$Card$Model))))))))))))))))))))))))))))))))))))));
var $author$project$Main$setDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Set$fromList,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'suppress_solutionDiagramFeature_announcement',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'userPrivileges',
		$author$project$Main$setDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hasRelatedSolutions',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'allTemplates',
				$elm$json$Json$Decode$list($author$project$Card$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'token',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'isReadOnly',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'isEnterprise',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'testing',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'gallery',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'windowHeight',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'windowWidth',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'isRTL',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'overrideLocale',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'translations',
														$elm$json$Json$Decode$value,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'pageUrl',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Main$Flags))))))))))))))));
var $author$project$Main$Home = 0;
var $author$project$Main$NotStarted = 0;
var $author$project$Main$StandardLoader = 0;
var $author$project$Main$defaultHeightInfo = {a3: 188, cy: 240};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Main$defaultPaging = {bc: -1, bu: 0, bC: 1, aY: 0};
var $author$project$Card$emptyCard = {bh: false, bJ: true, ap: $author$project$Card$BaseType, aP: _List_Nil, bi: '', bK: 0, co: 0, cr: 0.0, a6: '', a7: 0.0, bl: '', bM: '', cu: 0, bT: false, aa: '', cN: false, cO: false, aq: '', bq: false, bV: '', bW: '', bt: '', b$: 0, dj: _List_Nil, dq: _List_Nil, dr: _List_Nil, b3: false, aW: '', b4: '', b7: _List_Nil, dL: $author$project$Card$defaultTemplateInfo, aj: '', G: '', b9: '', ca: _List_Nil, cb: '', cc: ''};
var $author$project$Main$aecDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$airportPortRail = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$businessDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$conservationDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$defenseDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$facilitiesDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$govDomain = $elm$core$Set$fromList(
	_List_fromArray(
		['Airports', 'Agriculture', 'Assessment and Taxation', 'Elections', 'Emergency Management', 'Fire Service', 'Fish and Wildlife', 'Health and Human Services', 'Law Enforcement', 'Natural Resources', 'Parks', 'Planning and Development', 'Public Works', 'Transportation']));
var $author$project$Main$healthDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$pipelineDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$publicsafetyDomain = $elm$core$Set$fromList(
	_List_fromArray(
		['Emergency Management', 'Fire Service', 'Law Enforcement']));
var $author$project$Main$renewablesDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$telecommDomain = $elm$core$Set$fromList(_List_Nil);
var $author$project$Main$utilityDomain = $elm$core$Set$fromList(
	_List_fromArray(
		['District Energy', 'Electric', 'Gas', 'Sewer', 'Stormwater', 'Water Distribution']));
var $author$project$Main$industryTags = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('AEC', $author$project$Main$aecDomain),
			_Utils_Tuple2('Airports, Ports, and Rails', $author$project$Main$airportPortRail),
			_Utils_Tuple2('Business', $author$project$Main$businessDomain),
			_Utils_Tuple2('Conservation', $author$project$Main$conservationDomain),
			_Utils_Tuple2('Defense', $author$project$Main$defenseDomain),
			_Utils_Tuple2('Facilities', $author$project$Main$facilitiesDomain),
			_Utils_Tuple2('Health and Human Services', $author$project$Main$healthDomain),
			_Utils_Tuple2('Pipeline', $author$project$Main$pipelineDomain),
			_Utils_Tuple2('Public Safety', $author$project$Main$publicsafetyDomain),
			_Utils_Tuple2('Renewables', $author$project$Main$renewablesDomain),
			_Utils_Tuple2('State and Local Government', $author$project$Main$govDomain),
			_Utils_Tuple2('Telecommunications', $author$project$Main$telecommDomain),
			_Utils_Tuple2('Utilities', $author$project$Main$utilityDomain)
		]));
var $ChristophP$elm_i18next$I18Next$Translations = $elm$core$Basics$identity;
var $ChristophP$elm_i18next$I18Next$initialTranslations = $elm$core$Dict$empty;
var $author$project$Main$initialModel = {b: $author$project$Card$emptyCard, L: _List_Nil, Q: $author$project$Card$emptyCard, aO: $author$project$Card$emptyCard, az: _List_Nil, bI: $elm$core$Dict$empty, C: _List_Nil, a2: '', aP: $author$project$Main$industryTags, bj: '', aB: 0, u: false, Y: _List_Nil, a8: true, Z: $elm$core$Dict$empty, r: $elm$core$Dict$empty, x: $elm$core$Set$empty, bp: true, T: false, aS: 1, ad: false, D: $elm$core$Set$empty, ae: 'information', aT: false, ab: false, aE: false, aF: false, a9: false, aU: $author$project$Main$defaultHeightInfo, F: false, ak: 'Card', U: '', as: 'created', am: 'desc', aG: '', i: $author$project$Main$defaultPaging, aH: '', O: 0, V: '', bd: '', W: true, au: 'relevance', X: 'desc', av: false, e: 0, aL: true, aX: false, aw: '', n: $ChristophP$elm_i18next$I18Next$initialTranslations, B: $elm$core$Set$empty, H: -1, bH: true, an: $elm$core$Set$empty, I: $elm$core$Dict$empty, ay: 0, K: 0};
var $author$project$Main$mobileWidthThreshold = 860;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslationsHelp = F3(
	function (initialValue, namespace, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 1) {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$ChristophP$elm_i18next$I18Next$flattenTranslationsHelp,
							acc,
							newNamespace(key),
							children);
					}
				}),
			initialValue,
			dict);
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslations = A2($ChristophP$elm_i18next$I18Next$flattenTranslationsHelp, $elm$core$Dict$empty, '');
var $ChristophP$elm_i18next$I18Next$Branch = function (a) {
	return {$: 0, a: a};
};
var $ChristophP$elm_i18next$I18Next$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $ChristophP$elm_i18next$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$ChristophP$elm_i18next$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder()));
				})
			]));
}
var $ChristophP$elm_i18next$I18Next$treeDecoder = $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder();
$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder = function () {
	return $ChristophP$elm_i18next$I18Next$treeDecoder;
};
var $ChristophP$elm_i18next$I18Next$translationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $ChristophP$elm_i18next$I18Next$flattenTranslations, $elm$core$Basics$identity),
	$elm$json$Json$Decode$dict($ChristophP$elm_i18next$I18Next$treeDecoder));
var $author$project$Main$ChangeInfoMode = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Main$Deleting = 1;
var $author$project$Main$Deploy = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Main$Failed = 3;
var $author$project$Main$RequestAvailableSolutions = {$: 3};
var $author$project$Main$RequestDeployedSolutions = {$: 4};
var $author$project$Main$RequestInitialization = {$: 1};
var $author$project$Main$RequestSelectedSolution = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$Retrying = 2;
var $author$project$Main$ScrollLoader = 1;
var $author$project$Main$SearchLoader = 2;
var $author$project$Main$SetSpatialReference = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Main$Solutions = 1;
var $author$project$Main$StopDraggingPreviewImages = {$: 31};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Main$IOPCmdRequestAvailableSolutions = 4;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Main$askJSLibrary = _Platform_outgoingPort(
	'askJSLibrary',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'command',
					$elm$json$Json$Encode$string($.a4)),
					_Utils_Tuple2(
					'data',
					$elm$core$Basics$identity($.l)),
					_Utils_Tuple2(
					'optionalData',
					$elm$core$Basics$identity($.i))
				]));
	});
var $author$project$Main$IOPCmdCloseAlert = 25;
var $author$project$Main$IOPCmdCloseModal = 30;
var $author$project$Main$IOPCmdDeployFailure = 38;
var $author$project$Main$IOPCmdDeployingStarted = 12;
var $author$project$Main$IOPCmdError = 0;
var $author$project$Main$IOPCmdGenerateShareLinkForSoln = 9;
var $author$project$Main$IOPCmdGetValueById = 31;
var $author$project$Main$IOPCmdNavToggle = 15;
var $author$project$Main$IOPCmdOpenDeleteModal = 20;
var $author$project$Main$IOPCmdOpenDiagramModal = 21;
var $author$project$Main$IOPCmdOpenFilterModal = 22;
var $author$project$Main$IOPCmdOpenLink = 23;
var $author$project$Main$IOPCmdOpenModal = 18;
var $author$project$Main$IOPCmdPopulateDiagramModal = 24;
var $author$project$Main$IOPCmdRequestAvailableSolutionsError = 5;
var $author$project$Main$IOPCmdRequestDeployJobId = 40;
var $author$project$Main$IOPCmdRequestDeployedSolutions = 6;
var $author$project$Main$IOPCmdRequestMaxHeights = 39;
var $author$project$Main$IOPCmdRequestSelectedSolution = 8;
var $author$project$Main$IOPCmdRequestToDeleteSolution = 29;
var $author$project$Main$IOPCmdRequestToDeploySolution = 10;
var $author$project$Main$IOPCmdRequestToDeploySolutionAtLaunch = 11;
var $author$project$Main$IOPCmdRetryDeploy = 37;
var $author$project$Main$IOPCmdSetActiveCardTemplateInfos = 35;
var $author$project$Main$IOPCmdSetCookie = 26;
var $author$project$Main$IOPCmdSetDeleteCardRelatedItems = 36;
var $author$project$Main$IOPCmdToTriggerScrollRefresh = 19;
var $author$project$Main$IOPCmdTreeToggle = 14;
var $author$project$Main$IOPCmdTriggerBlur = 28;
var $author$project$Main$IOPCmdTriggerFocus = 27;
var $author$project$Main$IOPCmdUpdateFilterMetatags = 17;
var $author$project$Main$IOPCmdUpdateModal = 32;
var $author$project$Main$IOPCmdUpdateRelatedSolutions = 7;
var $author$project$Main$IOPCmdUpdateToken = 41;
var $author$project$Main$IOPCmdUpdateUrlSearch = 33;
var $author$project$Main$IOPCmdUpdateVisibleOptions = 34;
var $author$project$Main$IOPCmdUrlChange = 16;
var $author$project$Main$IOPCmdValidateID = 13;
var $author$project$Main$IOPLoadDeployedSolutions = 1;
var $author$project$Main$IOPNotifProgressUpdate = 2;
var $author$project$Main$IOPNotifyDeleteUpdate = 3;
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $Herteby$enum$Enum$create = function (list) {
	var toString = function (a) {
		var _v1 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v2) {
					var str = _v2.a;
					var b = _v2.b;
					return _Utils_eq(b, a);
				},
				list));
		if (!_v1.$) {
			var _v3 = _v1.a;
			var str = _v3.a;
			var b = _v3.b;
			return str;
		} else {
			return 'Missing enum';
		}
	};
	var dict = $elm$core$Dict$fromList(list);
	var fromString = function (string) {
		return A2($elm$core$Dict$get, string, dict);
	};
	return {
		bk: A2(
			$elm$json$Json$Decode$andThen,
			function (string) {
				var _v0 = A2($elm$core$Dict$get, string, dict);
				if (!_v0.$) {
					var a = _v0.a;
					return $elm$json$Json$Decode$succeed(a);
				} else {
					return $elm$json$Json$Decode$fail('Missing enum: ' + string);
				}
			},
			$elm$json$Json$Decode$string),
		bn: A2($elm$core$Basics$composeR, toString, $elm$json$Json$Encode$string),
		cC: fromString,
		br: list,
		g: toString
	};
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $Herteby$enum$Enum$iterate = F2(
	function (iterator, init) {
		var helper = F2(
			function (prevValue, stack) {
				helper:
				while (true) {
					var item = iterator(prevValue);
					var value = item.b;
					if (_Utils_eq(value, init)) {
						return A2(
							$elm$core$List$cons,
							item,
							$elm$core$List$reverse(stack));
					} else {
						var $temp$prevValue = value,
							$temp$stack = A2($elm$core$List$cons, item, stack);
						prevValue = $temp$prevValue;
						stack = $temp$stack;
						continue helper;
					}
				}
			});
		return A2(helper, init, _List_Nil);
	});
var $Herteby$enum$Enum$fromIterator = F2(
	function (iterator, start) {
		return $Herteby$enum$Enum$create(
			A2($Herteby$enum$Enum$iterate, iterator, start));
	});
var $author$project$Main$interopCommand = A2(
	$Herteby$enum$Enum$fromIterator,
	function (a) {
		switch (a) {
			case 0:
				return _Utils_Tuple2('IOPLoadDeployedSolutions', 1);
			case 1:
				return _Utils_Tuple2('IOPNotifProgressUpdate', 2);
			case 2:
				return _Utils_Tuple2('IOPNotifyDeleteUpdate', 3);
			case 3:
				return _Utils_Tuple2('IOPCmdRequestAvailableSolutions', 4);
			case 4:
				return _Utils_Tuple2('IOPCmdRequestAvailableSolutionsError', 5);
			case 5:
				return _Utils_Tuple2('IOPCmdRequestDeployedSolutions', 6);
			case 6:
				return _Utils_Tuple2('IOPCmdUpdateRelatedSolutions', 7);
			case 7:
				return _Utils_Tuple2('IOPCmdRequestSelectedSolution', 8);
			case 8:
				return _Utils_Tuple2('IOPCmdGenerateShareLinkForSoln', 9);
			case 9:
				return _Utils_Tuple2('IOPCmdRequestToDeploySolution', 10);
			case 10:
				return _Utils_Tuple2('IOPCmdRequestToDeploySolutionAtLaunch', 11);
			case 11:
				return _Utils_Tuple2('IOPCmdDeployingStarted', 12);
			case 12:
				return _Utils_Tuple2('IOPCmdTreeToggle', 14);
			case 14:
				return _Utils_Tuple2('IOPCmdNavToggle', 15);
			case 15:
				return _Utils_Tuple2('IOPCmdValidateID', 13);
			case 13:
				return _Utils_Tuple2('IOPCmdUrlChange', 16);
			case 16:
				return _Utils_Tuple2('IOPCmdUpdateFilterMetatags', 17);
			case 17:
				return _Utils_Tuple2('IOPCmdOpenModal', 18);
			case 18:
				return _Utils_Tuple2('IOPCmdToTriggerScrollRefresh', 19);
			case 19:
				return _Utils_Tuple2('IOPCmdOpenDeleteModal', 20);
			case 20:
				return _Utils_Tuple2('IOPCmdOpenDiagramModal', 21);
			case 21:
				return _Utils_Tuple2('IOPCmdOpenFilterModal', 22);
			case 22:
				return _Utils_Tuple2('IOPCmdOpenLink', 23);
			case 23:
				return _Utils_Tuple2('IOPCmdPopulateDiagramModal', 24);
			case 24:
				return _Utils_Tuple2('IOPCmdCloseAlert', 25);
			case 25:
				return _Utils_Tuple2('IOPCmdSetCookie', 26);
			case 26:
				return _Utils_Tuple2('IOPCmdTriggerFocus', 27);
			case 27:
				return _Utils_Tuple2('IOPCmdTriggerBlur', 28);
			case 28:
				return _Utils_Tuple2('IOPCmdRequestToDeleteSolution', 29);
			case 29:
				return _Utils_Tuple2('IOPCmdCloseModal', 30);
			case 30:
				return _Utils_Tuple2('IOPCmdGetValueById', 31);
			case 31:
				return _Utils_Tuple2('IOPCmdUpdateUrlSearch', 33);
			case 33:
				return _Utils_Tuple2('IOPCmdUpdateVisibleOptions', 34);
			case 34:
				return _Utils_Tuple2('IOPCmdUpdateModal', 32);
			case 32:
				return _Utils_Tuple2('IOPCmdSetActiveCardTemplateInfos', 35);
			case 35:
				return _Utils_Tuple2('IOPCmdSetDeleteCardRelatedItems', 36);
			case 36:
				return _Utils_Tuple2('IOPCmdRetryDeploy', 37);
			case 37:
				return _Utils_Tuple2('IOPCmdDeployFailure', 38);
			case 38:
				return _Utils_Tuple2('IOPCmdRequestMaxHeights', 39);
			case 39:
				return _Utils_Tuple2('IOPCmdRequestDeployJobId', 40);
			case 40:
				return _Utils_Tuple2('IOPCmdUpdateToken', 41);
			default:
				return _Utils_Tuple2('IOPCmdError', 0);
		}
	},
	0);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Main$packageRequest = F3(
	function (command, data, optionalData) {
		return {a4: command, l: data, i: optionalData};
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Main$setupCategoryQuery = F2(
	function (domFilters, indFilters) {
		var industryDomainCats = function () {
			var _v0 = $elm$core$Set$toList(indFilters);
			if (!_v0.b) {
				return _List_Nil;
			} else {
				if (!_v0.b.b) {
					var industryFilter = _v0.a;
					var _v1 = $elm$core$Set$toList(domFilters);
					if (!_v1.b) {
						return _List_fromArray(
							['/Categories/' + industryFilter]);
					} else {
						if (!_v1.b.b) {
							var domainFilter = _v1.a;
							return _List_fromArray(
								['/Categories/' + (industryFilter + ('/' + domainFilter))]);
						} else {
							return _List_Nil;
						}
					}
				} else {
					return _List_Nil;
				}
			}
		}();
		return industryDomainCats;
	});
var $author$project$Main$queryEncoder = F2(
	function (model, queryType) {
		var isTemplateQuery = queryType === 'Template';
		var searchQuery = isTemplateQuery ? model.V : model.U;
		var sortField = isTemplateQuery ? model.au : model.as;
		var sortOrder = isTemplateQuery ? model.X : model.am;
		var getSuggested = A2($elm$core$Set$member, 'Suggested', model.B);
		var delay = model.O === 2;
		var categoryQuery = _Utils_ap(
			A2($author$project$Main$setupCategoryQuery, model.x, model.D),
			A2($elm$core$Set$member, 'New', model.B) ? _List_fromArray(
				['/Categories/New Release']) : _List_Nil);
		var baseQuery = function () {
			if (isTemplateQuery) {
				return model.T ? '' : '(typekeywords:Solution,Template)';
			} else {
				var classicSolutionsSubquery = '(typekeywords:Solution,Deployed)';
				var classicSolutionsCreateSubquery = '(created:[1577862000000 TO 1622576880000])';
				var brandedSolutionsSubquery = '(typekeywords:Solution,Deployed,\'ArcGIS Solution\')';
				return '(' + (brandedSolutionsSubquery + (' OR (' + (classicSolutionsSubquery + (' AND ' + (classicSolutionsCreateSubquery + '))')))));
			}
		}();
		var q = $elm$json$Json$Encode$string(
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[baseQuery, searchQuery])));
		var resultObject = isTemplateQuery ? _List_fromArray(
			[
				_Utils_Tuple2('q', q),
				_Utils_Tuple2(
				'filter',
				$elm$json$Json$Encode$string('type:Solution')),
				_Utils_Tuple2(
				'sortField',
				$elm$json$Json$Encode$string(sortField)),
				_Utils_Tuple2(
				'sortOrder',
				$elm$json$Json$Encode$string(sortOrder)),
				_Utils_Tuple2(
				'nextStart',
				$elm$json$Json$Encode$int(model.i.bc)),
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, categoryQuery)),
				_Utils_Tuple2(
				'delay',
				$elm$json$Json$Encode$bool(delay)),
				_Utils_Tuple2(
				'getSuggested',
				$elm$json$Json$Encode$bool(getSuggested))
			]) : _List_fromArray(
			[
				_Utils_Tuple2('q', q),
				_Utils_Tuple2(
				'filter',
				$elm$json$Json$Encode$string('type:Solution')),
				_Utils_Tuple2(
				'sortField',
				$elm$json$Json$Encode$string(sortField)),
				_Utils_Tuple2(
				'sortOrder',
				$elm$json$Json$Encode$string(sortOrder)),
				_Utils_Tuple2(
				'delay',
				$elm$json$Json$Encode$bool(delay))
			]);
		return $elm$json$Json$Encode$object(resultObject);
	});
var $author$project$Main$askJSForAvailableSolutions = function (model) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(4),
			A2($author$project$Main$queryEncoder, model, 'Template'),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJSForDeployedSolutions = function (model) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(6),
			A2($author$project$Main$queryEncoder, model, 'Deployed'),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJSForMaxHeights = $author$project$Main$askJSLibrary(
	A3(
		$author$project$Main$packageRequest,
		$author$project$Main$interopCommand.g(39),
		$elm$json$Json$Encode$null,
		$elm$json$Json$Encode$null));
var $author$project$Main$askJSForSelectedSolution = function (solutionID) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(8),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'q',
						$elm$json$Json$Encode$string('typekeywords: Solution, solutionid-' + (solutionID + ' AND ((typekeywords: Template) OR (typekeywords: Display Only))'))),
						_Utils_Tuple2(
						'sortField',
						$elm$json$Json$Encode$string('')),
						_Utils_Tuple2(
						'sortOrder',
						$elm$json$Json$Encode$string(''))
					])),
			$elm$json$Json$Encode$string(solutionID)));
};
var $author$project$Main$askJSForUUID = $author$project$Main$askJSLibrary(
	A3(
		$author$project$Main$packageRequest,
		$author$project$Main$interopCommand.g(40),
		$elm$json$Json$Encode$null,
		$elm$json$Json$Encode$null));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $ChristophP$elm_i18next$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$Translations$Filters$IndustriesValues$aec = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.aec');
};
var $author$project$Translations$Filters$DomainsValues$agriculture = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.agriculture');
};
var $author$project$Translations$Filters$DomainsValues$airport = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.airport');
};
var $author$project$Translations$Filters$IndustriesValues$airportPortRail = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.airportPortRail');
};
var $author$project$Translations$Filters$DomainsValues$assessmentAndTaxation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.assessmentAndTaxation');
};
var $author$project$Translations$Filters$IndustriesValues$business = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.business');
};
var $author$project$Translations$Filters$IndustriesValues$conservation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.conservation');
};
var $author$project$Translations$Filters$IndustriesValues$defense = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.defense');
};
var $author$project$Translations$Filters$DomainsValues$districtEnergy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.districtEnergy');
};
var $author$project$Translations$Filters$DomainsValues$elections = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.elections');
};
var $author$project$Translations$Filters$DomainsValues$electric = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.electric');
};
var $author$project$Translations$Filters$DomainsValues$emergencyManagement = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.emergencyManagement');
};
var $author$project$Translations$Filters$DomainsValues$environmentAndNaturalResources = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.environmentAndNaturalResources');
};
var $author$project$Translations$Filters$IndustriesValues$facilities = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.facilities');
};
var $author$project$Translations$Filters$DomainsValues$fireService = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.fireService');
};
var $author$project$Translations$Filters$DomainsValues$fishAndWildlife = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.fishAndWildlife');
};
var $author$project$Translations$Filters$DomainsValues$gas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.gas');
};
var $author$project$Translations$Filters$DomainsValues$healthAndHumanServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.healthAndHumanServices');
};
var $author$project$Translations$Filters$DomainsValues$lawEnforcement = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.lawEnforcement');
};
var $author$project$Translations$Filters$DomainsValues$naturalResources = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.naturalResources');
};
var $author$project$Translations$Filters$newFilterValue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.newFilterValue');
};
var $author$project$Translations$Filters$DomainsValues$parks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.parks');
};
var $author$project$Translations$Filters$IndustriesValues$pipeline = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.pipeline');
};
var $author$project$Translations$Filters$DomainsValues$planningAndDevelopment = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.planningAndDevelopment');
};
var $author$project$Translations$Filters$DomainsValues$protectedAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.protectedAreas');
};
var $author$project$Translations$Filters$IndustriesValues$publicSafety = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.publicSafety');
};
var $author$project$Translations$Filters$DomainsValues$publicWorks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.publicWorks');
};
var $author$project$Translations$Filters$IndustriesValues$renewables = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.renewables');
};
var $author$project$Translations$Filters$DomainsValues$sewer = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.sewer');
};
var $author$project$Translations$Filters$IndustriesValues$stateAndLocalGovernment = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.stateAndLocalGovernment');
};
var $author$project$Translations$Filters$DomainsValues$stormwater = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.stormwater');
};
var $author$project$Translations$Filters$suggestedFilterValue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.suggestedFilterValue');
};
var $author$project$Translations$Filters$DomainsValues$telecommunications = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.telecommunications');
};
var $author$project$Translations$Filters$DomainsValues$transportation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.transportation');
};
var $author$project$Translations$Filters$IndustriesValues$utilities = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesValues.utilities');
};
var $author$project$Translations$Filters$DomainsValues$water = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainsValues.water');
};
var $author$project$Main$getFilterValueDisplay = F2(
	function (translations, tag) {
		switch (tag) {
			case 'AEC':
				return $author$project$Translations$Filters$IndustriesValues$aec(translations);
			case 'Airports, Ports, and Rails':
				return $author$project$Translations$Filters$IndustriesValues$airportPortRail(translations);
			case 'Business':
				return $author$project$Translations$Filters$IndustriesValues$business(translations);
			case 'Conservation':
				return $author$project$Translations$Filters$IndustriesValues$conservation(translations);
			case 'Defense':
				return $author$project$Translations$Filters$IndustriesValues$defense(translations);
			case 'Facilities':
				return $author$project$Translations$Filters$IndustriesValues$facilities(translations);
			case 'Pipeline':
				return $author$project$Translations$Filters$IndustriesValues$pipeline(translations);
			case 'Public Safety':
				return $author$project$Translations$Filters$IndustriesValues$publicSafety(translations);
			case 'Renewables':
				return $author$project$Translations$Filters$IndustriesValues$renewables(translations);
			case 'State and Local Government':
				return $author$project$Translations$Filters$IndustriesValues$stateAndLocalGovernment(translations);
			case 'Utilities':
				return $author$project$Translations$Filters$IndustriesValues$utilities(translations);
			case 'Airports':
				return $author$project$Translations$Filters$DomainsValues$airport(translations);
			case 'Agriculture':
				return $author$project$Translations$Filters$DomainsValues$agriculture(translations);
			case 'Assessment and Taxation':
				return $author$project$Translations$Filters$DomainsValues$assessmentAndTaxation(translations);
			case 'District Energy':
				return $author$project$Translations$Filters$DomainsValues$districtEnergy(translations);
			case 'Elections':
				return $author$project$Translations$Filters$DomainsValues$elections(translations);
			case 'Electric':
				return $author$project$Translations$Filters$DomainsValues$electric(translations);
			case 'Emergency Management':
				return $author$project$Translations$Filters$DomainsValues$emergencyManagement(translations);
			case 'Environment and Natural Resources':
				return $author$project$Translations$Filters$DomainsValues$environmentAndNaturalResources(translations);
			case 'Fire Service':
				return $author$project$Translations$Filters$DomainsValues$fireService(translations);
			case 'Fish and Wildlife':
				return $author$project$Translations$Filters$DomainsValues$fishAndWildlife(translations);
			case 'Gas':
				return $author$project$Translations$Filters$DomainsValues$gas(translations);
			case 'Health and Human Services':
				return $author$project$Translations$Filters$DomainsValues$healthAndHumanServices(translations);
			case 'Law Enforcement':
				return $author$project$Translations$Filters$DomainsValues$lawEnforcement(translations);
			case 'Natural Resources':
				return $author$project$Translations$Filters$DomainsValues$naturalResources(translations);
			case 'Parks':
				return $author$project$Translations$Filters$DomainsValues$parks(translations);
			case 'Planning and Development':
				return $author$project$Translations$Filters$DomainsValues$planningAndDevelopment(translations);
			case 'Protected Areas':
				return $author$project$Translations$Filters$DomainsValues$protectedAreas(translations);
			case 'Public Works':
				return $author$project$Translations$Filters$DomainsValues$publicWorks(translations);
			case 'Sewer':
				return $author$project$Translations$Filters$DomainsValues$sewer(translations);
			case 'Stormwater':
				return $author$project$Translations$Filters$DomainsValues$stormwater(translations);
			case 'Telecommunications':
				return $author$project$Translations$Filters$DomainsValues$telecommunications(translations);
			case 'Transportation':
				return $author$project$Translations$Filters$DomainsValues$transportation(translations);
			case 'Water Distribution':
				return $author$project$Translations$Filters$DomainsValues$water(translations);
			case 'New':
				return $author$project$Translations$Filters$newFilterValue(translations);
			case 'Suggested':
				return $author$project$Translations$Filters$suggestedFilterValue(translations);
			default:
				return '';
		}
	});
var $author$project$Main$filterEncoder = function (model) {
	var industry = function () {
		var _v2 = $elm$core$Set$toList(model.D);
		if (!_v2.b) {
			return '';
		} else {
			if (!_v2.b.b) {
				var oneIndustry = _v2.a;
				return A2($author$project$Main$getFilterValueDisplay, model.n, oneIndustry);
			} else {
				var _v3 = _v2.b;
				return '';
			}
		}
	}();
	var domain = function () {
		var _v0 = $elm$core$Set$toList(model.x);
		if (!_v0.b) {
			return '';
		} else {
			if (!_v0.b.b) {
				var oneDomain = _v0.a;
				return A2($author$project$Main$getFilterValueDisplay, model.n, oneDomain);
			} else {
				var _v1 = _v0.b;
				return '';
			}
		}
	}();
	var filter = (domain === '') ? industry : domain;
	var filterDisplay = (filter === '') ? 'ArcGIS Solutions' : (model.aE ? (filter + ' - ArcGIS Solutions') : ('ArcGIS Solutions - ' + filter));
	return $elm$json$Json$Encode$string(filterDisplay);
};
var $elm$url$Url$Builder$Relative = {$: 1};
var $elm$url$Url$Builder$rootToPrePath = function (root) {
	switch (root.$) {
		case 0:
			return '/';
		case 1:
			return '';
		default:
			var prePath = root.a;
			return prePath + '/';
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$custom = F4(
	function (root, pathSegments, parameters, maybeFragment) {
		var fragmentless = _Utils_ap(
			$elm$url$Url$Builder$rootToPrePath(root),
			_Utils_ap(
				A2($elm$core$String$join, '/', pathSegments),
				$elm$url$Url$Builder$toQuery(parameters)));
		if (maybeFragment.$ === 1) {
			return fragmentless;
		} else {
			var fragment = maybeFragment.a;
			return fragmentless + ('#' + fragment);
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Main$tab = $Herteby$enum$Enum$create(
	_List_fromArray(
		[
			_Utils_Tuple2('home', 0),
			_Utils_Tuple2('solutions', 1)
		]));
var $author$project$Main$urlEncoder = function (model) {
	var testing = model.aX ? _Utils_Tuple2('testing', 'true') : _Utils_Tuple2('testing', '');
	var sortOrder = (!model.e) ? _Utils_Tuple2('sortOrder', model.X) : _Utils_Tuple2('sortOrder', model.am);
	var sortField = (!model.e) ? _Utils_Tuple2('sortField', model.au) : _Utils_Tuple2('sortField', model.as);
	var solution = function () {
		var tag = model.u ? 'deploy' : 'solution';
		return _Utils_Tuple2(tag, model.b.a6);
	}();
	var searchTerm = (!model.e) ? _Utils_Tuple2('searchTerm', model.V) : _Utils_Tuple2('searchTerm', model.U);
	var locale = (model.aH === '') ? _Utils_Tuple2('locale', '') : _Utils_Tuple2('locale', model.aH);
	var industry = function () {
		var _v6 = $elm$core$Set$toList(model.D);
		if (!_v6.b) {
			return _Utils_Tuple2('industry', '');
		} else {
			if (!_v6.b.b) {
				var oneIndustry = _v6.a;
				return _Utils_Tuple2('industry', oneIndustry);
			} else {
				var _v7 = _v6.b;
				return _Utils_Tuple2('industry', '');
			}
		}
	}();
	var gallery = model.T ? _Utils_Tuple2('gallery', 'true') : _Utils_Tuple2('gallery', '');
	var filterType = function () {
		var _v4 = $elm$core$Set$toList(model.B);
		if (!_v4.b) {
			return _Utils_Tuple2('type', '');
		} else {
			if (!_v4.b.b) {
				var oneType = _v4.a;
				return _Utils_Tuple2('type', oneType);
			} else {
				var _v5 = _v4.b;
				return _Utils_Tuple2(
					'type',
					A2(
						$elm$core$String$join,
						',',
						$elm$core$Set$toList(model.B)));
			}
		}
	}();
	var domain = function () {
		var _v2 = $elm$core$Set$toList(model.x);
		if (!_v2.b) {
			return _Utils_Tuple2('domain', '');
		} else {
			if (!_v2.b.b) {
				var oneDomain = _v2.a;
				return _Utils_Tuple2('domain', oneDomain);
			} else {
				var _v3 = _v2.b;
				return _Utils_Tuple2('domain', '');
			}
		}
	}();
	var updateDict = (!model.e) ? $elm$core$Dict$fromList(
		_List_fromArray(
			[sortField, sortOrder, filterType, industry, domain, solution, searchTerm, locale, gallery, testing])) : $elm$core$Dict$fromList(
		_List_fromArray(
			[sortField, sortOrder, searchTerm, locale, gallery, testing]));
	var updateDictFilter = A2(
		$elm$core$Dict$filter,
		F2(
			function (_v1, v) {
				return v !== '';
			}),
		updateDict);
	var urlParamsList = A2(
		$elm$core$List$map,
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return A2($elm$url$Url$Builder$string, k, v);
		},
		$elm$core$Dict$toList(updateDictFilter));
	return $elm$json$Json$Encode$string(
		A4(
			$elm$url$Url$Builder$custom,
			$elm$url$Url$Builder$Relative,
			_List_Nil,
			urlParamsList,
			$elm$core$Maybe$Just(
				$author$project$Main$tab.g(model.e))));
};
var $author$project$Main$askJSToChangeUrl = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Main$askJSLibrary(
				A3(
					$author$project$Main$packageRequest,
					$author$project$Main$interopCommand.g(16),
					$author$project$Main$urlEncoder(model),
					$elm$json$Json$Encode$null)),
				$author$project$Main$askJSLibrary(
				A3(
					$author$project$Main$packageRequest,
					$author$project$Main$interopCommand.g(17),
					$author$project$Main$filterEncoder(model),
					$elm$json$Json$Encode$null))
			]));
};
var $author$project$Main$askJSToCloseAlert = function (alertName) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(25),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(alertName))
					])),
			$elm$json$Json$Encode$null));
};
var $author$project$Card$encode = function (card) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(card.aa)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(card.G)),
				_Utils_Tuple2(
				'snippet',
				$elm$json$Json$Encode$string(card.aW)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(card.bM)),
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(card.cb)),
				_Utils_Tuple2(
				'itemUrl',
				$elm$json$Json$Encode$string(card.aq)),
				_Utils_Tuple2(
				'thumbnailUrl',
				$elm$json$Json$Encode$string(card.aj)),
				_Utils_Tuple2(
				'tryitUrl',
				$elm$json$Json$Encode$string(card.b9)),
				_Utils_Tuple2(
				'typeKeywords',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, card.ca)),
				_Utils_Tuple2(
				'learnMoreUrl',
				$elm$json$Json$Encode$string(card.bV)),
				_Utils_Tuple2(
				'createdMs',
				$elm$json$Json$Encode$int(card.bK)),
				_Utils_Tuple2(
				'created',
				$elm$json$Json$Encode$string(card.bi)),
				_Utils_Tuple2(
				'modified',
				$elm$json$Json$Encode$string(card.bt)),
				_Utils_Tuple2(
				'numViews',
				$elm$json$Json$Encode$int(card.b$)),
				_Utils_Tuple2(
				'tags',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, card.b7)),
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, card.aP)),
				_Utils_Tuple2(
				'licenseInfo',
				$elm$json$Json$Encode$string(card.bW)),
				_Utils_Tuple2(
				'deployCommonId',
				$elm$json$Json$Encode$string(card.a6)),
				_Utils_Tuple2(
				'deployVersion',
				$elm$json$Json$Encode$string(card.bl)),
				_Utils_Tuple2(
				'canDelete',
				$elm$json$Json$Encode$bool(card.bh)),
				_Utils_Tuple2(
				'canDeploy',
				$elm$json$Json$Encode$bool(card.bJ)),
				_Utils_Tuple2(
				'sourcePortalUrl',
				$elm$json$Json$Encode$string(card.b4)),
				_Utils_Tuple2(
				'waitId',
				$elm$json$Json$Encode$string(card.cc)),
				_Utils_Tuple2(
				'knownToBePublicSource',
				$elm$json$Json$Encode$bool(card.bq))
			]));
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Main$encodeUserProp = function (record) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'prop',
				$elm$json$Json$Encode$string(record.e5)),
				_Utils_Tuple2(
				'default',
				$elm$json$Json$Encode$string(record.ef)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(record.fv)),
				_Utils_Tuple2(
				'responseValue',
				$elm$json$Json$Encode$string(record.e9)),
				_Utils_Tuple2(
				'outType',
				$elm$json$Json$Encode$string(record.eY)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(record.aa)),
				_Utils_Tuple2(
				'itemType',
				$elm$json$Json$Encode$string(record.cQ)),
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(record.eB)),
				_Utils_Tuple2(
				'valueType',
				$elm$json$Json$Encode$string(record.fw)),
				_Utils_Tuple2(
				'srSearchText',
				$elm$json$Json$Encode$string(record.ff)),
				_Utils_Tuple2(
				'autoSelect',
				$elm$json$Json$Encode$bool(record.d_)),
				_Utils_Tuple2(
				'valid',
				$elm$json$Json$Encode$bool(record.fs)),
				_Utils_Tuple2(
				'validId',
				$elm$json$Json$Encode$bool(record.ft)),
				_Utils_Tuple2(
				'choices',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, record.d9)),
				_Utils_Tuple2(
				'attributes',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, record.dZ)),
				_Utils_Tuple2(
				'validation',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, record.fu)),
				_Utils_Tuple2(
				'loading',
				$elm$json$Json$Encode$bool(record.eE)),
				_Utils_Tuple2(
				'tooltip',
				$elm$json$Json$Encode$string(record.fn)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(record.cX)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(record.G)),
				_Utils_Tuple2(
				'itemUrl',
				$elm$json$Json$Encode$string(record.aq))
			]));
};
var $author$project$Main$encodeUserOption = function (record) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(record.aa)),
				_Utils_Tuple2(
				'props',
				A2($elm$json$Json$Encode$list, $author$project$Main$encodeUserProp, record.e6)),
				_Utils_Tuple2(
				'accordionDisplay',
				$elm$json$Json$Encode$bool(record.dV))
			]));
};
var $author$project$Main$askJSToDeploySolution = F3(
	function (card, reuseItemsOption, jobId) {
		var userOptions = card.dL.dO;
		return $author$project$Main$askJSLibrary(
			A3(
				$author$project$Main$packageRequest,
				$author$project$Main$interopCommand.g(10),
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'card',
							$author$project$Card$encode(card)),
							_Utils_Tuple2(
							'reuse',
							$elm$json$Json$Encode$bool(reuseItemsOption)),
							_Utils_Tuple2(
							'jobId',
							$elm$json$Json$Encode$string(jobId)),
							_Utils_Tuple2(
							'userOptions',
							A2($elm$json$Json$Encode$list, $author$project$Main$encodeUserOption, userOptions))
						])),
				$elm$json$Json$Encode$null));
	});
var $author$project$Main$askJSToDeploySolutionAtLaunch = function (card) {
	var userOptions = card.dL.dO;
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(11),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'card',
						$author$project$Card$encode(card))
					])),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJSToGenerateShareLinkForSoln = $author$project$Main$askJSLibrary(
	A3(
		$author$project$Main$packageRequest,
		$author$project$Main$interopCommand.g(9),
		$elm$json$Json$Encode$null,
		$elm$json$Json$Encode$null));
var $author$project$Main$askJSToSetCookie = F3(
	function (name, value, maxAge) {
		return $author$project$Main$askJSLibrary(
			A3(
				$author$project$Main$packageRequest,
				$author$project$Main$interopCommand.g(26),
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(value)),
							_Utils_Tuple2(
							'maxAge',
							$elm$json$Json$Encode$int(maxAge))
						])),
				$elm$json$Json$Encode$null));
	});
var $author$project$Main$askJSToSetNavTab = function (navTab) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(15),
			$elm$json$Json$Encode$string(
				$author$project$Main$tab.g(navTab)),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJSToTriggerMeteredScroll = $author$project$Main$askJSLibrary(
	A3($author$project$Main$packageRequest, 'IOPCmdToTriggerMeteredScroll', $elm$json$Json$Encode$null, $elm$json$Json$Encode$null));
var $author$project$Main$askJSToValidateID = F2(
	function (card, userProp) {
		return $author$project$Main$askJSLibrary(
			A3(
				$author$project$Main$packageRequest,
				$author$project$Main$interopCommand.g(13),
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'card',
							$author$project$Card$encode(card)),
							_Utils_Tuple2(
							'userProp',
							$author$project$Main$encodeUserProp(userProp))
						])),
				$elm$json$Json$Encode$null));
	});
var $author$project$Main$askJsForColor = function (id) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(31),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id))
					])),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToCloseModal = function (closeType) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(30),
			$elm$json$Json$Encode$string(closeType),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToDeleteSolution = function (card) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(29),
			$author$project$Card$encode(card),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToOpenCardModal = function (card) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(18),
			$author$project$Card$encode(card),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToOpenDeleteCardModal = function (card) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(20),
			$author$project$Card$encode(card),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToOpenDiagramModal = function (card) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(21),
			$author$project$Card$encode(card),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToOpenFilterModal = $author$project$Main$askJSLibrary(
	A3(
		$author$project$Main$packageRequest,
		$author$project$Main$interopCommand.g(22),
		$elm$json$Json$Encode$null,
		$elm$json$Json$Encode$null));
var $author$project$Main$askJsToOpenLink = function (link) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(23),
			$elm$json$Json$Encode$string(link),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToPopulateDiagramModal = function (card) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(24),
			$author$project$Card$encode(card),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToTriggerBlur = F2(
	function (cardId, value) {
		return $author$project$Main$askJSLibrary(
			A3(
				$author$project$Main$packageRequest,
				$author$project$Main$interopCommand.g(28),
				$elm$json$Json$Encode$string(cardId),
				value));
	});
var $author$project$Main$askJsToTriggerFocus = function (cardId) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(27),
			$elm$json$Json$Encode$string(cardId),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToUpdateModal = F2(
	function (card, infoMode) {
		return $author$project$Main$askJSLibrary(
			A3(
				$author$project$Main$packageRequest,
				$author$project$Main$interopCommand.g(32),
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'card',
							$author$project$Card$encode(card)),
							_Utils_Tuple2(
							'infoMode',
							$elm$json$Json$Encode$string(infoMode))
						])),
				$elm$json$Json$Encode$null));
	});
var $author$project$Main$askJsToUpdateUrlSearch = function (model) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(33),
			$author$project$Main$urlEncoder(model),
			$elm$json$Json$Encode$null));
};
var $author$project$Main$askJsToUpdateVisibleOptions = function (index) {
	return $author$project$Main$askJSLibrary(
		A3(
			$author$project$Main$packageRequest,
			$author$project$Main$interopCommand.g(34),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'index',
						$elm$json$Json$Encode$int(index))
					])),
			$elm$json$Json$Encode$null));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Main$setDeployPercentage = F2(
	function (progress, card) {
		return _Utils_update(
			card,
			{
				a7: A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, progress, 100))
			});
	});
var $author$project$Main$cardUpdatePercentage = F2(
	function (percentage, card) {
		return A2(
			$elm$core$Maybe$andThen,
			function (goodCard) {
				return $elm$core$Maybe$Just(
					A2($author$project$Main$setDeployPercentage, percentage, goodCard));
			},
			card);
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{v: nodeList, p: nodeListSize, s: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ev: index, eF: match, eS: number, fg: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{d5: false, eJ: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Main$isValidFormat = F2(
	function (userProp, v) {
		var isItemId = $elm$core$String$toLower(userProp.fw) === 'itemid';
		var expression = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, 'expression', userProp.fu));
		var maybeRegex = isItemId ? A2(
			$elm$regex$Regex$fromStringWith,
			{d5: true, eJ: false},
			expression) : $elm$regex$Regex$fromString(expression);
		var regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, maybeRegex);
		var valid = (expression === '') ? true : A2($elm$regex$Regex$contains, regex, v);
		return valid;
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Main$checkOptions = F2(
	function (userOptions, userOptionsIndex) {
		var optionArray = $elm$core$Array$fromList(userOptions);
		var emptyOpt = {dV: false, aa: '', e6: _List_Nil};
		var currentOption = A2(
			$elm$core$Maybe$withDefault,
			emptyOpt,
			A2($elm$core$Array$get, userOptionsIndex, optionArray));
		var invalidOptions = A2(
			$elm$core$List$filter,
			function (p) {
				return ((p.fw === 'itemid') && (p.fv === '')) ? false : ((p.fw === 'itemid') ? ((!p.ft) || (!A2($author$project$Main$isValidFormat, p, p.fv))) : (!p.fs));
			},
			currentOption.e6);
		var optionsValid = !$elm$core$List$length(invalidOptions);
		return optionsValid;
	});
var $author$project$Main$cookieMaxAge = 31536000;
var $author$project$Main$decodeBool = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$bool, value);
	if (!_v0.$) {
		var booleanValue = _v0.a;
		return booleanValue;
	} else {
		return false;
	}
};
var $author$project$Main$decodeString = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	if (!_v0.$) {
		var stringValue = _v0.a;
		return stringValue;
	} else {
		return '';
	}
};
var $author$project$Main$emptyUserProp = {dZ: $elm$core$Dict$empty, d_: false, d9: _List_Nil, ef: '', aa: '', cQ: '', aq: '', eB: '', eE: false, cX: '', eY: '', e5: '', e9: '', ff: '', G: '', fn: '', fs: false, ft: true, fu: $elm$core$Dict$empty, fv: '', fw: ''};
var $author$project$Main$UserProp = function (autoSelect) {
	return function (id) {
		return function (itemType) {
			return function (label) {
				return function (prop) {
					return function (_default) {
						return function (value) {
							return function (responseValue) {
								return function (choices) {
									return function (valueType) {
										return function (attributes) {
											return function (validation) {
												return function (valid) {
													return function (validId) {
														return function (srSearchText) {
															return function (outType) {
																return function (loading) {
																	return function (tooltip) {
																		return function (name) {
																			return function (title) {
																				return function (itemUrl) {
																					return {dZ: attributes, d_: autoSelect, d9: choices, ef: _default, aa: id, cQ: itemType, aq: itemUrl, eB: label, eE: loading, cX: name, eY: outType, e5: prop, e9: responseValue, ff: srSearchText, G: title, fn: tooltip, fs: valid, ft: validId, fu: validation, fv: value, fw: valueType};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$propDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'itemUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tooltip',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'loading',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'outType',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'srSearchText',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'validId',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'valid',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'validation',
										$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'attributes',
											$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'valueType',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'choices',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'responseValue',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'value',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'default',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'prop',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'label',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'itemType',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'id',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'autoSelect',
																					$elm$json$Json$Decode$bool,
																					$elm$json$Json$Decode$succeed($author$project$Main$UserProp))))))))))))))))))))));
var $author$project$Main$decodeUserProp = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$propDecoder, value);
	if (!_v0.$) {
		var userProp = _v0.a;
		return userProp;
	} else {
		return $author$project$Main$emptyUserProp;
	}
};
var $author$project$Main$DeployInfo = F2(
	function (card, jobId) {
		return {t: card, E: jobId};
	});
var $author$project$Main$deployedDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Main$DeployInfo,
	A2($elm$json$Json$Decode$field, 'card', $author$project$Card$decoder),
	A2($elm$json$Json$Decode$field, 'jobId', $elm$json$Json$Decode$string));
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $author$project$Main$filterSetup = function (tag) {
	return (tag === 'None') ? $elm$core$Set$empty : $elm$core$Set$fromList(
		_List_fromArray(
			[tag]));
};
var $author$project$Main$filtersSetup = function (tags) {
	return $elm$core$Set$fromList(tags);
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Main$getCardCatalog = function (cards) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (card, accum) {
				var updatedAccum = A2($elm$core$Dict$member, card.aa, accum) ? accum : A3($elm$core$Dict$insert, card.aa, card, accum);
				return updatedAccum;
			}),
		$elm$core$Dict$empty,
		cards);
};
var $author$project$Main$getCardsFromPacketData = function (jsPacket) {
	var decodeAttempt = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$list($author$project$Card$decoder),
		jsPacket.l);
	var decoded = function () {
		if (!decodeAttempt.$) {
			var goodItem = decodeAttempt.a;
			return goodItem;
		} else {
			return _List_Nil;
		}
	}();
	return decoded;
};
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$intersect, dict1, dict2);
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Main$getDependentJobId = F2(
	function (candidateCard, deployingCards) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, accum) {
					var jobId = _v0.a;
					var deployingCard = _v0.b;
					var updatedString = _Utils_eq(candidateCard.a6, deployingCard.a6) ? accum : (($elm$core$Set$size(
						A2($elm$core$Set$intersect, candidateCard.dL.cJ, deployingCard.dL.cJ)) > 0) ? jobId : accum);
					return updatedString;
				}),
			'',
			$elm$core$Dict$toList(deployingCards));
	});
var $author$project$Main$createSemVerList = function (semVer) {
	var semVerList = A2($elm$core$String$split, '.', semVer);
	if (!semVerList.b) {
		return _List_fromArray(
			[0, 0, 0]);
	} else {
		if (!semVerList.b.b) {
			var mj = semVerList.a;
			return _List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(mj)),
					0,
					0
				]);
		} else {
			if (!semVerList.b.b.b) {
				var mj = semVerList.a;
				var _v1 = semVerList.b;
				var mn = _v1.a;
				return _List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(mj)),
						A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(mn)),
						0
					]);
			} else {
				if (!semVerList.b.b.b.b) {
					var mj = semVerList.a;
					var _v2 = semVerList.b;
					var mn = _v2.a;
					var _v3 = _v2.b;
					var pt = _v3.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mj)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mn)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(pt))
						]);
				} else {
					var mj = semVerList.a;
					var _v4 = semVerList.b;
					var mn = _v4.a;
					var _v5 = _v4.b;
					var pt = _v5.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mj)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mn)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(pt))
						]);
				}
			}
		}
	}
};
var $author$project$Main$getDeployedSeriesMostRecent = function (cards) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (card, accum) {
				var updatedAccum = A2($elm$core$Dict$member, card.a6, accum) ? ((_Utils_cmp(
					$author$project$Main$createSemVerList(
						A2(
							$elm$core$Maybe$withDefault,
							'0.0.0',
							A2($elm$core$Dict$get, card.a6, accum))),
					$author$project$Main$createSemVerList(card.bl)) < 0) ? A3($elm$core$Dict$insert, card.a6, card.bl, accum) : accum) : A3($elm$core$Dict$insert, card.a6, card.bl, accum);
				return updatedAccum;
			}),
		$elm$core$Dict$empty,
		cards);
};
var $author$project$Main$getErrorMessageFromPacketData = function (jsPacket) {
	return $author$project$Main$decodeString(jsPacket.l);
};
var $author$project$Main$OptionalData = F4(
	function (start, num, nextStart, total) {
		return {bc: nextStart, bu: num, bC: start, aY: total};
	});
var $author$project$Main$optionalDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nextStart',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'num',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Main$OptionalData)))));
var $author$project$Main$getOptionalDataFromPacketData = function (jsPacket) {
	var decodeAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$optionalDataDecoder, jsPacket.i);
	var decoded = function () {
		if (!decodeAttempt.$) {
			var goodItem = decodeAttempt.a;
			return goodItem;
		} else {
			return $author$project$Main$defaultPaging;
		}
	}();
	return decoded;
};
var $author$project$Main$PartialItem = F4(
	function (itemName, itemType, owner, modified) {
		return {ez: itemName, cQ: itemType, bt: modified, eZ: owner};
	});
var $author$project$Main$partialItemDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Main$PartialItem,
	A2($elm$json$Json$Decode$field, 'itemName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'itemType', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'owner', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'modified', $elm$json$Json$Decode$string));
var $author$project$Main$getRelatedItemsFromPacketData = function (jsPacket) {
	var decodeAttempt = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$list($author$project$Main$partialItemDecoder),
		jsPacket.l);
	var decoded = function () {
		if (!decodeAttempt.$) {
			var goodItem = decodeAttempt.a;
			return goodItem;
		} else {
			return _List_Nil;
		}
	}();
	return decoded;
};
var $author$project$Main$getRelatedSolutionsSwitchFromPacketData = function (jsPacket) {
	var decodeAttempt = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$bool, jsPacket.i);
	var decoded = function () {
		if (!decodeAttempt.$) {
			var goodItem = decodeAttempt.a;
			return goodItem;
		} else {
			return false;
		}
	}();
	return decoded;
};
var $author$project$Main$getWaitingKey = F3(
	function (model, jobId, dependentJobId) {
		var dependentCardKeys2 = (dependentJobId !== '') ? A2(
			$elm$core$List$filter,
			$elm$core$String$contains(dependentJobId),
			$elm$core$Dict$keys(model.I)) : _List_Nil;
		var dependentDeployWaiting2 = $elm$core$List$length(dependentCardKeys2) > 0;
		var dependentCardKeys = A2(
			$elm$core$List$filter,
			$elm$core$String$startsWith(jobId),
			$elm$core$Dict$keys(model.I));
		var dependentDeployWaiting = $elm$core$List$length(dependentCardKeys) > 0;
		var waitingKey = dependentDeployWaiting ? A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(dependentCardKeys)) : (dependentDeployWaiting2 ? A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(dependentCardKeys2)) : '');
		return waitingKey;
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Main$Page = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h, i: i, j: j, k: k, l: l};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aC: frag, aI: params, ax: unvisited, fv: value, aN: visited};
	});
var $elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_v0) {
		var visited = _v0.aN;
		var unvisited = _v0.ax;
		var params = _v0.aI;
		var frag = _v0.aC;
		var value = _v0.fv;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aN;
		var unvisited = _v0.ax;
		var params = _v0.aI;
		var frag = _v0.aC;
		var value = _v0.fv;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aN;
			var unvisited = _v1.ax;
			var params = _v1.aI;
			var frag = _v1.aC;
			var value = _v1.fv;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.aN;
		var unvisited = _v1.ax;
		var params = _v1.aI;
		var frag = _v1.aC;
		var value = _v1.fv;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Main$myParser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Main$Page,
	A2(
		$elm$url$Url$Parser$questionMark,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											A2(
												$elm$url$Url$Parser$questionMark,
												$elm$url$Url$Parser$fragment($elm$core$Basics$identity),
												$elm$url$Url$Parser$Query$string('sortField')),
											$elm$url$Url$Parser$Query$string('sortOrder')),
										$elm$url$Url$Parser$Query$string('type')),
									$elm$url$Url$Parser$Query$string('industry')),
								$elm$url$Url$Parser$Query$string('domain')),
							$elm$url$Url$Parser$Query$string('searchTerm')),
						$elm$url$Url$Parser$Query$string('solution')),
					$elm$url$Url$Parser$Query$string('deploy')),
				$elm$url$Url$Parser$Query$string('locale')),
			$elm$url$Url$Parser$Query$string('gallery')),
		$elm$url$Url$Parser$Query$string('testing')));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ax;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.fv);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.fv);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.e0),
					$elm$url$Url$Parser$prepareQuery(url.dp),
					url.cA,
					$elm$core$Basics$identity)));
	});
var $author$project$Main$locationHrefToRoute = function (locationHref) {
	return A2(
		$elm$core$Maybe$andThen,
		function (url) {
			return A2(
				$elm$url$Url$Parser$parse,
				$author$project$Main$myParser,
				_Utils_update(
					url,
					{e0: ''}));
		},
		$elm$url$Url$fromString(locationHref));
};
var $author$project$Main$HeightInfo = F2(
	function (cards, filters) {
		return {a3: cards, cy: filters};
	});
var $author$project$Main$maxHeightsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Main$HeightInfo,
	A2($elm$json$Json$Decode$field, 'cards', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'filters', $elm$json$Json$Decode$int));
var $author$project$Main$maxHeightsResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$maxHeightsDecoder, value);
	if (!_v0.$) {
		var maxHeights = _v0.a;
		return maxHeights;
	} else {
		return $author$project$Main$defaultHeightInfo;
	}
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Main$parseInteropCommand = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Main$interopCommand.cC(value));
};
var $author$project$Main$Progress = F2(
	function (id, percentage) {
		return {aa: id, dd: percentage};
	});
var $author$project$Main$progressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'percentage',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Main$Progress)));
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Main$resetUserOptions = function (card) {
	var templateInfo = card.dL;
	var options = A2(
		$elm$core$List$map,
		function (opt) {
			return _Utils_update(
				opt,
				{
					e6: A2(
						$elm$core$List$map,
						function (p) {
							var requiredSet = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, 'required', p.dZ));
							var defaultValue = p.ef;
							var valid = (requiredSet === 'true') ? A2($author$project$Main$isValidFormat, p, defaultValue) : true;
							var autoSelect = defaultValue !== '';
							return _Utils_update(
								p,
								{d_: autoSelect, ff: defaultValue, fs: valid, fv: defaultValue});
						},
						opt.e6)
				});
		},
		templateInfo.dO);
	return options;
};
var $author$project$Main$isVersionDeployed = F2(
	function (card, deployedSeriesMostRecent) {
		return A2($elm$core$Dict$member, card.a6, deployedSeriesMostRecent) ? _Utils_eq(
			$author$project$Main$createSemVerList(
				A2(
					$elm$core$Maybe$withDefault,
					'0.0.0',
					A2($elm$core$Dict$get, card.a6, deployedSeriesMostRecent))),
			$author$project$Main$createSemVerList(card.bl)) : false;
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Main$isVersionDeploying = F2(
	function (candidateCard, deployingCards) {
		var sameDeployingVersions = A2(
			$elm$core$List$filter,
			function (deployingCard) {
				return _Utils_eq(candidateCard.a6, deployingCard.a6);
			},
			$elm$core$Dict$values(deployingCards));
		return $elm$core$List$length(sameDeployingVersions) > 0;
	});
var $author$project$Main$reuseItems = F3(
	function (card, deployedSeriesMostRecent, deployingCards) {
		return (!A2($author$project$Main$isVersionDeployed, card, deployedSeriesMostRecent)) && (!A2($author$project$Main$isVersionDeploying, card, deployingCards));
	});
var $elm$core$Basics$round = _Basics_round;
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Main$defaultTemplateInfo = {cl: '', cJ: $elm$core$Set$empty, dk: $elm$core$Set$empty, dO: _List_Nil};
var $author$project$Main$templateInfoResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Card$templateInfoDecoder, value);
	if (!_v0.$) {
		var templateInfo = _v0.a;
		return templateInfo;
	} else {
		return $author$project$Main$defaultTemplateInfo;
	}
};
var $author$project$Main$IndustryDomainPair = F3(
	function (industry, domain, filterType) {
		return {bO: domain, bQ: filterType, bU: industry};
	});
var $author$project$Main$treeDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Main$IndustryDomainPair,
	A2($elm$json$Json$Decode$field, 'industry', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'domain', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'filterType', $elm$json$Json$Decode$string));
var $author$project$Main$treeResultToPair = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$treeDecoder, value);
	if (!_v0.$) {
		var indDomPair = _v0.a;
		return indDomPair;
	} else {
		return {bO: 'None', bQ: 'None', bU: 'None'};
	}
};
var $author$project$Main$updateUserOptions = F6(
	function (card, v, userProp, isSearch, canEnableDeploy, isLoading) {
		var templateInfo = card.dL;
		var isSR = userProp.fw === 'spatialreference';
		var defaultValue = userProp.ef;
		var valueDefault = (isSR && (isSearch && (v === ''))) ? defaultValue : v;
		var srSearchText = (isSR && isSearch) ? valueDefault : userProp.ff;
		var autoSelect = v === '';
		var valid = (userProp.fw === 'itemid') ? (canEnableDeploy || (v === '')) : (canEnableDeploy ? ((isSR && isSearch) ? (autoSelect && A2($author$project$Main$isValidFormat, userProp, srSearchText)) : A2($author$project$Main$isValidFormat, userProp, v)) : canEnableDeploy);
		var options = A2(
			$elm$core$List$map,
			function (opt) {
				return _Utils_update(
					opt,
					{
						e6: A2(
							$elm$core$List$map,
							function (p) {
								return (_Utils_eq(p.aa, userProp.aa) && _Utils_eq(p.e5, userProp.e5)) ? _Utils_update(
									p,
									{d_: autoSelect, cQ: userProp.cQ, aq: userProp.aq, eE: isLoading, cX: userProp.cX, e9: userProp.e9, ff: srSearchText, G: userProp.G, fs: valid, ft: valid, fu: userProp.fu, fv: valueDefault}) : p;
							},
							opt.e6)
					});
			},
			templateInfo.dO);
		return options;
	});
var $author$project$Main$updateActiveCard = F6(
	function (model, v, userProp, isSearch, canEnableDeploy, isLoading) {
		var activeCard = model.b;
		var options = A6($author$project$Main$updateUserOptions, activeCard, v, userProp, isSearch, canEnableDeploy, isLoading);
		var templateInfo = activeCard.dL;
		return _Utils_update(
			activeCard,
			{
				dL: _Utils_update(
					templateInfo,
					{dO: options})
			});
	});
var $author$project$Main$getId = function (userProp) {
	return userProp.aa + ('--*--' + userProp.e5);
};
var $author$project$Main$updateUserOptionsById = F3(
	function (id, v, userOptions) {
		return A2(
			$elm$core$List$map,
			function (opt) {
				return _Utils_update(
					opt,
					{
						e6: A2(
							$elm$core$List$map,
							function (p) {
								var p_id = $author$project$Main$getId(p);
								return _Utils_eq(p_id, id) ? _Utils_update(
									p,
									{fv: v}) : p;
							},
							opt.e6)
					});
			},
			userOptions);
	});
var $author$project$Main$UserOption = F3(
	function (id, props, accordionDisplay) {
		return {dV: accordionDisplay, aa: id, e6: props};
	});
var $author$project$Main$userOptionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Main$UserOption,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'props',
		$elm$json$Json$Decode$list($author$project$Main$propDecoder)),
	A2($elm$json$Json$Decode$field, 'accordionDisplay', $elm$json$Json$Decode$bool));
var $author$project$Main$userOptionsDecoder = $elm$json$Json$Decode$list($author$project$Main$userOptionDecoder);
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var isSignedIn = !$elm$core$Set$isEmpty(model.an);
			switch (msg.$) {
				case 1:
					if (model.b.aa === '') {
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$askJSForAvailableSolutions(model),
										$author$project$Main$askJSToSetNavTab(model.e),
										$author$project$Main$askJSToChangeUrl(model)
									])));
					} else {
						if (model.u && (!model.aF)) {
							var updatedModel = _Utils_update(
								model,
								{
									L: _List_fromArray(
										[model.b]),
									e: 1
								});
							return _Utils_Tuple2(
								updatedModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$askJSForAvailableSolutions(updatedModel),
											$author$project$Main$askJSToSetNavTab(updatedModel.e),
											$author$project$Main$askJSToDeploySolutionAtLaunch(model.b)
										])));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										L: _List_fromArray(
											[model.b]),
										u: false
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$askJSForAvailableSolutions(model),
											$author$project$Main$askJSToSetNavTab(model.e),
											$author$project$Main$askJsToOpenCardModal(model.b),
											$author$project$Main$askJSToChangeUrl(model),
											$author$project$Main$askJSForUUID
										])));
						}
					}
				case 2:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{u: true}),
						$author$project$Main$askJsToUpdateUrlSearch(
							_Utils_update(
								model,
								{u: true})));
				case 3:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aL: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJSForAvailableSolutions(model),
									$author$project$Main$askJSToChangeUrl(model)
								])));
				case 4:
					return isSignedIn ? _Utils_Tuple2(
						_Utils_update(
							model,
							{a8: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJSForDeployedSolutions(model),
									$author$project$Main$askJSToChangeUrl(model)
								]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 5:
					var solutionID = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Main$askJSForSelectedSolution(solutionID));
				case 6:
					return _Utils_Tuple2(model, $author$project$Main$askJSToGenerateShareLinkForSoln);
				case 7:
					var pageInfo = msg.a;
					var mySolutionsPagingStart = (!model.e) ? model.aS : pageInfo.bD;
					var homePaging = (!model.e) ? {bc: pageInfo.bD, bu: model.i.bu, bC: pageInfo.bD, aY: model.i.aY} : model.i;
					var $temp$msg = $author$project$Main$RequestAvailableSolutions,
						$temp$model = _Utils_update(
						model,
						{aS: mySolutionsPagingStart, i: homePaging});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 8:
					var tag = msg.a;
					var checked = msg.b;
					var updatedFilters = checked ? A2($elm$core$Set$insert, tag, model.B) : A2($elm$core$Set$remove, tag, model.B);
					var $temp$msg = $author$project$Main$RequestAvailableSolutions,
						$temp$model = _Utils_update(
						model,
						{C: _List_Nil, i: $author$project$Main$defaultPaging, B: updatedFilters});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 11:
					var tag = msg.a;
					var updatedFilters = A2($elm$core$Set$remove, tag, model.x);
					var $temp$msg = $author$project$Main$RequestAvailableSolutions,
						$temp$model = _Utils_update(
						model,
						{C: _List_Nil, x: updatedFilters, i: $author$project$Main$defaultPaging});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 9:
					var tag = msg.a;
					var updatedFilters = A2($elm$core$Set$remove, tag, model.D);
					var $temp$msg = $author$project$Main$RequestAvailableSolutions,
						$temp$model = _Utils_update(
						model,
						{C: _List_Nil, x: $elm$core$Set$empty, D: updatedFilters, i: $author$project$Main$defaultPaging});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 12:
					var $temp$msg = $author$project$Main$RequestAvailableSolutions,
						$temp$model = _Utils_update(
						model,
						{C: _List_Nil, x: $elm$core$Set$empty, D: $elm$core$Set$empty, i: $author$project$Main$defaultPaging, B: $elm$core$Set$empty});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 14:
					var userProp = msg.a;
					var updatedUserProp = _Utils_update(
						userProp,
						{ft: true, fv: ''});
					var updatedCard = A6($author$project$Main$updateActiveCard, model, '', updatedUserProp, false, false, false);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedCard}),
						$elm$core$Platform$Cmd$none);
				case 13:
					if (!model.e) {
						var $temp$msg = $author$project$Main$RequestAvailableSolutions,
							$temp$model = _Utils_update(
							model,
							{C: _List_Nil, i: $author$project$Main$defaultPaging, V: ''});
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var $temp$msg = $author$project$Main$RequestDeployedSolutions,
							$temp$model = _Utils_update(
							model,
							{U: ''});
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
				case 15:
					var textinput = msg.a;
					if (!model.e) {
						var $temp$msg = $author$project$Main$RequestAvailableSolutions,
							$temp$model = _Utils_update(
							model,
							{C: _List_Nil, i: $author$project$Main$defaultPaging, O: 2, V: textinput});
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var $temp$msg = $author$project$Main$RequestDeployedSolutions,
							$temp$model = _Utils_update(
							model,
							{U: textinput, O: 2});
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
				case 16:
					var textinput = msg.a;
					if (!model.e) {
						if ($elm$core$String$isEmpty(textinput) || ($elm$core$String$length(textinput) >= 3)) {
							var $temp$msg = $author$project$Main$RequestAvailableSolutions,
								$temp$model = _Utils_update(
								model,
								{C: _List_Nil, i: $author$project$Main$defaultPaging, O: 2, V: textinput});
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{V: textinput}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						if ($elm$core$String$isEmpty(textinput) || ($elm$core$String$length(textinput) >= 3)) {
							var $temp$msg = $author$project$Main$RequestDeployedSolutions,
								$temp$model = _Utils_update(
								model,
								{U: textinput, O: 2});
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{U: textinput}),
								$elm$core$Platform$Cmd$none);
						}
					}
				case 10:
					var userProp = msg.a;
					var v = msg.b;
					var valid = A2($author$project$Main$isValidFormat, userProp, v);
					var val = valid ? v : '';
					var updatedUserProp = _Utils_update(
						userProp,
						{ft: true, fv: val});
					var updatedCard = A6($author$project$Main$updateActiveCard, model, v, updatedUserProp, false, false, valid);
					var cmd = valid ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Main$askJSToValidateID, updatedCard, updatedUserProp)
							])) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedCard}),
						cmd);
				case 17:
					var userProp = msg.a;
					var v = msg.b;
					var cmd = A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							A2(
								$author$project$Main$SetSpatialReference,
								userProp,
								$elm$core$String$fromInt(v))),
						$elm$core$Process$sleep(0));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bj: $elm$core$String$fromInt(v),
								a9: true
							}),
						cmd);
				case 29:
					var clientPos = msg.a;
					var activeCard = model.b;
					var updatedActiveCard = _Utils_update(
						activeCard,
						{
							cu: $elm$core$Basics$round(clientPos.a),
							cO: true
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						$elm$core$Platform$Cmd$none);
				case 30:
					var clientPos = msg.a;
					var activeCard = model.b;
					var changeInHorizOffset = activeCard.cO ? ($elm$core$Basics$round(clientPos.a) - activeCard.cu) : 0;
					var updatedActiveCard = (!(!changeInHorizOffset)) ? _Utils_update(
						activeCard,
						{
							cu: $elm$core$Basics$round(clientPos.a),
							cN: true
						}) : activeCard;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						$elm$core$Platform$Cmd$none);
				case 32:
					var index = msg.a;
					var activeCard = model.b;
					var updatedActiveCard = (!activeCard.cN) ? _Utils_update(
						activeCard,
						{co: index, cO: false}) : activeCard;
					var $temp$msg = $author$project$Main$StopDraggingPreviewImages,
						$temp$model = _Utils_update(
						model,
						{b: updatedActiveCard});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 33:
					var activeCard = model.b;
					var newPreviewImage = (!activeCard.co) ? ($elm$core$List$length(activeCard.dj) - 1) : (activeCard.co - 1);
					var updatedActiveCard = _Utils_update(
						activeCard,
						{co: newPreviewImage});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						$elm$core$Platform$Cmd$none);
				case 34:
					var activeCard = model.b;
					var newPreviewImage = _Utils_eq(
						activeCard.co,
						$elm$core$List$length(activeCard.dj) - 1) ? 0 : (activeCard.co + 1);
					var updatedActiveCard = _Utils_update(
						activeCard,
						{co: newPreviewImage});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						$elm$core$Platform$Cmd$none);
				case 35:
					var index = msg.a;
					var activeCard = model.b;
					var updatedActiveCard = (!activeCard.cN) ? _Utils_update(
						activeCard,
						{co: index, cO: false}) : activeCard;
					var $temp$msg = $author$project$Main$StopDraggingPreviewImages,
						$temp$model = _Utils_update(
						model,
						{b: updatedActiveCard});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 36:
					var announcementType = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJSToCloseAlert('announcementAlert'),
									A3($author$project$Main$askJSToSetCookie, announcementType, 'true', $author$project$Main$cookieMaxAge)
								])));
				case 37:
					var announcementType = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJSToCloseAlert('announcementAlert')
								])));
				case 31:
					var activeCard = model.b;
					var updatedActiveCard = _Utils_update(
						activeCard,
						{cN: false, cO: false});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						$elm$core$Platform$Cmd$none);
				case 52:
					var userProp = msg.a;
					var updatedCard = A6($author$project$Main$updateActiveCard, model, model.bj, userProp, true, true, false);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedCard, a9: false}),
						$elm$core$Platform$Cmd$none);
				case 18:
					var userProp = msg.a;
					var v = msg.b;
					var updatedCard = A6($author$project$Main$updateActiveCard, model, v, userProp, false, true, false);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedCard}),
						$elm$core$Platform$Cmd$none);
				case 19:
					var field = msg.a;
					var sortFieldValues = _List_fromArray(
						['relevance', 'created', 'title', 'numviews']);
					var defaultSortOrder = ((field === 'created') || ((field === 'relevance') || (field === 'numviews'))) ? 'desc' : ((field === 'title') ? 'asc' : ((!model.e) ? model.X : model.am));
					var updatedModel = A2($elm$core$List$member, field, sortFieldValues) ? ((!model.e) ? _Utils_update(
						model,
						{au: field, X: defaultSortOrder}) : _Utils_update(
						model,
						{as: field, am: defaultSortOrder})) : ((!model.e) ? _Utils_update(
						model,
						{X: field}) : _Utils_update(
						model,
						{am: field}));
					if (!model.e) {
						var $temp$msg = $author$project$Main$RequestAvailableSolutions,
							$temp$model = _Utils_update(
							updatedModel,
							{C: _List_Nil, i: $author$project$Main$defaultPaging});
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var $temp$msg = $author$project$Main$RequestDeployedSolutions,
							$temp$model = updatedModel;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
				case 24:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: true}),
						$elm$core$Platform$Cmd$none);
				case 21:
					var userProp = msg.a;
					var v = msg.b;
					var valueType = userProp.fw;
					var cmd = (valueType === 'color') ? $author$project$Main$askJsForColor(v) : $elm$core$Platform$Cmd$none;
					var activeCard = model.b;
					var templateInfo = activeCard.dL;
					var options = (valueType === 'color') ? templateInfo.dO : A6($author$project$Main$updateUserOptions, activeCard, v, userProp, false, true, false);
					var updatedActiveCard = _Utils_update(
						activeCard,
						{
							dL: _Utils_update(
								templateInfo,
								{dO: options})
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						cmd);
				case 22:
					var userProp = msg.a;
					var checked = msg.b;
					var v = checked ? 'true' : 'false';
					var activeCard = model.b;
					var options = A6($author$project$Main$updateUserOptions, activeCard, v, userProp, false, true, false);
					var templateInfo = activeCard.dL;
					var updatedActiveCard = _Utils_update(
						activeCard,
						{
							dL: _Utils_update(
								templateInfo,
								{dO: options})
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard}),
						$elm$core$Platform$Cmd$none);
				case 20:
					var card = msg.a;
					var isRetry = msg.b;
					var userOptionsSet = isRetry ? true : _Utils_eq(
						model.H + 1,
						$elm$core$List$length(card.dL.dO));
					var reuseItemsOption = A3($author$project$Main$reuseItems, card, model.Z, model.r);
					var optionsValid = A2($author$project$Main$checkOptions, card.dL.dO, model.H);
					var hasUserOptions = ($elm$core$List$length(card.dL.dO) > 0) && (!userOptionsSet);
					var dependentJobId = A2($author$project$Main$getDependentJobId, card, model.r);
					var longId = dependentJobId + ('_' + (card.aa + ('_' + model.aG)));
					var sendToWaiting = reuseItemsOption && (!$elm$core$String$isEmpty(dependentJobId));
					var updatedCard = _Utils_update(
						card,
						{cc: dependentJobId});
					var updatedModel = optionsValid ? (hasUserOptions ? _Utils_update(
						model,
						{b: updatedCard, ae: 'configure', H: 0}) : (sendToWaiting ? _Utils_update(
						model,
						{
							b: $author$project$Card$emptyCard,
							L: _List_Nil,
							u: false,
							e: 1,
							H: -1,
							I: A3(
								$elm$core$Dict$insert,
								longId,
								{t: updatedCard, E: model.aG},
								model.I)
						}) : _Utils_update(
						model,
						{
							b: $author$project$Card$emptyCard,
							L: _List_Nil,
							u: false,
							r: A3($elm$core$Dict$insert, model.aG, updatedCard, model.r),
							e: 1,
							H: -1
						}))) : _Utils_update(
						model,
						{bH: optionsValid});
					var command = hasUserOptions ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Main$askJsToUpdateModal, updatedCard, 'configure')
							])) : (optionsValid ? (sendToWaiting ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$askJSToSetNavTab(1),
								$author$project$Main$askJSToChangeUrl(updatedModel),
								$author$project$Main$askJsToCloseModal('sendToWaiting')
							])) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Main$askJSToDeploySolution, updatedCard, reuseItemsOption, model.aG),
								$author$project$Main$askJSToSetNavTab(1),
								$author$project$Main$askJSToChangeUrl(updatedModel),
								$author$project$Main$askJsToCloseModal('askJSToDeploySolution')
							]))) : $elm$core$Platform$Cmd$none);
					return _Utils_Tuple2(updatedModel, command);
				case 23:
					var newActiveCardQueue = function () {
						var _v7 = model.L;
						if (!_v7.b) {
							return _List_Nil;
						} else {
							var rest = _v7.b;
							return rest;
						}
					}();
					var newActiveCard = function () {
						var _v5 = model.L;
						if (!_v5.b) {
							return $author$project$Card$emptyCard;
						} else {
							var rest = _v5.b;
							if (!rest.b) {
								return $author$project$Card$emptyCard;
							} else {
								var second = rest.a;
								return second;
							}
						}
					}();
					var updatedModel = _Utils_update(
						model,
						{b: newActiveCard, L: newActiveCardQueue});
					return _Utils_Tuple2(
						updatedModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJsToOpenCardModal(newActiveCard),
									$author$project$Main$askJSToChangeUrl(updatedModel)
								])));
				case 25:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ae: 'information', ab: false, H: -1}),
						$author$project$Main$askJsToCloseModal('closeCard'));
				case 26:
					var card = msg.a;
					var mode = msg.b;
					var templateInfo = card.dL;
					var resetTemplateInfo = (model.ae === 'configure') && (mode === 'information');
					var options = resetTemplateInfo ? $author$project$Main$resetUserOptions(card) : templateInfo.dO;
					var updatedActiveCard = _Utils_update(
						card,
						{
							dL: _Utils_update(
								templateInfo,
								{dO: options})
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard, ae: mode, H: -1, bH: true}),
						A2($author$project$Main$askJsToUpdateModal, card, mode));
				case 50:
					var currentIndex = msg.a;
					var newIndex = currentIndex + 1;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: newIndex}),
						$author$project$Main$askJsToUpdateVisibleOptions(newIndex));
				case 51:
					var card = msg.a;
					var currentIndex = msg.b;
					var templateInfo = card.dL;
					var newIndex = currentIndex - 1;
					var infoMode = _Utils_eq(newIndex, -1) ? 'information' : model.ae;
					var options = (infoMode === 'information') ? $author$project$Main$resetUserOptions(card) : card.dL.dO;
					var updatedActiveCard = _Utils_update(
						card,
						{
							dL: _Utils_update(
								templateInfo,
								{dO: options})
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b: updatedActiveCard, ae: infoMode, H: newIndex}),
						$author$project$Main$askJsToUpdateVisibleOptions(newIndex));
				case 27:
					var width = msg.a;
					var height = msg.b;
					var filter = ((_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) < 1) && model.W) ? false : (((_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) > 0) && (model.bp && (!model.W))) ? true : model.W);
					var command = ((_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) > 0) && (model.ak === 'Filters')) ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$askJsToCloseModal('filters'),
								$author$project$Main$askJSForMaxHeights
							])) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[$author$project$Main$askJSForMaxHeights]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{W: filter, ay: height, K: width}),
						command);
				case 28:
					var card = msg.a;
					var updatedStatus = (model.aB === 3) ? 2 : 1;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aB: updatedStatus}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJsToDeleteSolution(card)
								])));
				case 38:
					var cardMsg = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 39:
					var card = msg.a;
					var updatedModel = _Utils_update(
						model,
						{Q: card, ab: true, F: true, ak: 'Delete'});
					return _Utils_Tuple2(
						updatedModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJsToOpenDeleteCardModal(card)
								])));
				case 40:
					var card = msg.a;
					var updatedModel = _Utils_update(
						model,
						{aO: card, ab: true, ak: 'Diagram'});
					return _Utils_Tuple2(
						updatedModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJsToOpenDiagramModal(card)
								])));
				case 41:
					var updatedModel = _Utils_update(
						model,
						{F: true, ak: 'Filters'});
					return _Utils_Tuple2(
						updatedModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[$author$project$Main$askJsToOpenFilterModal])));
				case 42:
					var link = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Main$askJsToOpenLink(link));
				case 43:
					var id = msg.a;
					var value = msg.b;
					return _Utils_Tuple2(
						model,
						A2($author$project$Main$askJsToTriggerBlur, id, value));
				case 44:
					var id = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Main$askJsToTriggerFocus(id));
				case 45:
					var card = msg.a;
					var updatedModel = _Utils_update(
						model,
						{
							b: card,
							L: A2($elm$core$List$cons, card, model.L),
							ae: 'information',
							ab: true,
							H: -1
						});
					return _Utils_Tuple2(
						updatedModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$askJsToOpenCardModal(card),
									$author$project$Main$askJSToChangeUrl(updatedModel),
									$author$project$Main$askJSForUUID
								])));
				case 46:
					var jsPacket = msg.a;
					var command = $author$project$Main$parseInteropCommand(jsPacket.a4);
					switch (command) {
						case 1:
							var $temp$msg = $author$project$Main$RequestDeployedSolutions,
								$temp$model = model;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 2:
							var progressUpdateAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$progressDecoder, jsPacket.l);
							if (!progressUpdateAttempt.$) {
								var progressUpdate = progressUpdateAttempt.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											r: A3(
												$elm$core$Dict$update,
												progressUpdate.aa,
												$author$project$Main$cardUpdatePercentage(progressUpdate.dd),
												model.r)
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 3:
							var progressDeleteAttempt = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$float, jsPacket.l);
							if (!progressDeleteAttempt.$) {
								var deleteUpdate = progressDeleteAttempt.a;
								var activeDeleteCard = model.Q;
								var updatedDeleteCard = _Utils_update(
									activeDeleteCard,
									{cr: deleteUpdate});
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{Q: updatedDeleteCard}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 4:
							var optionalData = $author$project$Main$getOptionalDataFromPacketData(jsPacket);
							var cards = $author$project$Main$getCardsFromPacketData(jsPacket);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										bI: $author$project$Main$getCardCatalog(cards),
										C: cards,
										a2: '',
										i: optionalData,
										O: 0,
										aL: false
									}),
								$elm$core$Platform$Cmd$none);
						case 5:
							var errorMsg = $author$project$Main$getErrorMessageFromPacketData(jsPacket);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{C: _List_Nil, a2: errorMsg, O: 0, aL: false}),
								$elm$core$Platform$Cmd$none);
						case 6:
							var hasRelatedSolutions = $author$project$Main$getRelatedSolutionsSwitchFromPacketData(jsPacket);
							var cards = $author$project$Main$getCardsFromPacketData(jsPacket);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										Y: cards,
										a8: false,
										Z: $author$project$Main$getDeployedSeriesMostRecent(cards),
										ad: hasRelatedSolutions,
										O: 0
									}),
								$elm$core$Platform$Cmd$none);
						case 7:
							var hasRelatedSolutions = $author$project$Main$getRelatedSolutionsSwitchFromPacketData(jsPacket);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ad: hasRelatedSolutions}),
								$elm$core$Platform$Cmd$none);
						case 8:
							var cards = $author$project$Main$getCardsFromPacketData(jsPacket);
							var activeCard = function () {
								if (!cards.b) {
									return $author$project$Card$emptyCard;
								} else {
									if (!cards.b.b) {
										var card = cards.a;
										return card;
									} else {
										return $author$project$Card$emptyCard;
									}
								}
							}();
							var $temp$msg = $author$project$Main$RequestInitialization,
								$temp$model = _Utils_update(
								model,
								{b: activeCard});
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 9:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 10:
							var deployedCardAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$deployedDecoder, jsPacket.l);
							if (!deployedCardAttempt.$) {
								var deployedCardResult = deployedCardAttempt.a;
								var waitingKey = A3($author$project$Main$getWaitingKey, model, deployedCardResult.E, deployedCardResult.t.cc);
								var dependentDeployWaiting = waitingKey !== '';
								var dependentDeployInfo = A2(
									$elm$core$Maybe$withDefault,
									{t: $author$project$Card$emptyCard, E: ''},
									A2($elm$core$Dict$get, waitingKey, model.I));
								var updatedModel = dependentDeployWaiting ? _Utils_update(
									model,
									{
										Y: A2($elm$core$List$cons, deployedCardResult.t, model.Y),
										Z: A3($elm$core$Dict$insert, deployedCardResult.t.a6, deployedCardResult.t.bl, model.Z),
										r: function () {
											var updatedDeployingCardsRemove = A2($elm$core$Dict$remove, deployedCardResult.E, model.r);
											var updatedDeployingCards = A3($elm$core$Dict$insert, dependentDeployInfo.E, dependentDeployInfo.t, updatedDeployingCardsRemove);
											return updatedDeployingCards;
										}(),
										I: A2($elm$core$Dict$remove, waitingKey, model.I)
									}) : _Utils_update(
									model,
									{
										Y: A2($elm$core$List$cons, deployedCardResult.t, model.Y),
										Z: A3($elm$core$Dict$insert, deployedCardResult.t.a6, deployedCardResult.t.bl, model.Z),
										r: A2($elm$core$Dict$remove, deployedCardResult.E, model.r)
									});
								var action = dependentDeployWaiting ? A3($author$project$Main$askJSToDeploySolution, dependentDeployInfo.t, true, dependentDeployInfo.E) : $elm$core$Platform$Cmd$none;
								return _Utils_Tuple2(updatedModel, action);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 11:
							var cardAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Card$decoder, jsPacket.l);
							if (!cardAttempt.$) {
								var card = cardAttempt.a;
								var missingPrivilegesPrecheck = A2($elm$core$Set$diff, card.dL.dk, model.an);
								var deployCommand = (!$elm$core$Set$size(missingPrivilegesPrecheck)) ? A2(
									$author$project$Main$update,
									A2($author$project$Main$Deploy, card, false),
									model) : A2(
									$author$project$Main$update,
									$author$project$Main$RequestInitialization,
									_Utils_update(
										model,
										{u: false}));
								return deployCommand;
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 12:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{aS: 1}),
								$elm$core$Platform$Cmd$none);
						case 14:
							var tag = $author$project$Main$treeResultToPair(jsPacket.l);
							var updatedDomainFilters = $author$project$Main$filterSetup(tag.bO);
							var updatedIndustryFilters = $author$project$Main$filterSetup(tag.bU);
							var updatedModel = (tag.bQ === 'industry-domain') ? _Utils_update(
								model,
								{x: updatedDomainFilters, D: updatedIndustryFilters}) : model;
							var $temp$msg = $author$project$Main$RequestAvailableSolutions,
								$temp$model = _Utils_update(
								updatedModel,
								{C: _List_Nil, i: $author$project$Main$defaultPaging});
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 15:
							var activeTab = A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Main$tab.cC(
									$author$project$Main$decodeString(jsPacket.l)));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{e: activeTab}),
								$author$project$Main$askJSToChangeUrl(
									_Utils_update(
										model,
										{e: activeTab})));
						case 18:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 19:
							var action = (_Utils_cmp(model.i.bc, -1) > 0) ? A2(
								$author$project$Main$update,
								$author$project$Main$RequestAvailableSolutions,
								_Utils_update(
									model,
									{O: 1, aL: true})) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							return action;
						case 20:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 21:
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$askJsToPopulateDiagramModal(model.aO)
										])));
						case 24:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 25:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 26:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 22:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 23:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 27:
							var selectedId = $author$project$Main$decodeString(jsPacket.l);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bd: selectedId}),
								$elm$core$Platform$Cmd$none);
						case 28:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bd: ''}),
								$elm$core$Platform$Cmd$none);
						case 29:
							var newRelatedItems = $author$project$Main$getRelatedItemsFromPacketData(jsPacket);
							var failedDeletes = !$elm$core$List$isEmpty(newRelatedItems);
							var activeDeleteCard = model.Q;
							var updatedDeleteCard = _Utils_update(
								activeDeleteCard,
								{dq: newRelatedItems});
							var action = function () {
								if (failedDeletes) {
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{Q: updatedDeleteCard, aB: 3}),
										$elm$core$Platform$Cmd$none);
								} else {
									var updatedDeployedCards = A2(
										$elm$core$List$filter,
										function (item) {
											return !_Utils_eq(item.aa, activeDeleteCard.aa);
										},
										model.Y);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												Q: updatedDeleteCard,
												Y: updatedDeployedCards,
												Z: $author$project$Main$getDeployedSeriesMostRecent(updatedDeployedCards)
											}),
										$author$project$Main$askJsToCloseModal('delete'));
								}
							}();
							return action;
						case 33:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 34:
							var m = _Utils_eq(model.H, -1) ? A2(
								$author$project$Main$update,
								A2($author$project$Main$ChangeInfoMode, model.b, 'information'),
								model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							return m;
						case 30:
							var updatedModel = model.F ? _Utils_update(
								model,
								{F: false}) : _Utils_update(
								model,
								{b: $author$project$Card$emptyCard, L: _List_Nil, Q: $author$project$Card$emptyCard, aO: $author$project$Card$emptyCard, ab: false});
							var cmds = model.F ? _List_fromArray(
								[
									$author$project$Main$askJsToOpenCardModal(model.b),
									$author$project$Main$askJSToChangeUrl(updatedModel)
								]) : _List_fromArray(
								[
									$author$project$Main$askJSToChangeUrl(updatedModel)
								]);
							return _Utils_Tuple2(
								_Utils_update(
									updatedModel,
									{aB: 0, u: false, ak: 'Card'}),
								$elm$core$Platform$Cmd$batch(cmds));
						case 31:
							var v = $author$project$Main$decodeString(jsPacket.l);
							var id = $author$project$Main$decodeString(jsPacket.i);
							var activeCard = model.b;
							var templateInfo = activeCard.dL;
							var options = A3($author$project$Main$updateUserOptionsById, id, v, templateInfo.dO);
							var updatedActiveCard = _Utils_update(
								activeCard,
								{
									dL: _Utils_update(
										templateInfo,
										{dO: options})
								});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{b: updatedActiveCard}),
								$elm$core$Platform$Cmd$none);
						case 32:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 35:
							var inTemplateInfos = $author$project$Main$templateInfoResult(jsPacket.l);
							var activeCard = model.b;
							var updatedActiveCard = _Utils_update(
								activeCard,
								{dL: inTemplateInfos});
							var nextStep = function () {
								if (model.F || model.u) {
									var missingPrivileges = A2($elm$core$Set$diff, updatedActiveCard.dL.dk, model.an);
									return (!$elm$core$Set$size(missingPrivileges)) ? A2(
										$author$project$Main$update,
										A2($author$project$Main$Deploy, updatedActiveCard, false),
										_Utils_update(
											model,
											{b: updatedActiveCard, u: false, F: false})) : A2(
										$author$project$Main$update,
										A2($author$project$Main$ChangeInfoMode, updatedActiveCard, 'blocked'),
										_Utils_update(
											model,
											{b: updatedActiveCard, u: false, F: false}));
								} else {
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{b: updatedActiveCard, u: false}),
										$elm$core$Platform$Cmd$batch(_List_Nil));
								}
							}();
							return nextStep;
						case 36:
							var newRelatedItems = $author$project$Main$getRelatedItemsFromPacketData(jsPacket);
							var activeDeleteCard = model.Q;
							var updatedDeleteCard = _Utils_update(
								activeDeleteCard,
								{dq: newRelatedItems});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{Q: updatedDeleteCard, F: false}),
								$elm$core$Platform$Cmd$none);
						case 16:
							return A2(
								$author$project$Main$urlValidater,
								$author$project$Main$decodeString(jsPacket.l),
								model);
						case 17:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 37:
							var userOptionsAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$userOptionsDecoder, jsPacket.i);
							var cardAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Card$decoder, jsPacket.l);
							if (!cardAttempt.$) {
								var retryCard = cardAttempt.a;
								var updatedRetryCard = function () {
									if (!userOptionsAttempt.$) {
										var userOptions = userOptionsAttempt.a;
										var templateInfo = retryCard.dL;
										return _Utils_update(
											retryCard,
											{
												dL: _Utils_update(
													templateInfo,
													{dO: userOptions})
											});
									} else {
										return retryCard;
									}
								}();
								var $temp$msg = A2($author$project$Main$Deploy, updatedRetryCard, true),
									$temp$model = model;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 38:
							var deployAttempt = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$deployedDecoder, jsPacket.l);
							if (!deployAttempt.$) {
								var failDeployResult = deployAttempt.a;
								var waitingKey = A3($author$project$Main$getWaitingKey, model, failDeployResult.E, failDeployResult.t.cc);
								var dependentDeployWaiting = waitingKey !== '';
								var dependentDeployInfo = A2(
									$elm$core$Maybe$withDefault,
									{t: $author$project$Card$emptyCard, E: ''},
									A2($elm$core$Dict$get, waitingKey, model.I));
								var updatedModel = dependentDeployWaiting ? _Utils_update(
									model,
									{
										r: function () {
											var updatedDeployingCardsRemove = A2($elm$core$Dict$remove, failDeployResult.E, model.r);
											var updatedDeployingCards = A3($elm$core$Dict$insert, dependentDeployInfo.E, dependentDeployInfo.t, updatedDeployingCardsRemove);
											return updatedDeployingCards;
										}(),
										I: A2($elm$core$Dict$remove, waitingKey, model.I)
									}) : _Utils_update(
									model,
									{
										r: A2($elm$core$Dict$remove, failDeployResult.E, model.r)
									});
								var action = dependentDeployWaiting ? A3($author$project$Main$askJSToDeploySolution, dependentDeployInfo.t, true, dependentDeployInfo.E) : $elm$core$Platform$Cmd$none;
								return _Utils_Tuple2(updatedModel, action);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 39:
							var offsets = $author$project$Main$maxHeightsResult(jsPacket.l);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{aU: offsets}),
								$elm$core$Platform$Cmd$none);
						case 40:
							var jobID = $author$project$Main$decodeString(jsPacket.l);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{aG: jobID}),
								$elm$core$Platform$Cmd$none);
						case 13:
							var valid = $author$project$Main$decodeBool(jsPacket.l);
							var userProp = $author$project$Main$decodeUserProp(jsPacket.i);
							var updatedCard = A6($author$project$Main$updateActiveCard, model, userProp.fv, userProp, false, valid, false);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{b: updatedCard}),
								$elm$core$Platform$Cmd$none);
						case 41:
							var newToken = $author$project$Main$decodeString(jsPacket.l);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{aw: newToken}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 47:
					var scrollHeight = msg.a.dz;
					var scrollTop = msg.a.dA;
					var offsetHeight = msg.a.c1;
					return _Utils_Tuple2(model, $author$project$Main$askJSToTriggerMeteredScroll);
				case 48:
					var cmd = model.T ? $elm$core$Platform$Cmd$none : $author$project$Main$askJSToTriggerMeteredScroll;
					return _Utils_Tuple2(model, cmd);
				case 49:
					var showFilters = !model.W;
					return ((_Utils_cmp(model.K, $author$project$Main$mobileWidthThreshold) < 1) && showFilters) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{ab: true, ak: 'Filters'}),
						$author$project$Main$askJsToOpenFilterModal) : _Utils_Tuple2(
						_Utils_update(
							model,
							{bp: showFilters, ab: false, W: showFilters}),
						$elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Main$urlValidater = F2(
	function (urlString, selectedModel) {
		var startRoute = $author$project$Main$locationHrefToRoute(urlString);
		if (!startRoute.$) {
			var _v1 = startRoute.a;
			var loadTab = _v1.a;
			var sortField = _v1.b;
			var sortOrder = _v1.c;
			var filterType = _v1.d;
			var industry = _v1.e;
			var domain = _v1.f;
			var searchTerm = _v1.g;
			var solution = _v1.h;
			var deploy = _v1.i;
			var validatedTab = function () {
				var _v3 = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Main$tab.g(selectedModel.e),
					loadTab);
				switch (_v3) {
					case 'home':
						return 0;
					case 'solutions':
						return 1;
					case '':
						return 0;
					default:
						return selectedModel.e;
				}
			}();
			var validatedSortOrder = A2(
				$elm$core$Set$member,
				A2($elm$core$Maybe$withDefault, selectedModel.X, sortOrder),
				$elm$core$Set$fromList(
					_List_fromArray(
						['asc', 'desc']))) ? A2($elm$core$Maybe$withDefault, selectedModel.X, sortOrder) : selectedModel.X;
			var validatedIndustryFilters = A2(
				$elm$core$Dict$member,
				A2($elm$core$Maybe$withDefault, 'None', industry),
				$author$project$Main$industryTags) ? $author$project$Main$filterSetup(
				A2($elm$core$Maybe$withDefault, 'None', industry)) : selectedModel.D;
			var validatedDomainFilters = function () {
				if (_Utils_eq(validatedIndustryFilters, $elm$core$Set$empty)) {
					return selectedModel.x;
				} else {
					var currentFilter = function () {
						var _v2 = $elm$core$Set$toList(validatedIndustryFilters);
						if (!_v2.b) {
							return '';
						} else {
							if (!_v2.b.b) {
								var industryFilter = _v2.a;
								return industryFilter;
							} else {
								return '';
							}
						}
					}();
					return A2(
						$elm$core$Set$member,
						A2($elm$core$Maybe$withDefault, '', domain),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Set$empty,
							A2($elm$core$Dict$get, currentFilter, $author$project$Main$industryTags))) ? $author$project$Main$filterSetup(
						A2($elm$core$Maybe$withDefault, 'None', domain)) : selectedModel.x;
				}
			}();
			var validateDeployActiveCard = !$elm$core$String$isEmpty(
				A2($elm$core$Maybe$withDefault, '', deploy));
			var tentativeTypeFilters = A2(
				$elm$core$Set$member,
				A2($elm$core$Maybe$withDefault, 'None', filterType),
				$elm$core$Set$fromList(
					_List_fromArray(
						['New', 'Suggested']))) ? $author$project$Main$filterSetup(
				A2($elm$core$Maybe$withDefault, 'None', filterType)) : (A2(
				$elm$core$Set$member,
				A2($elm$core$Maybe$withDefault, 'None', filterType),
				$elm$core$Set$fromList(
					_List_fromArray(
						['New,Suggested']))) ? $author$project$Main$filtersSetup(
				A2(
					$elm$core$String$split,
					',',
					A2($elm$core$Maybe$withDefault, '', filterType))) : selectedModel.B);
			var validatedTypeFilters = selectedModel.ad ? tentativeTypeFilters : A2($elm$core$Set$remove, 'Suggested', tentativeTypeFilters);
			var defaultSortField = (!validatedTab) ? selectedModel.au : selectedModel.as;
			var validatedSortField = function () {
				var validSortFieldSet = (!validatedTab) ? $elm$core$Set$fromList(
					_List_fromArray(
						['relevance', 'numviews', 'title'])) : $elm$core$Set$fromList(
					_List_fromArray(
						['relevance', 'created', 'title', 'numviews']));
				return A2(
					$elm$core$Set$member,
					A2($elm$core$Maybe$withDefault, defaultSortField, sortField),
					validSortFieldSet) ? A2($elm$core$Maybe$withDefault, defaultSortField, sortField) : defaultSortField;
			}();
			var updatedModel = (!validatedTab) ? _Utils_update(
				selectedModel,
				{
					u: validateDeployActiveCard,
					x: validatedDomainFilters,
					D: validatedIndustryFilters,
					V: A2($elm$core$Maybe$withDefault, selectedModel.V, searchTerm),
					au: validatedSortField,
					X: validatedSortOrder,
					e: validatedTab,
					B: validatedTypeFilters
				}) : _Utils_update(
				selectedModel,
				{
					u: validateDeployActiveCard,
					x: validatedDomainFilters,
					D: validatedIndustryFilters,
					U: A2($elm$core$Maybe$withDefault, selectedModel.U, searchTerm),
					as: validatedSortField,
					am: validatedSortOrder,
					e: validatedTab,
					B: validatedTypeFilters
				});
			return $elm$core$String$isEmpty(
				A2($elm$core$Maybe$withDefault, '', solution)) ? ($elm$core$String$isEmpty(
				A2($elm$core$Maybe$withDefault, '', deploy)) ? A2($author$project$Main$update, $author$project$Main$RequestInitialization, updatedModel) : A2(
				$author$project$Main$update,
				$author$project$Main$RequestSelectedSolution(
					A2($elm$core$Maybe$withDefault, '', deploy)),
				updatedModel)) : A2(
				$author$project$Main$update,
				$author$project$Main$RequestSelectedSolution(
					A2($elm$core$Maybe$withDefault, '', solution)),
				updatedModel);
		} else {
			return A2($author$project$Main$update, $author$project$Main$RequestInitialization, $author$project$Main$initialModel);
		}
	});
var $author$project$Main$init = function (flags) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$flagsDecoder, flags);
	if (!_v0.$) {
		var value = _v0.a;
		var _v1 = A2($elm$json$Json$Decode$decodeValue, $ChristophP$elm_i18next$I18Next$translationsDecoder, value.n);
		if (!_v1.$) {
			var translations = _v1.a;
			var initialLangModel = _Utils_update(
				$author$project$Main$initialModel,
				{
					az: value.az,
					T: value.T,
					ad: value.ad,
					aT: value.aT,
					aE: value.aE,
					aF: value.aF,
					aH: value.aH,
					W: _Utils_cmp(value.K, $author$project$Main$mobileWidthThreshold) > 0,
					av: value.av,
					aX: value.aX,
					aw: value.aw,
					n: translations,
					an: value.an,
					ay: value.ay,
					K: value.K
				});
			return A2($author$project$Main$urlValidater, value.dc, initialLangModel);
		} else {
			return _Utils_Tuple2($author$project$Main$initialModel, $elm$core$Platform$Cmd$none);
		}
	} else {
		return _Utils_Tuple2($author$project$Main$initialModel, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Main$CallbackFromJSLibrary = function (a) {
	return {$: 46, a: a};
};
var $author$project$Main$SetWindowDimens = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Main$elmCallback = _Platform_incomingPort(
	'elmCallback',
	A2(
		$elm$json$Json$Decode$andThen,
		function (optionalData) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (data) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (command) {
							return $elm$json$Json$Decode$succeed(
								{a4: command, l: data, i: optionalData});
						},
						A2($elm$json$Json$Decode$field, 'command', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$field, 'optionalData', $elm$json$Json$Decode$value)));
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {de: pids, dJ: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {cw: event, cR: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.de,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.cR;
		var event = _v0.cw;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.dJ);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Main$elmCallback($author$project$Main$CallbackFromJSLibrary),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (w, h) {
						return A2($author$project$Main$SetWindowDimens, w, h);
					}))
			]));
};
var $author$project$Main$PaginationChange = function (a) {
	return {$: 7, a: a};
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Main$calcitePagination = $elm$html$Html$node('calcite-pagination');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Main$galleryItemsPerPage = 24;
var $author$project$Translations$Pagination$jumpToNextPage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'pagination.jumpToNextPage');
};
var $author$project$Translations$Pagination$jumpToPreviousPage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'pagination.jumpToPreviousPage');
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Main$PaginationData = F3(
	function (startItem, pageSize, totalItems) {
		return {e$: pageSize, bD: startItem, fo: totalItems};
	});
var $author$project$Main$paginationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalItems',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pageSize',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'startItem',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Main$PaginationData))));
var $author$project$Main$onPaginationEvent = function (pageMsg) {
	return A2(
		$elm$html$Html$Events$on,
		'calcitePaginationChange',
		A2(
			$elm$json$Json$Decode$map,
			pageMsg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target']),
				$author$project$Main$paginationDecoder)));
};
var $author$project$Translations$Search$searchArcGISSolutions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'search.searchArcGISSolutions');
};
var $author$project$Main$ClearText = {$: 13};
var $author$project$Main$Search = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$SearchText = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$SortChange = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$ToggleFilter = {$: 49};
var $author$project$Main$calciteButton = $elm$html$Html$node('calcite-button');
var $author$project$Main$calciteDropdown = $elm$html$Html$node('calcite-dropdown');
var $author$project$Main$calciteDropdownGroup = $elm$html$Html$node('calcite-dropdown-group');
var $author$project$Main$calciteIcon = $elm$html$Html$node('calcite-icon');
var $author$project$Translations$Search$clearSearch = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'search.clearSearch');
};
var $author$project$Translations$Filters$filterButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.filterButton');
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$onCalciteDropdownItemSelected = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'calciteDropdownItemSelect',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'attributes', 'value', 'value']),
				$elm$json$Json$Decode$string)));
};
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Main$keyEventDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['key']),
	$elm$json$Json$Decode$string);
var $author$project$Main$onEnter = function (msg) {
	var isEnter = function (key) {
		return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not ENTER');
	};
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnter, $author$project$Main$keyEventDecoder));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Translations$CardDisplayOrder$sortBy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortBy');
};
var $author$project$Translations$CardDisplayOrder$sortByDateDeployed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortByDateDeployed');
};
var $author$project$Translations$CardDisplayOrder$sortByRelevance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortByRelevance');
};
var $author$project$Translations$CardDisplayOrder$sortByTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortByTitle');
};
var $author$project$Translations$CardDisplayOrder$sortByViewCount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortByViewCount');
};
var $author$project$Translations$CardDisplayOrder$sortDirection = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirection');
};
var $author$project$Translations$CardDisplayOrder$sortDirectionAlphabetical = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirectionAlphabetical');
};
var $author$project$Translations$CardDisplayOrder$sortDirectionLeastRecent = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirectionLeastRecent');
};
var $author$project$Translations$CardDisplayOrder$sortDirectionLeastViews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirectionLeastViews');
};
var $author$project$Translations$CardDisplayOrder$sortDirectionMostRecent = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirectionMostRecent');
};
var $author$project$Translations$CardDisplayOrder$sortDirectionMostViews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirectionMostViews');
};
var $author$project$Translations$CardDisplayOrder$sortDirectionReverseAlphabetical = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortDirectionReverseAlphabetical');
};
var $author$project$Main$calciteDropdownItem = $elm$html$Html$node('calcite-dropdown-item');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Main$sortFieldItem = F4(
	function (sortField, displayValue, a11yValue, value) {
		return A2(
			$author$project$Main$calciteDropdownItem,
			_List_fromArray(
				[
					_Utils_eq(sortField, value) ? A2($elm$html$Html$Attributes$attribute, 'open', 'true') : A2($elm$html$Html$Attributes$attribute, 'open', 'false'),
					A2($elm$html$Html$Attributes$attribute, 'value', value),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', a11yValue)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(displayValue)
				]));
	});
var $author$project$Main$sortOrderItem = F4(
	function (sortOrder, sortDirectionText, sortDirectionA11y, value) {
		return A2(
			$author$project$Main$calciteDropdownItem,
			_List_fromArray(
				[
					_Utils_eq(sortOrder, value) ? A2($elm$html$Html$Attributes$attribute, 'open', 'true') : A2($elm$html$Html$Attributes$attribute, 'open', 'false'),
					A2($elm$html$Html$Attributes$attribute, 'value', value),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', sortDirectionA11y)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(sortDirectionText)
				]));
	});
var $author$project$Translations$CardDisplayOrder$sortingByAlphabetical = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByAlphabetical');
};
var $author$project$Translations$CardDisplayOrder$sortingByDateDeployed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByDateDeployed');
};
var $author$project$Translations$CardDisplayOrder$sortingByLeastToMostViews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByLeastToMostViews');
};
var $author$project$Translations$CardDisplayOrder$sortingByMostToLeastViews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByMostToLeastViews');
};
var $author$project$Translations$CardDisplayOrder$sortingByRelevance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByRelevance');
};
var $author$project$Translations$CardDisplayOrder$sortingByReverseAlphabetical = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByReverseAlphabetical');
};
var $author$project$Translations$CardDisplayOrder$sortingByTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByTitle');
};
var $author$project$Translations$CardDisplayOrder$sortingByViewCount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cardDisplayOrder.sortingByViewCount');
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Main$searchControl = function (search) {
	return function (sortField) {
		return function (sortOrder) {
			return function (translations) {
				return function (placeholderText) {
					return function (supportsFilter) {
						return function (filterActive) {
							return function (width) {
								return function (height) {
									return function (page) {
										return function (modalOpen) {
											var sortIcon = (sortOrder === 'desc') ? 'sortDescending' : 'sortAscending';
											var sortFieldValue = (sortField === 'relevance') ? $author$project$Translations$CardDisplayOrder$sortByRelevance(translations) : ((sortField === 'created') ? $author$project$Translations$CardDisplayOrder$sortByDateDeployed(translations) : ((sortField === 'numviews') ? $author$project$Translations$CardDisplayOrder$sortByViewCount(translations) : $author$project$Translations$CardDisplayOrder$sortByTitle(translations)));
											var sortButtonLabel = (_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) < 1) ? '' : sortFieldValue;
											var searchInputCSS = (modalOpen && (_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) < 1)) ? 'input-group' : 'input-group input-group-override';
											var isActive = filterActive ? 'active' : 'notActive';
											var hasText = (_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) < 1) ? 'notHasText' : 'hasText';
											var filterButtonValue = $author$project$Translations$Filters$filterButton(translations);
											var filterButtonLabel = (_Utils_cmp(width, $author$project$Main$mobileWidthThreshold) < 1) ? '' : filterButtonValue;
											var filterButton = supportsFilter ? 'filter-btn sort-control flex visible' : 'filter-btn hide invisible';
											var clearButton = ($elm$core$String$length(search) > 0) ? 'clear-btn visible' : 'clear-btn hide invisible';
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('solutions-search')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('grid-container')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class(searchInputCSS)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$input,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('solutions-search-large input-group-input input-search input-minimal'),
																				$elm$html$Html$Attributes$type_('search'),
																				$elm$html$Html$Attributes$placeholder(placeholderText),
																				A2($elm$html$Html$Attributes$attribute, 'aria-label', placeholderText),
																				$elm$html$Html$Attributes$value(search),
																				$elm$html$Html$Events$onInput($author$project$Main$SearchText),
																				$author$project$Main$onEnter(
																				$author$project$Main$Search(search))
																			]),
																		_List_Nil),
																		A2(
																		$author$project$Main$calciteButton,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(clearButton),
																				A2($elm$html$Html$Attributes$attribute, 'appearance', 'transparent'),
																				A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
																				A2($elm$html$Html$Attributes$attribute, 'scale', 'xs'),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'aria-label',
																				$author$project$Translations$Search$clearSearch(translations)),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'label',
																				$author$project$Translations$Search$clearSearch(translations)),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'title',
																				$author$project$Translations$Search$clearSearch(translations)),
																				$elm$html$Html$Events$onClick($author$project$Main$ClearText)
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Main$calciteIcon,
																				_List_fromArray(
																					[
																						A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
																						A2($elm$html$Html$Attributes$attribute, 'icon', 'x')
																					]),
																				_List_Nil)
																			])),
																		function () {
																		var widthThreshold = 23;
																		var text_sortDirectionReverseAlphabetical = $author$project$Translations$CardDisplayOrder$sortDirectionReverseAlphabetical(translations);
																		var text_sortDirectionMostViews = $author$project$Translations$CardDisplayOrder$sortDirectionMostViews(translations);
																		var text_sortDirectionMostRecent = $author$project$Translations$CardDisplayOrder$sortDirectionMostRecent(translations);
																		var text_sortDirectionLeastViews = $author$project$Translations$CardDisplayOrder$sortDirectionLeastViews(translations);
																		var text_sortDirectionLeastRecent = $author$project$Translations$CardDisplayOrder$sortDirectionLeastRecent(translations);
																		var text_sortDirectionAlphabetical = $author$project$Translations$CardDisplayOrder$sortDirectionAlphabetical(translations);
																		var text_sortDirection = $author$project$Translations$CardDisplayOrder$sortDirection(translations);
																		var text_sortByViewCount = $author$project$Translations$CardDisplayOrder$sortByViewCount(translations);
																		var text_sortByTitle = $author$project$Translations$CardDisplayOrder$sortByTitle(translations);
																		var text_sortByRelevance = $author$project$Translations$CardDisplayOrder$sortByRelevance(translations);
																		var text_sortByDateDeployed = $author$project$Translations$CardDisplayOrder$sortByDateDeployed(translations);
																		var text_sortBy = $author$project$Translations$CardDisplayOrder$sortBy(translations);
																		var maxMenuWidth = A2(
																			$elm$core$Maybe$withDefault,
																			widthThreshold,
																			$elm$core$List$maximum(
																				_List_fromArray(
																					[
																						$elm$core$String$length(text_sortBy),
																						$elm$core$String$length(text_sortByRelevance),
																						$elm$core$String$length(text_sortByDateDeployed),
																						$elm$core$String$length(text_sortByViewCount),
																						$elm$core$String$length(text_sortByTitle),
																						$elm$core$String$length(text_sortDirection),
																						$elm$core$String$length(text_sortDirectionLeastRecent),
																						$elm$core$String$length(text_sortDirectionAlphabetical),
																						$elm$core$String$length(text_sortDirectionMostRecent),
																						$elm$core$String$length(text_sortDirectionMostViews),
																						$elm$core$String$length(text_sortDirectionLeastViews),
																						$elm$core$String$length(text_sortDirectionReverseAlphabetical)
																					])));
																		var menuDisplayWidth = (_Utils_cmp(maxMenuWidth, widthThreshold) > 0) ? 'l' : 'm';
																		var maxItems = (!height) ? '0' : ((height < 240) ? '2' : ((height < 360) ? '3' : ((height < 390) ? '4' : '0')));
																		var a11y_sortDirectionReverseAlphabetical = $author$project$Translations$CardDisplayOrder$sortingByReverseAlphabetical(translations);
																		var a11y_sortDirectionMostViews = $author$project$Translations$CardDisplayOrder$sortingByMostToLeastViews(translations);
																		var a11y_sortDirectionLeastViews = $author$project$Translations$CardDisplayOrder$sortingByLeastToMostViews(translations);
																		var a11y_sortDirectionAlphabetical = $author$project$Translations$CardDisplayOrder$sortingByAlphabetical(translations);
																		var sortOrderItems = function () {
																			var sortDescText = (sortField === 'title') ? text_sortDirectionReverseAlphabetical : ((sortField === 'created') ? text_sortDirectionMostRecent : text_sortDirectionMostViews);
																			var sortDescA11y = (sortField === 'title') ? a11y_sortDirectionReverseAlphabetical : ((sortField === 'created') ? text_sortDirectionMostRecent : a11y_sortDirectionMostViews);
																			var sortAscText = (sortField === 'title') ? text_sortDirectionAlphabetical : ((sortField === 'created') ? text_sortDirectionLeastRecent : text_sortDirectionLeastViews);
																			var sortAscA11y = (sortField === 'title') ? a11y_sortDirectionAlphabetical : ((sortField === 'created') ? text_sortDirectionLeastRecent : a11y_sortDirectionLeastViews);
																			return ((sortField === 'numviews') || ((sortField === 'title') || (sortField === 'created'))) ? A2(
																				$author$project$Main$calciteDropdownGroup,
																				_List_fromArray(
																					[
																						A2($elm$html$Html$Attributes$attribute, 'group-title', text_sortDirection),
																						$author$project$Main$onCalciteDropdownItemSelected($author$project$Main$SortChange)
																					]),
																				_List_fromArray(
																					[
																						A4($author$project$Main$sortOrderItem, sortOrder, sortAscText, sortAscA11y, 'asc'),
																						A4($author$project$Main$sortOrderItem, sortOrder, sortDescText, sortDescA11y, 'desc')
																					])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
																		}();
																		var a11y_sortByViewCount = $author$project$Translations$CardDisplayOrder$sortingByViewCount(translations);
																		var a11y_sortByTitle = $author$project$Translations$CardDisplayOrder$sortingByTitle(translations);
																		var a11y_sortByRelevance = $author$project$Translations$CardDisplayOrder$sortingByRelevance(translations);
																		var a11y_sortByDateDeployed = $author$project$Translations$CardDisplayOrder$sortingByDateDeployed(translations);
																		var sortFieldItems = (!page) ? _List_fromArray(
																			[
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByRelevance, a11y_sortByRelevance, 'relevance'),
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByTitle, a11y_sortByTitle, 'title'),
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByViewCount, a11y_sortByViewCount, 'numviews')
																			]) : _List_fromArray(
																			[
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByDateDeployed, a11y_sortByDateDeployed, 'created'),
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByRelevance, a11y_sortByRelevance, 'relevance'),
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByTitle, a11y_sortByTitle, 'title'),
																				A4($author$project$Main$sortFieldItem, sortField, text_sortByViewCount, a11y_sortByViewCount, 'numviews')
																			]);
																		return A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('sort-control-container')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$author$project$Main$calciteDropdown,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('sort-control-dropdown'),
																							A2($elm$html$Html$Attributes$attribute, 'alignment', 'end'),
																							A2($elm$html$Html$Attributes$attribute, 'width-scale', menuDisplayWidth),
																							A2($elm$html$Html$Attributes$attribute, 'max-items', maxItems)
																						]),
																					_List_fromArray(
																						[
																							A2(
																							$author$project$Main$calciteButton,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('sort-control'),
																									A2($elm$html$Html$Attributes$attribute, 'slot', 'trigger'),
																									A2($elm$html$Html$Attributes$attribute, 'appearance', 'transparent'),
																									A2($elm$html$Html$Attributes$attribute, 'icon-start', sortIcon),
																									A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
																									A2($elm$html$Html$Attributes$attribute, hasText, ''),
																									A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
																									A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite'),
																									A2($elm$html$Html$Attributes$attribute, 'aria-atomic', 'true'),
																									A2($elm$html$Html$Attributes$attribute, 'aria-label', text_sortBy),
																									A2($elm$html$Html$Attributes$attribute, 'label', text_sortBy),
																									A2($elm$html$Html$Attributes$attribute, 'title', text_sortBy)
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text(sortButtonLabel)
																								])),
																							A2(
																							$author$project$Main$calciteDropdownGroup,
																							_List_fromArray(
																								[
																									A2($elm$html$Html$Attributes$attribute, 'group-title', text_sortBy),
																									$author$project$Main$onCalciteDropdownItemSelected($author$project$Main$SortChange)
																								]),
																							sortFieldItems),
																							sortOrderItems
																						]))
																				]));
																	}(),
																		A2(
																		$author$project$Main$calciteButton,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(filterButton),
																				A2($elm$html$Html$Attributes$attribute, 'appearance', 'transparent'),
																				A2($elm$html$Html$Attributes$attribute, 'icon-start', 'sliders'),
																				A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
																				A2($elm$html$Html$Attributes$attribute, isActive, ''),
																				A2($elm$html$Html$Attributes$attribute, hasText, ''),
																				A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'aria-label',
																				$author$project$Translations$Filters$filterButton(translations)),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'label',
																				$author$project$Translations$Filters$filterButton(translations)),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'title',
																				$author$project$Translations$Filters$filterButton(translations)),
																				$elm$html$Html$Events$onClick($author$project$Main$ToggleFilter)
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(filterButtonLabel)
																			]))
																	]))
															]))
													]));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Translations$Search$searchMyArcGISSolutions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'search.searchMyArcGISSolutions');
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Main$CloseCard = {$: 25};
var $author$project$Main$NoOp = {$: 0};
var $author$project$Main$ShowLastActiveCard = {$: 23};
var $author$project$Main$ShowNextOptions = function (a) {
	return {$: 50, a: a};
};
var $author$project$Translations$Cards$back = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.back');
};
var $author$project$Main$calciteModal = $elm$html$Html$node('calcite-modal');
var $author$project$Translations$Cards$close = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.close');
};
var $author$project$Translations$Cards$deploy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.deploy');
};
var $ChristophP$elm_i18next$I18Next$Curly = {$: 0};
var $ChristophP$elm_i18next$I18Next$delimsToTuple = function (delims) {
	switch (delims.$) {
		case 0:
			return _Utils_Tuple2('{{', '}}');
		case 1:
			return _Utils_Tuple2('__', '__');
		default:
			var tuple = delims.a;
			return tuple;
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $ChristophP$elm_i18next$I18Next$replacePlaceholders = F3(
	function (replacements, delims, str) {
		var _v0 = $ChristophP$elm_i18next$I18Next$delimsToTuple(delims);
		var start = _v0.a;
		var end = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(
						$elm$core$String$replace,
						_Utils_ap(
							start,
							_Utils_ap(key, end)),
						value,
						acc);
				}),
			str,
			replacements);
	});
var $ChristophP$elm_i18next$I18Next$tr = F4(
	function (_v0, delims, key, replacements) {
		var translations = _v0;
		var _v1 = A2($elm$core$Dict$get, key, translations);
		if (!_v1.$) {
			var str = _v1.a;
			return A3($ChristophP$elm_i18next$I18Next$replacePlaceholders, replacements, delims, str);
		} else {
			return key;
		}
	});
var $author$project$Translations$Cards$deploySolution = F2(
	function (translations, solutionTitle) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'cards.deploySolution',
			_List_fromArray(
				[
					_Utils_Tuple2('solutionTitle', solutionTitle)
				]));
	});
var $author$project$Translations$Cards$getNow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.getNow');
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Translations$Cards$next = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.next');
};
var $author$project$Main$calciteAccordion = $elm$html$Html$node('calcite-accordion');
var $author$project$Main$calciteLabel = $elm$html$Html$node('calcite-label');
var $author$project$Main$calciteLink = $elm$html$Html$node('calcite-link');
var $author$project$Translations$Configure$featureServiceInfo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'configure.featureServiceInfo');
};
var $author$project$Main$calciteAccordionItem = $elm$html$Html$node('calcite-accordion-item');
var $author$project$Main$InputChanged = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Main$calciteColorPicker = $elm$html$Html$node('calcite-color-picker');
var $author$project$Main$getAttributes = function (userProp) {
	var attributeList = $elm$core$Dict$toList(userProp.dZ);
	var attributes = ($elm$core$List$length(attributeList) > 0) ? A2(
		$elm$core$List$map,
		function (_v0) {
			var k = _v0.a;
			var val = _v0.b;
			return A2($elm$html$Html$Attributes$attribute, k, val);
		},
		attributeList) : _List_Nil;
	return attributes;
};
var $author$project$Main$colorControl = function (userProp) {
	var id = $author$project$Main$getId(userProp);
	var control = A2(
		$author$project$Main$calciteColorPicker,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Main$InputChanged, userProp, id)),
					A2($elm$html$Html$Attributes$attribute, 'id', id)
				]),
			$author$project$Main$getAttributes(userProp)),
		_List_Nil);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('configure-control')
			]),
		_List_fromArray(
			[control]));
};
var $author$project$Main$calciteCombobox = $elm$html$Html$node('calcite-combobox');
var $author$project$Main$calciteComboboxItem = $elm$html$Html$node('calcite-combobox-item');
var $author$project$Main$onCalciteComboboxItemChange = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'calciteComboboxItemChange',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'attributes', 'value', 'value']),
				$elm$json$Json$Decode$string)));
};
var $author$project$Main$getComboboxItem = F2(
	function (userProp, value) {
		return A2(
			$author$project$Main$calciteComboboxItem,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('combobox-item'),
					A2($elm$html$Html$Attributes$attribute, 'value', value),
					A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
					A2($elm$html$Html$Attributes$attribute, 'text-label', value),
					$author$project$Main$onCalciteComboboxItemChange(
					$author$project$Main$InputChanged(userProp))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Main$getComboboxItems = F2(
	function (userProp, choices) {
		return A2(
			$elm$core$List$map,
			$author$project$Main$getComboboxItem(userProp),
			choices);
	});
var $author$project$Main$comboboxControl = function (userProp) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('configure-control')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Main$calciteCombobox,
				A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('calcite-combobox'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'id',
							$author$project$Main$getId(userProp)),
							A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
							A2($elm$html$Html$Attributes$attribute, 'type', 'combobox')
						]),
					$author$project$Main$getAttributes(userProp)),
				A2($author$project$Main$getComboboxItems, userProp, userProp.d9))
			]));
};
var $author$project$Main$calciteDatePicker = $elm$html$Html$node('calcite-date-picker');
var $author$project$Main$onCalciteDateChange = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'calciteDateChange',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'value']),
				$elm$json$Json$Decode$string)));
};
var $author$project$Main$dateControl = F2(
	function (userProp, v) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configure-control')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Main$calciteDatePicker,
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('date-input'),
								A2($elm$html$Html$Attributes$attribute, 'value', v),
								A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
								$author$project$Main$onCalciteDateChange(
								$author$project$Main$InputChanged(userProp)),
								A2(
								$elm$html$Html$Attributes$attribute,
								'id',
								$author$project$Main$getId(userProp)),
								A2($elm$html$Html$Attributes$attribute, 'type', 'date')
							]),
						$author$project$Main$getAttributes(userProp)),
					_List_fromArray(
						[
							$elm$html$Html$text(v)
						]))
				]));
	});
var $author$project$Main$getDropdownItem = function (value) {
	return A2(
		$author$project$Main$calciteDropdownItem,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item'),
				A2($elm$html$Html$Attributes$attribute, 'value', value),
				A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
				A2($elm$html$Html$Attributes$attribute, 'primary-text', value)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(value)
			]));
};
var $author$project$Main$getDropdownItems = function (choices) {
	return A2($elm$core$List$map, $author$project$Main$getDropdownItem, choices);
};
var $author$project$Main$dropdownControl = function (userProp) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('configure-control')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Main$calciteDropdown,
				A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-input')
						]),
					$author$project$Main$getAttributes(userProp)),
				_List_fromArray(
					[
						A2(
						$author$project$Main$calciteButton,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-control'),
								A2($elm$html$Html$Attributes$attribute, 'slot', 'dropdown-trigger'),
								A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
								A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite'),
								A2($elm$html$Html$Attributes$attribute, 'aria-atomic', 'true'),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', userProp.eB),
								A2(
								$elm$html$Html$Attributes$attribute,
								'id',
								$author$project$Main$getId(userProp)),
								A2($elm$html$Html$Attributes$attribute, 'type', 'dropdown')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(userProp.eB)
							])),
						A2(
						$author$project$Main$calciteDropdownGroup,
						_List_fromArray(
							[
								$author$project$Main$onCalciteDropdownItemSelected(
								$author$project$Main$InputChanged(userProp))
							]),
						$author$project$Main$getDropdownItems(userProp.d9))
					]))
			]));
};
var $author$project$Main$getValidationOptions = F2(
	function (userProp, v) {
		var validation = userProp.fu;
		var valid = A2($author$project$Main$isValidFormat, userProp, v);
		var status = valid ? 'valid' : 'invalid';
		var requiredSet = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, 'required', userProp.dZ));
		var required = requiredSet === 'true';
		var messageStyle = (required || (status === 'invalid')) ? 'initial' : 'none';
		var message = valid ? '' : A2(
			$elm$core$Maybe$withDefault,
			'Value required',
			A2($elm$core$Dict$get, 'message', validation));
		return {eB: '', bX: message, bY: messageStyle, du: required, bE: status};
	});
var $author$project$Main$ClearItemIdControl = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$ValidateID = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Main$calciteInput = $elm$html$Html$node('calcite-input');
var $author$project$Main$calciteInputMessage = $elm$html$Html$node('calcite-input-message');
var $author$project$Translations$Configure$invalidID = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'configure.invalidID');
};
var $author$project$Translations$Configure$itemIdPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'configure.itemIdPlaceholder');
};
var $author$project$Main$onCalciteInputInput = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'calciteInputInput',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'value']),
				$elm$json$Json$Decode$string)));
};
var $author$project$Main$itemIdControl = F3(
	function (userProp, v, translations) {
		var valid = A2($author$project$Main$isValidFormat, userProp, v);
		var tooltip = (userProp.fn !== '') ? A2(
			$author$project$Main$calciteIcon,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'scale', 's'),
					A2($elm$html$Html$Attributes$attribute, 'icon', 'information-f'),
					$elm$html$Html$Attributes$class('configure-toolip configure-control-validate-icon'),
					A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
					A2($elm$html$Html$Attributes$attribute, 'title', userProp.fn)
				]),
			_List_Nil) : $elm$html$Html$text('');
		var status = (((!valid) || (!userProp.ft)) && (v !== '')) ? 'invalid' : 'idle';
		var messageNode = (userProp.ft && valid) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'href', userProp.aq),
					A2($elm$html$Html$Attributes$attribute, 'target', '_blank'),
					$elm$html$Html$Attributes$class('configure-control-link-no-underline configure-text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(userProp.G)
				])) : ((((!valid) || (!userProp.ft)) && (v !== '')) ? A2(
			$author$project$Main$calciteInputMessage,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'active', ''),
					A2($elm$html$Html$Attributes$attribute, 'status', 'invalid'),
					A2($elm$html$Html$Attributes$style, 'display', 'initial'),
					$elm$html$Html$Attributes$class('configure-text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Configure$invalidID(translations))
				])) : A2($elm$html$Html$div, _List_Nil, _List_Nil));
		var isLoading = userProp.eE ? 'true' : 'false';
		var iconNodeDisplay = (((valid && userProp.ft) && (v !== '')) || (((!valid) || (!userProp.ft)) && (v !== ''))) ? 'inline-flex' : 'none';
		var iconColor = userProp.ft ? 'valid-color' : 'invalid-color';
		var icon = userProp.ft ? 'check-circle' : 'exclamation-mark-triangle';
		var clearBtn = ($elm$core$String$length(v) > 0) ? A2(
			$author$project$Main$calciteButton,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
					A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
					A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
					A2($elm$html$Html$Attributes$attribute, 'icon-start', 'x'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-label',
					$author$project$Translations$Search$clearSearch(translations)),
					$elm$html$Html$Events$onClick(
					$author$project$Main$ClearItemIdControl(userProp)),
					A2($elm$html$Html$Attributes$attribute, 'slot', 'action')
				]),
			_List_Nil) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configure-sub-control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Main$calciteLabel,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('configure-control-main-label configure-icon-label'),
									A2($elm$html$Html$Attributes$attribute, 'status', status),
									A2($elm$html$Html$Attributes$attribute, 'layout', 'inline'),
									A2($elm$html$Html$Attributes$attribute, 'scale', 's')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('configure-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(userProp.eB)
										])),
									tooltip
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configure-control-pad-bottom flex')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Main$calciteInput,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-child'),
									A2($elm$html$Html$Attributes$attribute, 'type', 'text'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'placeholder',
									$author$project$Translations$Configure$itemIdPlaceholder(translations)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-label',
									$author$project$Translations$Configure$itemIdPlaceholder(translations)),
									A2($elm$html$Html$Attributes$attribute, 'loading', isLoading),
									$author$project$Main$onCalciteInputInput(
									$author$project$Main$ValidateID(userProp)),
									A2($elm$html$Html$Attributes$attribute, 'value', v)
								]),
							_List_Nil),
							clearBtn
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Main$calciteIcon,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'scale', 's'),
									A2($elm$html$Html$Attributes$attribute, 'icon', icon),
									$elm$html$Html$Attributes$class(iconColor),
									$elm$html$Html$Attributes$class('configure-control-validate-icon'),
									A2($elm$html$Html$Attributes$style, 'display', iconNodeDisplay)
								]),
							_List_Nil),
							messageNode
						]))
				]));
	});
var $author$project$Main$SearchSpatialReferences = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Main$analysisSpatialReferenceSelector = $elm$html$Html$node('analysis-spatial-reference-selector');
var $author$project$Translations$Common$learnMore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'common.learnMore');
};
var $author$project$Main$onAnalysisSpatialReferenceValueChange = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'analysisSpatialReferenceValueChange',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'value', 'latestWkid']),
				$elm$json$Json$Decode$int)));
};
var $author$project$Translations$Configure$spatialReferenceInfo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'configure.spatialReferenceInfo');
};
var $author$project$Translations$Configure$spatialReferenceLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'configure.spatialReferenceLabel');
};
var $author$project$Main$spatialReferenceControl = F5(
	function (userProp, translations, isSearching, isEnterprise, indent) {
		var wkid = userProp.ef;
		var url = isEnterprise ? 'https://doc.arcgis.com/en/arcgis-solutions/latest/get-started/get-started-with-arcgis-enterprise.htm' : 'https://doc.arcgis.com/en/arcgis-solutions/latest/get-started/get-started-with-arcgis-online.htm';
		var search = userProp.ff;
		var label = $author$project$Translations$Configure$spatialReferenceLabel(translations);
		var isLoading = isSearching ? 'true' : 'false';
		var info = $author$project$Translations$Configure$spatialReferenceInfo(translations);
		var indentClass = indent ? 'configure-control' : '';
		var help = $author$project$Translations$Common$learnMore(translations);
		var autoSelect = userProp.d_ && ((search === '') || _Utils_eq(search, userProp.ef));
		var autoFilter = autoSelect ? 'true' : 'false';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(indentClass),
					A2($elm$html$Html$Attributes$style, 'height', '375px')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Main$calciteLabel,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configure-control-main-label configure-control-big-label'),
							A2($elm$html$Html$Attributes$attribute, 'scale', 's'),
							A2($elm$html$Html$Attributes$attribute, 'layout', 'inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('configure-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('configure-control-sr-info configure-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(info + ' '),
							A2(
							$author$project$Main$calciteLink,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'href', url),
									A2($elm$html$Html$Attributes$attribute, 'target', '_blank'),
									$elm$html$Html$Attributes$class('configure-control-link-no-underline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(help)
								]))
						])),
					A2(
					$author$project$Main$analysisSpatialReferenceSelector,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'default-wkid', wkid),
							A2($elm$html$Html$Attributes$attribute, 'hide-done', 'true'),
							A2($elm$html$Html$Attributes$attribute, 'auto-filter-to-default', autoFilter),
							A2($elm$html$Html$Attributes$attribute, 'id', 'SpatialReferenceControl'),
							$elm$html$Html$Attributes$class('spatial-reference-selector'),
							$author$project$Main$onAnalysisSpatialReferenceValueChange(
							$author$project$Main$SearchSpatialReferences(userProp))
						]),
					_List_Nil)
				]));
	});
var $author$project$Main$SwitchChanged = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Main$calciteSwitch = $elm$html$Html$node('calcite-switch');
var $author$project$Main$onCalciteSwitchChange = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'calciteSwitchChange',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'checked']),
				$elm$json$Json$Decode$bool)));
};
var $author$project$Main$switchControl = F2(
	function (userProp, v) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configure-control')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Main$calciteSwitch,
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('switch-item'),
								$author$project$Main$onCalciteSwitchChange(
								$author$project$Main$SwitchChanged(userProp)),
								A2(
								$elm$html$Html$Attributes$attribute,
								'id',
								$author$project$Main$getId(userProp)),
								A2($elm$html$Html$Attributes$attribute, 'type', 'switch'),
								A2(
								$elm$html$Html$Attributes$attribute,
								'checked',
								$elm$core$String$toLower(v))
							]),
						$author$project$Main$getAttributes(userProp)),
					_List_Nil)
				]));
	});
var $author$project$Main$textControl = F3(
	function (userProp, v, validationOptions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configure-control')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Main$calciteLabel,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'status', validationOptions.bE)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(validationOptions.eB),
							A2(
							$author$project$Main$calciteInput,
							A2(
								$elm$core$List$append,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-input'),
										A2(
										$elm$html$Html$Attributes$attribute,
										'id',
										$author$project$Main$getId(userProp)),
										A2($elm$html$Html$Attributes$attribute, 'value', v),
										$author$project$Main$onCalciteInputInput(
										$author$project$Main$InputChanged(userProp))
									]),
								$author$project$Main$getAttributes(userProp)),
							_List_Nil),
							A2(
							$author$project$Main$calciteInputMessage,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'active', ''),
									A2($elm$html$Html$Attributes$attribute, 'icon', ''),
									A2($elm$html$Html$Attributes$attribute, 'status', validationOptions.bE),
									A2($elm$html$Html$Attributes$style, 'display', validationOptions.bY)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(validationOptions.bX)
								]))
						]))
				]));
	});
var $author$project$Main$getControl = F5(
	function (translations, isSearching, userProp, isEnterprise, indent) {
		var value = userProp.fv;
		var validationOptions = A2($author$project$Main$getValidationOptions, userProp, value);
		var _v0 = $elm$core$String$toLower(userProp.fw);
		switch (_v0) {
			case 'color':
				return $author$project$Main$colorControl(userProp);
			case 'combobox':
				return $author$project$Main$comboboxControl(userProp);
			case 'date':
				return A2($author$project$Main$dateControl, userProp, value);
			case 'dropdown':
				return $author$project$Main$dropdownControl(userProp);
			case 'switch':
				return A2($author$project$Main$switchControl, userProp, value);
			case 'text':
				return A3($author$project$Main$textControl, userProp, value, validationOptions);
			case 'itemid':
				return A3($author$project$Main$itemIdControl, userProp, value, translations);
			case 'spatialreference':
				return A5($author$project$Main$spatialReferenceControl, userProp, translations, isSearching, isEnterprise, indent);
			default:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Main$getAccordionItem = F5(
	function (translations, isSearching, userProp, isEnterprise, indent) {
		var valid = A2($author$project$Main$isValidFormat, userProp, userProp.fv);
		var label = (userProp.fw === 'spatialReference') ? $author$project$Translations$Configure$spatialReferenceLabel(translations) : userProp.eB;
		var icon = valid ? '' : 'exclamation-mark-triangle';
		return A2(
			$author$project$Main$calciteAccordionItem,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'item-title', label),
					A2($elm$html$Html$Attributes$attribute, 'icon-position', 'end'),
					A2($elm$html$Html$Attributes$attribute, 'icon', icon)
				]),
			_List_fromArray(
				[
					A5($author$project$Main$getControl, translations, isSearching, userProp, isEnterprise, indent)
				]));
	});
var $author$project$Translations$Configure$servicesLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'configure.servicesLabel');
};
var $author$project$Main$getTab = F7(
	function (userOption, index, visibleIndex, translations, isSearching, isEnterprise, learnMore) {
		var otherProps = A2(
			$elm$core$List$filter,
			function (p) {
				return p.fw !== 'itemid';
			},
			userOption.e6);
		var hasItemIds = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (userProp) {
					return userProp.fw === 'itemid';
				},
				userOption.e6)) > 0;
		var infoClass = hasItemIds ? 'configure-control-feature-service-parent' : '';
		var fsProps = A2(
			$elm$core$List$filter,
			function (p) {
				return p.fw === 'itemid';
			},
			userOption.e6);
		var display = _Utils_eq(index, visibleIndex) ? 'display-block' : 'display-none';
		var accordionDisplay = userOption.dV;
		var fsNode = hasItemIds ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configure-tab ' + display),
					A2($elm$html$Html$Attributes$attribute, 'id', userOption.aa + '_fs')
				]),
			(!accordionDisplay) ? A2(
				$elm$core$List$map,
				function (p) {
					return A5($author$project$Main$getControl, translations, isSearching, p, isEnterprise, false);
				},
				fsProps) : _List_fromArray(
				[
					A2(
					$author$project$Main$calciteAccordion,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'icon-type', 'chevron')
						]),
					A2(
						$elm$core$List$map,
						function (p) {
							return A5($author$project$Main$getAccordionItem, translations, isSearching, p, isEnterprise, false);
						},
						fsProps))
				])) : $elm$html$Html$text('');
		var otherNode = ($elm$core$List$length(otherProps) > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('configure-tab ' + display),
					A2($elm$html$Html$Attributes$attribute, 'id', userOption.aa)
				]),
			(!accordionDisplay) ? A2(
				$elm$core$List$map,
				function (p) {
					return A5($author$project$Main$getControl, translations, isSearching, p, isEnterprise, !hasItemIds);
				},
				otherProps) : _List_fromArray(
				[
					A2(
					$author$project$Main$calciteAccordion,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'icon-type', 'chevron')
						]),
					A2(
						$elm$core$List$map,
						function (p) {
							return A5($author$project$Main$getAccordionItem, translations, isSearching, p, isEnterprise, !hasItemIds);
						},
						otherProps))
				])) : $elm$html$Html$text('');
		var displayNode = hasItemIds ? _List_fromArray(
			[
				A2(
				$author$project$Main$calciteLabel,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('configure-control-main-label configure-control-big-label'),
						A2($elm$html$Html$Attributes$attribute, 'scale', 's'),
						A2($elm$html$Html$Attributes$attribute, 'layout', 'inline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('configure-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Configure$servicesLabel(translations))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('configure-control-sr-info configure-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Configure$featureServiceInfo(translations) + ' '),
						A2(
						$author$project$Main$calciteLink,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'href', learnMore),
								A2($elm$html$Html$Attributes$attribute, 'target', '_blank'),
								$elm$html$Html$Attributes$class('configure-control-link-no-underline')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Common$learnMore(translations))
							]))
					])),
				fsNode,
				otherNode
			]) : _List_fromArray(
			[otherNode]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(infoClass)
				]),
			displayNode);
	});
var $author$project$Main$viewModalConfigure = F5(
	function (card, visibleIndex, translations, isSearching, isEnterprise) {
		var templateInfo = card.dL;
		var userOptions = templateInfo.dO;
		var configureModalLearnMore = templateInfo.cl;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, userOption) {
							return A7($author$project$Main$getTab, userOption, i, visibleIndex, translations, isSearching, isEnterprise, configureModalLearnMore);
						}),
					userOptions))
			]);
	});
var $author$project$Main$NextPreviewImage = {$: 34};
var $author$project$Main$PreviousPreviewImage = {$: 33};
var $author$project$Main$RequestUpdateUrlSearch = {$: 2};
var $author$project$Main$WaitForNextStep = {$: 24};
var $author$project$Translations$Cards$agolName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.agolName');
};
var $author$project$Translations$Cards$availableFor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.availableFor');
};
var $author$project$Main$calciteBlock = $elm$html$Html$node('calcite-block');
var $author$project$Main$calciteFloatingActionButton = $elm$html$Html$node('calcite-fab');
var $author$project$Main$calciteNotice = $elm$html$Html$node('calcite-notice');
var $author$project$Main$calcitePopover = $elm$html$Html$node('calcite-popover');
var $author$project$Main$calciteTab = $elm$html$Html$node('calcite-tab');
var $author$project$Main$calciteTabNav = $elm$html$Html$node('calcite-tab-nav');
var $author$project$Main$calciteTabTitle = $elm$html$Html$node('calcite-tab-title');
var $author$project$Main$calciteTabs = $elm$html$Html$node('calcite-tabs');
var $author$project$Translations$Cards$deployNow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.deployNow');
};
var $author$project$Translations$Cards$developedFor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.developedFor');
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Translations$Cards$enterpriseName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.enterpriseName');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$addMembers = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.addMembers');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$createGroup = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.createGroup');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$createItem = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.createItem');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$hubPremium = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.hubPremium');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishBigDataAnalytics = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.publishBigDataAnalytics');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishFeatures = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.publishFeatures');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishFeeds = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.publishFeeds');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishGPServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.publishGPServices');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishRealTimeAnalytics = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.publishRealTimeAnalytics');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresAdmin = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.requiresAdmin');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresLocationTracking = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.requiresLocationTracking');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresLocationTrackingAndAdmin = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.requiresLocationTrackingAndAdmin');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresNotebookServer = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.requiresNotebookServer');
};
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {ck: col, ec: contextStack, dl: problem, dw: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.dw, s.ck, x, s.h));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.d, s.c);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{ck: 1, h: s.h, j: s.j, d: s.d + 1, dw: s.dw + 1, c: s.c}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{ck: s.ck + 1, h: s.h, j: s.j, d: newOffset, dw: s.dw, c: s.c}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.c);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.d, offset) < 0,
					0,
					{ck: col, h: s0.h, j: s0.j, d: offset, dw: row, c: s0.c});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.d, s.dw, s.ck, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.d, s1.d, s0.c),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.d, s.dw, s.ck, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.h)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, newOffset) < 0,
			0,
			{ck: newCol, h: s.h, j: s.j, d: newOffset, dw: newRow, c: s.c});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.d, s.dw, s.ck, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{ck: newCol, h: s.h, j: s.j, d: newOffset, dw: newRow, c: s.c});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {ck: s.ck + (newOffset - s.d), h: s.h, j: s.j, d: newOffset, dw: s.dw, c: s.c};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.d, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.c);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.dw, s.ck - (floatOffset + s.d), invalid, s.h));
		} else {
			if (_Utils_eq(s.d, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.d, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.d, floatOffset, s.c));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.d, s.c)) {
			var zeroOffset = s.d + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.ex,
				c.cH,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.c),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.ex,
				c.c0,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.c),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.c) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.ex,
				c.ch,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.c),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.ex,
				c.cx,
				c.cM,
				c.cz,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.ex,
				c.cx,
				c.cM,
				c.cz,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.d, s.c),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				ch: $elm$core$Result$Err(invalid),
				cx: expecting,
				cz: $elm$core$Result$Err(invalid),
				cH: $elm$core$Result$Err(invalid),
				cM: $elm$core$Result$Ok($elm$core$Basics$identity),
				ex: invalid,
				c0: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {ck: col, dl: problem, dw: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.dw, p.ck, p.dl);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{ck: 1, h: _List_Nil, j: 1, d: 0, dw: 1, c: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$shareToGroup = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.shareToGroup');
};
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$velocity = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.velocity');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$workflowManager = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.workflowManager');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$writableEnterprise = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.writableEnterprise');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$writableOnline = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.requiredPrivilegesList.writableOnline');
};
var $author$project$Main$getPrivilegeCodeDisplay = F2(
	function (translations, tag) {
		switch (tag) {
			case 'portal:user:createItem':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$createItem(translations))
					]);
			case 'portal:publisher:publishFeatures':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishFeatures(translations))
					]);
			case 'portal:user:createGroup':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$createGroup(translations))
					]);
			case 'portal:user:shareToGroup':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$shareToGroup(translations))
					]);
			case 'portal:user:addExternalMembersToGroup':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$addMembers(translations))
					]);
			case 'portal:publisher:publishFeeds':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishFeeds(translations))
					]);
			case 'portal:publisher:publishBigDataAnalytics':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishBigDataAnalytics(translations))
					]);
			case 'portal:publisher:publishRealTimeAnalytics':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishRealTimeAnalytics(translations))
					]);
			case 'solutions:locationtracking:admin:tracking':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresLocationTrackingAndAdmin(translations))
					]);
			case 'solutions:locationtracking:tracking':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresLocationTracking(translations))
					]);
			case 'solutions:locationtracking:admin':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresAdmin(translations))
					]);
			case 'solutions:hubPremium':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$hubPremium(translations))
					]);
			case 'solutions:workflowManager':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$workflowManager(translations))
					]);
			case 'solutions:velocity':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$velocity(translations))
					]);
			case 'solutions:notebook':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$requiresNotebookServer(translations))
					]);
			case 'portal:publisher:publishServerGPServices':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$publishGPServices(translations))
					]);
			case 'writable:Enterprise':
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$writableEnterprise(translations))
					]);
			case 'writable:Online':
				var message = $author$project$Translations$Cards$MissingPrivilegesPopup$RequiredPrivilegesList$writableOnline(translations);
				var _v1 = $hecrj$html_parser$Html$Parser$run(message);
				if (!_v1.$) {
					var value = _v1.a;
					return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(value);
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text(message)
						]);
				}
			default:
				return _List_fromArray(
					[
						$elm$html$Html$text('')
					]);
		}
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Translations$Cards$MissingPrivilegesPopup$missingPrivilegesListHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.missingPrivilegesListHeading');
};
var $author$project$Translations$Cards$MissingPrivilegesPopup$suggestedProblemRemedyMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.missingPrivilegesPopup.suggestedProblemRemedyMessage');
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Main$getPrivilegeMessages = F3(
	function (translations, missingPrivileges, isEnterprise) {
		var workflowPrivilege = 'solutions:workflowManager';
		var workflowManagerMessages = A2(
			$elm$core$List$filter,
			function (p) {
				return A2($elm$core$String$contains, workflowPrivilege, p);
			},
			$elm$core$Set$toList(missingPrivileges));
		var velocityPrivilege = 'solutions:velocity';
		var velocityMessages = A2(
			$elm$core$List$filter,
			function (p) {
				return A2($elm$core$String$contains, velocityPrivilege, p);
			},
			$elm$core$Set$toList(missingPrivileges));
		var trackingPrivilege = 'solutions:locationtracking';
		var trackingMessages = A2(
			$elm$core$List$filter,
			function (p) {
				return A2($elm$core$String$contains, trackingPrivilege, p);
			},
			$elm$core$Set$toList(missingPrivileges));
		var tag = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(trackingMessages));
		var notebookPrivilege = 'solutions:notebook';
		var notebookMessages = A2(
			$elm$core$List$filter,
			function (p) {
				return A2($elm$core$String$contains, notebookPrivilege, p);
			},
			$elm$core$Set$toList(missingPrivileges));
		var learnMoreUrl = isEnterprise ? 'https://enterprise.arcgis.com/en/portal/latest/administer/windows/configure-location-tracking.htm' : 'https://doc.arcgis.com/en/arcgis-online/administer/configure-location-tracking.htm';
		var learnMore = (tag === 'solutions:locationtracking:admin') ? $elm$html$Html$text('') : A2(
			$author$project$Main$calciteLink,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'href', learnMoreUrl),
					A2($elm$html$Html$Attributes$attribute, 'target', '_blank'),
					$elm$html$Html$Attributes$class('configure-control-link-no-underline learn-more')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Common$learnMore(translations))
				]));
		var hubPrivilege = 'solutions:hubPremium';
		var privilegeMessages = A2(
			$elm$core$List$filter,
			function (p) {
				return (!A2($elm$core$String$contains, hubPrivilege, p)) && ((!A2($elm$core$String$contains, trackingPrivilege, p)) && ((!A2($elm$core$String$contains, workflowPrivilege, p)) && ((!A2($elm$core$String$contains, velocityPrivilege, p)) && (!A2($elm$core$String$contains, notebookPrivilege, p)))));
			},
			$elm$core$Set$toList(missingPrivileges));
		var privileges = ($elm$core$List$length(privilegeMessages) > 0) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Cards$MissingPrivilegesPopup$missingPrivilegesListHeading(translations))
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (privilege) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							A2($author$project$Main$getPrivilegeCodeDisplay, translations, privilege));
					},
					privilegeMessages))
			]) : _List_Nil;
		var hubMessages = A2(
			$elm$core$List$filter,
			function (p) {
				return A2($elm$core$String$contains, hubPrivilege, p);
			},
			$elm$core$Set$toList(missingPrivileges));
		var hasWorkflowMgrMessage = $elm$core$List$length(workflowManagerMessages) > 0;
		var workflowManager = hasWorkflowMgrMessage ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('margin-bottom-1')
					]),
				A2($author$project$Main$getPrivilegeCodeDisplay, translations, workflowPrivilege))
			]) : _List_Nil;
		var hasVelocityMessage = $elm$core$List$length(velocityMessages) > 0;
		var velocity = hasVelocityMessage ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('margin-bottom-1')
					]),
				A2($author$project$Main$getPrivilegeCodeDisplay, translations, velocityPrivilege))
			]) : _List_Nil;
		var hasTrackingMessage = $elm$core$List$length(trackingMessages) > 0;
		var tracking = hasTrackingMessage ? _Utils_ap(
			A2($author$project$Main$getPrivilegeCodeDisplay, translations, tag),
			_List_fromArray(
				[learnMore])) : _List_Nil;
		var hasPrivilegeMessages = $elm$core$List$length(privilegeMessages) > 0;
		var hasNotebookMessage = $elm$core$List$length(notebookMessages) > 0;
		var notebook = hasNotebookMessage ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('margin-bottom-1')
					]),
				A2($author$project$Main$getPrivilegeCodeDisplay, translations, notebookPrivilege))
			]) : _List_Nil;
		var hasHubMessage = $elm$core$List$length(hubMessages) > 0;
		var hub = hasHubMessage ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('margin-bottom-1')
					]),
				A2($author$project$Main$getPrivilegeCodeDisplay, translations, hubPrivilege))
			]) : _List_Nil;
		var messages = (hasVelocityMessage || (hasHubMessage || (hasTrackingMessage || (hasWorkflowMgrMessage || (hasPrivilegeMessages || hasNotebookMessage))))) ? _List_fromArray(
			[
				A2(
				$author$project$Main$calciteNotice,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('margin-bottom-20'),
						A2($elm$html$Html$Attributes$attribute, 'open', ''),
						A2($elm$html$Html$Attributes$attribute, 'closable', 'false'),
						A2($elm$html$Html$Attributes$attribute, 'width', 'full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'slot', 'message')
							]),
						_Utils_ap(
							velocity,
							_Utils_ap(
								notebook,
								_Utils_ap(
									hub,
									_Utils_ap(
										workflowManager,
										_Utils_ap(
											privileges,
											_Utils_ap(
												tracking,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Translations$Cards$MissingPrivilegesPopup$suggestedProblemRemedyMessage(translations))
															]))
													]))))))))
					]))
			]) : _List_Nil;
		return messages;
	});
var $author$project$Main$getYouTubeUrls = function (name) {
	return _Utils_Tuple2('https://img.youtube.com/vi/' + (name + '/mqdefault.jpg'), 'https://www.youtube.com/embed/' + name);
};
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Main$instantAppsSocialShare = $elm$html$Html$node('instant-apps-social-share');
var $author$project$Card$isEmptyCard = function (model) {
	return model.aa === '';
};
var $author$project$Translations$Common$learnMoreAbout = F2(
	function (translations, solutionTitle) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'common.learnMoreAbout',
			_List_fromArray(
				[
					_Utils_Tuple2('solutionTitle', solutionTitle)
				]));
	});
var $author$project$Translations$Cards$overview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.overview');
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Translations$Cards$share = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.share');
};
var $author$project$Translations$Alerts$shareToClipboardDone = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'alerts.shareToClipboardDone');
};
var $author$project$Translations$Cards$showNextImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.showNextImage');
};
var $author$project$Translations$Cards$showPreviousImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.showPreviousImage');
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Translations$Cards$termsOfUse = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.termsOfUse');
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Translations$Cards$version = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.version');
};
var $author$project$Translations$Cards$whatsIncluded = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.whatsIncluded');
};
var $author$project$Translations$Cards$youMayAlsoLike = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.youMayAlsoLike');
};
var $author$project$Main$viewModalInformation = function (heights) {
	return function (tree) {
		return function (translations) {
			return function (isRTL) {
				return function (activeCard) {
					return function (relatedSolutionDisplays) {
						return function (gallery) {
							return function (userPrivileges) {
								return function (missingPrivileges) {
									return function (nextStepQueuing) {
										return function (isEnterprise) {
											return function (isReadOnly) {
												return function (token) {
													return function (allTemplates) {
														var youMayAlsoLikeTitle = _List_fromArray(
															[
																A2(
																$author$project$Main$calciteTabTitle,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'id', 'solution-you-may-also-like')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Cards$youMayAlsoLike(translations))
																	]))
															]);
														var titles = _List_fromArray(
															[
																A2(
																$author$project$Main$calciteTabTitle,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'id', 'solution-overview')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Cards$overview(translations))
																	])),
																A2(
																$author$project$Main$calciteTabTitle,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'id', 'solution-whats-included')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Cards$whatsIncluded(translations))
																	]))
															]);
														var tabNav = $author$project$Main$calciteTabNav(
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$attribute, 'slot', 'title-group')
																]));
														var tabBase = $author$project$Main$calciteTabs(
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$attribute, 'scale', 'l'),
																	$elm$html$Html$Attributes$class('padding-start-end')
																]));
														var socialSharing = gallery ? _List_fromArray(
															[
																A2(
																$author$project$Main$calcitePopover,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'auto-close', 'true'),
																		A2($elm$html$Html$Attributes$attribute, 'label', 'List of social-sharing options'),
																		A2($elm$html$Html$Attributes$attribute, 'reference-element', 'share-popover-button'),
																		A2($elm$html$Html$Attributes$attribute, 'overlay-positioning', 'fixed')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Main$instantAppsSocialShare,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$attribute, 'display-tip-text', 'false'),
																				A2($elm$html$Html$Attributes$attribute, 'inline-success-popover-placement', 'bottom-trailing'),
																				A2($elm$html$Html$Attributes$attribute, 'mode', 'inline'),
																				A2($elm$html$Html$Attributes$attribute, 'shorten-share-url', 'true'),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'success-message',
																				$author$project$Translations$Alerts$shareToClipboardDone(translations)),
																				$elm$html$Html$Attributes$class('shareOptions')
																			]),
																		_List_Nil)
																	])),
																A2(
																$author$project$Main$calciteButton,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'alignment', 'center'),
																		A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
																		A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																		A2($elm$html$Html$Attributes$attribute, 'data-calcite-popover-reference', ''),
																		A2($elm$html$Html$Attributes$attribute, 'icon-end', 'share'),
																		A2($elm$html$Html$Attributes$attribute, 'id', 'share-popover-button'),
																		A2($elm$html$Html$Attributes$attribute, 'scale', 'l'),
																		A2($elm$html$Html$Attributes$attribute, 'width', 'auto'),
																		$elm$html$Html$Attributes$href('')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Cards$share(translations))
																	]))
															]) : _List_fromArray(
															[
																A2($elm$html$Html$span, _List_Nil, _List_Nil)
															]);
														var readOnlyMessage = isEnterprise ? A2($author$project$Main$getPrivilegeCodeDisplay, translations, 'writable:Enterprise') : A2($author$project$Main$getPrivilegeCodeDisplay, translations, 'writable:Online');
														var restrictionMessages = (isReadOnly && (token !== '')) ? _List_fromArray(
															[
																A2(
																$author$project$Main$calciteNotice,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('margin-bottom-20'),
																		A2($elm$html$Html$Attributes$attribute, 'open', ''),
																		A2($elm$html$Html$Attributes$attribute, 'closable', 'false'),
																		A2($elm$html$Html$Attributes$attribute, 'width', 'full')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$attribute, 'slot', 'message')
																			]),
																		readOnlyMessage)
																	]))
															]) : A3($author$project$Main$getPrivilegeMessages, translations, missingPrivileges, isEnterprise);
														var previousPreviewScrollArrowsVisibility = (($elm$core$List$length(activeCard.dj) > 1) && (activeCard.co > 0)) ? 'visible' : 'hidden';
														var numRelatedSolutions = $elm$core$List$length(relatedSolutionDisplays);
														var tabTitles = (numRelatedSolutions > 0) ? tabNav(
															_Utils_ap(titles, youMayAlsoLikeTitle)) : tabNav(titles);
														var nextPreviewScrollArrowsVisibility = (($elm$core$List$length(activeCard.dj) > 1) && (_Utils_cmp(
															activeCard.co,
															$elm$core$List$length(activeCard.dj) - 1) < 0)) ? 'visible' : 'hidden';
														var licenseInfoHtmlList = function () {
															if ($elm$core$String$length(activeCard.bW) > 0) {
																var _v5 = $hecrj$html_parser$Html$Parser$run(activeCard.bW);
																if (!_v5.$) {
																	var value = _v5.a;
																	return _List_fromArray(
																		[
																			A2(
																			$author$project$Main$calciteBlock,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$id('terms-of-use-title'),
																					A2($elm$html$Html$Attributes$attribute, 'collapsible', 'true'),
																					A2(
																					$elm$html$Html$Attributes$attribute,
																					'heading',
																					$author$project$Translations$Cards$termsOfUse(translations)),
																					$elm$html$Html$Attributes$class('terms-of-use')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('industry-listing-content-list license-terms-text')
																						]),
																					$hecrj$html_parser$Html$Parser$Util$toVirtualDom(value))
																				]))
																		]);
																} else {
																	return _List_fromArray(
																		[
																			$elm$html$Html$text(activeCard.bW)
																		]);
																}
															} else {
																return _List_Nil;
															}
														}();
														var learnMoreLink = ($elm$core$String$length(activeCard.bV) > 0) ? A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('learnMoreLink')
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Main$calciteLink,
																	_List_fromArray(
																		[
																			A2($elm$html$Html$Attributes$attribute, 'href', activeCard.bV),
																			A2($elm$html$Html$Attributes$attribute, 'target', '_blank')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($author$project$Translations$Common$learnMoreAbout, translations, activeCard.G))
																		]))
																])) : $elm$html$Html$text('');
														var isSignedIn = !$elm$core$Set$isEmpty(userPrivileges);
														var infoPanelMainImage_previous = A2(
															$author$project$Main$calciteFloatingActionButton,
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline-fill'),
																	A2($elm$html$Html$Attributes$attribute, 'icon', 'caret-left'),
																	A2($elm$html$Html$Attributes$attribute, 'icon-flip-rtl', 'true'),
																	A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
																	A2(
																	$elm$html$Html$Attributes$attribute,
																	'label',
																	$author$project$Translations$Cards$showPreviousImage(translations)),
																	A2($elm$html$Html$Attributes$attribute, 'scale', 'l'),
																	$elm$html$Html$Attributes$class('previousFAB'),
																	A2($elm$html$Html$Attributes$style, 'visibility', previousPreviewScrollArrowsVisibility),
																	$elm$html$Html$Events$onClick($author$project$Main$PreviousPreviewImage)
																]),
															_List_Nil);
														var infoPanelMainImage_next = A2(
															$author$project$Main$calciteFloatingActionButton,
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline-fill'),
																	A2($elm$html$Html$Attributes$attribute, 'icon', 'caret-right'),
																	A2($elm$html$Html$Attributes$attribute, 'icon-flip-rtl', 'true'),
																	A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
																	A2(
																	$elm$html$Html$Attributes$attribute,
																	'label',
																	$author$project$Translations$Cards$showNextImage(translations)),
																	A2($elm$html$Html$Attributes$attribute, 'scale', 'l'),
																	$elm$html$Html$Attributes$class('nextFAB'),
																	A2($elm$html$Html$Attributes$style, 'visibility', nextPreviewScrollArrowsVisibility),
																	$elm$html$Html$Events$onClick($author$project$Main$NextPreviewImage)
																]),
															_List_Nil);
														var industries = A2(
															$elm$core$List$map,
															function (_v4) {
																var industry = _v4.a;
																return industry;
															},
															$elm$core$Dict$toList(tree));
														var highlightedPreview = function () {
															var _v2 = A2($elm$core$List$drop, activeCard.co, activeCard.dj);
															if (!_v2.b) {
																return $elm$html$Html$text('');
															} else {
																var first = _v2.a;
																var _v3 = first.er;
																switch (_v3) {
																	case 'image':
																		return A2(
																			$elm$html$Html$div,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$img,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$src(first.cX)
																						]),
																					_List_Nil)
																				]));
																	case 'kaltura':
																		var kalturaPath = 'https://mediaspace.esri.com/embed/secure/iframe/entryId/' + first.cX;
																		return A2(
																			$elm$html$Html$div,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$iframe,
																					_List_fromArray(
																						[
																							A2($elm$html$Html$Attributes$attribute, 'src', kalturaPath),
																							A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', '1'),
																							$elm$html$Html$Attributes$class('info-panel-video-wrapper')
																						]),
																					_List_Nil)
																				]));
																	case 'youtube':
																		var youtubePaths = $author$project$Main$getYouTubeUrls(first.cX);
																		return A2(
																			$elm$html$Html$div,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$iframe,
																					_List_fromArray(
																						[
																							A2($elm$html$Html$Attributes$attribute, 'src', youtubePaths.b),
																							$elm$html$Html$Attributes$class('info-panel-video-wrapper')
																						]),
																					_List_Nil)
																				]));
																	default:
																		return $elm$html$Html$text('');
																}
															}
														}();
														var infoPanelMainImage = A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('info-panel-main-image')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('FABContainer previousFABContainer')
																		]),
																	_List_fromArray(
																		[infoPanelMainImage_previous])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('info-panel-image-wrapper')
																		]),
																	_List_fromArray(
																		[highlightedPreview])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('FABContainer nextFABContainer')
																		]),
																	_List_fromArray(
																		[infoPanelMainImage_next]))
																]));
														var developedFor = A2(
															$elm$core$List$map,
															function (industry) {
																return A2(
																	$elm$html$Html$li,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('font-size--1')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(industry)
																		]));
															},
															A2(
																$elm$core$List$filter,
																function (category) {
																	return A2($elm$core$List$member, category, industries);
																},
																$elm_community$list_extra$List$Extra$unique(
																	A2(
																		$elm$core$List$map,
																		function (category) {
																			var _v1 = $elm$core$List$head(
																				A2($elm$core$String$split, '/', category));
																			if (!_v1.$) {
																				var value = _v1.a;
																				return value;
																			} else {
																				return '';
																			}
																		},
																		A2(
																			$elm$core$List$map,
																			function (category) {
																				return A3($elm$core$String$replace, '/Categories/', '', category);
																			},
																			$elm$core$List$sort(activeCard.aP))))));
														var description = function () {
															var _v0 = $hecrj$html_parser$Html$Parser$run(activeCard.bM);
															if (!_v0.$) {
																var value = _v0.a;
																return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(value);
															} else {
																return _List_fromArray(
																	[
																		$elm$html$Html$text(activeCard.bM)
																	]);
															}
														}();
														var cardHeight = (!numRelatedSolutions) ? 'unset' : ('calc((100% - ' + ($elm$core$String$fromInt(heights.a3) + 'px) - 2rem)'));
														var youMayAlsoLike = (numRelatedSolutions > 0) ? A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('leader-half'),
																	A2($elm$html$Html$Attributes$style, 'height', cardHeight)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('block-group lg-screen-block-group-4 sm-screen-block-group-3-2 tablet-block-group-2 phone-block-group-1 solutions-card-area'),
																			$elm$html$Html$Attributes$id('results-section'),
																			A2($elm$html$Html$Attributes$style, 'clear', 'both'),
																			A2($elm$html$Html$Attributes$style, 'max-height', '100%')
																		]),
																	relatedSolutionDisplays)
																])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
														var youMayAlsoLikeTab = _List_fromArray(
															[
																A2(
																$author$project$Main$calciteTab,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('overflow-hidden')
																	]),
																_List_fromArray(
																	[youMayAlsoLike]))
															]);
														var availableForEnterprise = A2($elm$core$List$member, '/Categories/ArcGIS Enterprise', activeCard.aP);
														var availableForAGO = A2($elm$core$List$member, '/Categories/ArcGIS Online', activeCard.aP);
														var availableFor = (gallery && (availableForAGO || availableForEnterprise)) ? _List_fromArray(
															[
																A2(
																$elm$html$Html$h4,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-size-0 avenir-demi industry-listing-content-heading')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Cards$availableFor(translations))
																	])),
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('industry-listing-content-list')
																	]),
																_List_fromArray(
																	[
																		availableForAGO ? A2(
																		$elm$html$Html$div,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Translations$Cards$agolName(translations))
																			])) : $elm$html$Html$text(''),
																		availableForEnterprise ? A2(
																		$elm$html$Html$div,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Translations$Cards$enterpriseName(translations))
																			])) : $elm$html$Html$text('')
																	]))
															]) : _List_Nil;
														var overviewPanel = A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('overview-panel')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('overview-panel-contents')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('overview-section-description')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$p,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text(activeCard.aW)
																						])),
																					A2($elm$html$Html$div, _List_Nil, description)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('industry-listing-container')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('industry-listing')
																				]),
																			_Utils_ap(
																				availableFor,
																				_Utils_ap(
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$h4,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('font-size-0 avenir-demi industry-listing-content-heading')
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text(
																									$author$project$Translations$Cards$developedFor(translations))
																								])),
																							A2(
																							$elm$html$Html$ul,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('industry-listing-content-list')
																								]),
																							developedFor),
																							A2(
																							$elm$html$Html$h4,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('font-size-0 avenir-demi industry-listing-content-heading')
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text(
																									$author$project$Translations$Cards$version(translations))
																								])),
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('industry-listing-content-list')
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text(activeCard.bl)
																								]))
																						]),
																					licenseInfoHtmlList)))
																		]))
																]));
														var tabs = _List_fromArray(
															[
																tabTitles,
																A2(
																$author$project$Main$calciteTab,
																_List_Nil,
																_List_fromArray(
																	[overviewPanel])),
																A2(
																$author$project$Main$calciteTab,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'id', 'solution-whats-included-tab')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Cards$whatsIncluded(translations))
																	]))
															]);
														var allTabs = (numRelatedSolutions > 0) ? tabBase(
															_Utils_ap(tabs, youMayAlsoLikeTab)) : tabBase(tabs);
														var activeCardDataFetched = !$author$project$Card$isEmptyCard(activeCard);
														var deployBtn = activeCard.bJ ? A2(
															$author$project$Main$calciteButton,
															_Utils_ap(
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'alignment', 'center'),
																		A2($elm$html$Html$Attributes$attribute, 'appearance', 'solid'),
																		A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																		A2($elm$html$Html$Attributes$attribute, 'icon-end', 'arrow-right'),
																		A2($elm$html$Html$Attributes$attribute, 'icon-flip-rtl', 'end'),
																		A2($elm$html$Html$Attributes$attribute, 'id', 'getNowBtn'),
																		A2($elm$html$Html$Attributes$attribute, 'scale', 'l'),
																		A2($elm$html$Html$Attributes$attribute, 'width', 'auto'),
																		$elm$html$Html$Attributes$href(''),
																		$elm$html$Html$Events$onClick(
																		A2($author$project$Main$Deploy, activeCard, false))
																	]),
																(!isSignedIn) ? _List_fromArray(
																	[
																		$elm$html$Html$Events$onClick($author$project$Main$RequestUpdateUrlSearch)
																	]) : (isReadOnly ? _List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'disabled', '')
																	]) : (((!activeCardDataFetched) && nextStepQueuing) ? _List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'disabled', ''),
																		A2($elm$html$Html$Attributes$attribute, 'loading', '')
																	]) : (((!activeCardDataFetched) && (!nextStepQueuing)) ? _List_fromArray(
																	[
																		$elm$html$Html$Events$onClick($author$project$Main$WaitForNextStep)
																	]) : ((activeCardDataFetched && (!$elm$core$Set$size(missingPrivileges))) ? _List_fromArray(
																	[
																		$elm$html$Html$Events$onClick(
																		A2($author$project$Main$Deploy, activeCard, false))
																	]) : _List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'disabled', '')
																	])))))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$Cards$deployNow(translations))
																])) : $elm$html$Html$text('');
														return _List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('full-width-modal')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('info-panel-bkgd')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('info-panel')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('info-panel-content')
																							]),
																						_Utils_ap(
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$div,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('info-panel-header')
																										]),
																									_List_fromArray(
																										[
																											A2(
																											$elm$html$Html$div,
																											_List_fromArray(
																												[
																													$elm$html$Html$Attributes$class('info-panel-header-content')
																												]),
																											_List_fromArray(
																												[
																													A2(
																													$elm$html$Html$p,
																													_List_fromArray(
																														[
																															$elm$html$Html$Attributes$class('info-panel-header-heading avenir-light')
																														]),
																													_List_fromArray(
																														[
																															$elm$html$Html$text(activeCard.G)
																														]))
																												]))
																										])),
																									A2(
																									$elm$html$Html$div,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('info-panel-button-list')
																										]),
																									_List_fromArray(
																										[
																											A2(
																											$elm$html$Html$div,
																											_List_fromArray(
																												[
																													$elm$html$Html$Attributes$class('info-panel-buttons lighttheme')
																												]),
																											_List_fromArray(
																												[
																													A2(
																													$elm$html$Html$div,
																													_List_fromArray(
																														[
																															$elm$html$Html$Attributes$class('info-panel-buttons button-actions')
																														]),
																													A2($elm$core$List$cons, deployBtn, socialSharing))
																												]))
																										])),
																									learnMoreLink
																								]),
																							restrictionMessages)),
																						infoPanelMainImage
																					]))
																			])),
																		allTabs
																	]))
															]);
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$viewCardModal = function (heights) {
	return function (categories) {
		return function (activeCard) {
			return function (activeCardQueue) {
				return function (relatedSolutionDisplays) {
					return function (infoMode) {
						return function (userPrivileges) {
							return function (nextStepQueuing) {
								return function (translations) {
									return function (isRTL) {
										return function (userOptionsIndex) {
											return function (gallery) {
												return function (isSearching) {
													return function (isEnterprise) {
														return function (isReadOnly) {
															return function (token) {
																return function (allTemplates) {
																	var title = (infoMode === 'configure') ? _List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($author$project$Translations$Cards$deploySolution, translations, activeCard.G))
																		]) : _List_Nil;
																	var modalSize = (infoMode === 'configure') ? 'm' : 'l';
																	var modalContentClass = function () {
																		if (infoMode === 'configure') {
																			return _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('solutions-modal-content-config')
																				]);
																		} else {
																			return _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('solutions-modal-content')
																				]);
																		}
																	}();
																	var missingPrivileges = A2($elm$core$Set$diff, activeCard.dL.dk, userPrivileges);
																	var backThroughActiveQueue = ($elm$core$List$length(activeCardQueue) > 1) ? A2(
																		$author$project$Main$calciteButton,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$attribute, 'slot', 'back'),
																				A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
																				A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
																				A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																				$elm$html$Html$Events$onClick($author$project$Main$ShowLastActiveCard)
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Translations$Cards$back(translations))
																			])) : $elm$html$Html$text('');
																	return A2(
																		$author$project$Main$calciteModal,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'solutions-modal-title'),
																				A2($elm$html$Html$Attributes$attribute, 'focus-trap-disabled', 'true'),
																				A2($elm$html$Html$Attributes$attribute, 'outside-close-disabled', 'true'),
																				A2($elm$html$Html$Attributes$attribute, 'padding', ''),
																				A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
																				A2($elm$html$Html$Attributes$attribute, 'width-scale', modalSize)
																			]),
																		_Utils_ap(
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							A2($elm$html$Html$Attributes$attribute, 'slot', 'header'),
																							$elm$html$Html$Attributes$id('solutions-modal-title')
																						]),
																					title),
																					A2(
																					$elm$html$Html$div,
																					_Utils_ap(
																						_List_fromArray(
																							[
																								A2($elm$html$Html$Attributes$attribute, 'slot', 'content'),
																								$elm$html$Html$Attributes$id('solutions-modal-content')
																							]),
																						modalContentClass),
																					function () {
																						if (infoMode === 'configure') {
																							return A5($author$project$Main$viewModalConfigure, activeCard, userOptionsIndex, translations, isSearching, isEnterprise);
																						} else {
																							return $author$project$Main$viewModalInformation(heights)(categories)(translations)(isRTL)(activeCard)(relatedSolutionDisplays)(gallery)(userPrivileges)(missingPrivileges)(nextStepQueuing)(isEnterprise)(isReadOnly)(token)(allTemplates);
																						}
																					}())
																				]),
																			function () {
																				switch (infoMode) {
																					case 'information':
																						return _List_fromArray(
																							[
																								A2(
																								$author$project$Main$calciteButton,
																								_List_fromArray(
																									[
																										A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
																										A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
																										A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
																										A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																										$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Translations$Cards$close(translations))
																									])),
																								backThroughActiveQueue
																							]);
																					case 'configure':
																						var userOptions = activeCard.dL.dO;
																						var userOptionsLength = $elm$core$List$length(userOptions);
																						var optionsValid = A2($author$project$Main$checkOptions, userOptions, userOptionsIndex);
																						var isLastOptions = _Utils_eq(userOptionsIndex + 1, userOptionsLength);
																						var enabled = optionsValid ? A2($elm$html$Html$Attributes$attribute, 'enabled', '') : A2($elm$html$Html$Attributes$attribute, 'disabled', '');
																						var btnNextText = isLastOptions ? $author$project$Translations$Cards$deploy : $author$project$Translations$Cards$next;
																						var btnNextFunction = optionsValid ? (isLastOptions ? $elm$html$Html$Events$onClick(
																							A2($author$project$Main$Deploy, activeCard, false)) : $elm$html$Html$Events$onClick(
																							$author$project$Main$ShowNextOptions(userOptionsIndex))) : $elm$html$Html$Events$onClick($author$project$Main$NoOp);
																						return _List_fromArray(
																							[
																								A2(
																								$author$project$Main$calciteButton,
																								_List_fromArray(
																									[
																										A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
																										A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
																										A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
																										A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																										$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Translations$Cards$close(translations))
																									])),
																								A2(
																								$author$project$Main$calciteButton,
																								_List_fromArray(
																									[
																										A2($elm$html$Html$Attributes$attribute, 'slot', 'primary'),
																										A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
																										A2($elm$html$Html$Attributes$attribute, 'appearance', 'solid'),
																										A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																										enabled,
																										btnNextFunction
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										btnNextText(translations))
																									]))
																							]);
																					default:
																						return _List_fromArray(
																							[
																								A2(
																								$author$project$Main$calciteButton,
																								_List_fromArray(
																									[
																										A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
																										A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
																										A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
																										A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																										$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Translations$Cards$close(translations))
																									])),
																								A2(
																								$author$project$Main$calciteButton,
																								_List_fromArray(
																									[
																										A2($elm$html$Html$Attributes$attribute, 'slot', 'primary'),
																										A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
																										A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
																										(!$elm$core$Set$size(missingPrivileges)) ? $elm$html$Html$Events$onClick(
																										A2($author$project$Main$Deploy, activeCard, false)) : A2($elm$html$Html$Attributes$attribute, 'disabled', '')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Translations$Cards$getNow(translations))
																									]))
																							]);
																				}
																			}()));
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$DeleteSolution = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$calciteLoader = $elm$html$Html$node('calcite-loader');
var $author$project$Translations$Cards$cancel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.cancel');
};
var $author$project$Translations$Delete$confirmDelete = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.confirmDelete');
};
var $author$project$Translations$Delete$confirmDeleteButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.confirmDeleteButton');
};
var $author$project$Translations$Delete$confirmDeleteWithItems = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.confirmDeleteWithItems');
};
var $author$project$Translations$Delete$confirmHeader = F2(
	function (translations, solutionName) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'delete.confirmHeader',
			_List_fromArray(
				[
					_Utils_Tuple2('solutionName', solutionName)
				]));
	});
var $author$project$Translations$Delete$deletingMessage = F2(
	function (translations, solutionName) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'delete.deletingMessage',
			_List_fromArray(
				[
					_Utils_Tuple2('solutionName', solutionName)
				]));
	});
var $author$project$Translations$Delete$failedHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.failedHeader');
};
var $author$project$Translations$Delete$failedRetryButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.failedRetryButton');
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Translations$Delete$successRemainingItems = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.successRemainingItems');
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $author$project$Translations$Delete$tableColumnItemName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.tableColumnItemName');
};
var $author$project$Translations$Delete$tableColumnLastModified = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.tableColumnLastModified');
};
var $author$project$Translations$Delete$tableColumnOwner = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.tableColumnOwner');
};
var $author$project$Translations$Delete$tableColumnType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.tableColumnType');
};
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Main$viewRelatedItemsTable = F2(
	function (relatedItems, translations) {
		var relatedItemRows = A2(
			$elm$core$List$map,
			function (relatedItem) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-priority-1'),
									A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'rel-item-name'),
									$elm$html$Html$Attributes$title(relatedItem.ez)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(relatedItem.ez)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-priority-3'),
									A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'rel-item-type'),
									$elm$html$Html$Attributes$title(relatedItem.cQ)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(relatedItem.cQ)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-priority-4'),
									A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'rel-item-owner'),
									$elm$html$Html$Attributes$title(relatedItem.eZ)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(relatedItem.eZ)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-priority-2'),
									A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'rel-item-modified'),
									$elm$html$Html$Attributes$title(relatedItem.bt)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(relatedItem.bt)
								]))
						]));
			},
			relatedItems);
		var itemTypeHeader = $author$project$Translations$Delete$tableColumnType(translations);
		var itemOwnerHeader = $author$project$Translations$Delete$tableColumnOwner(translations);
		var itemNameHeader = $author$project$Translations$Delete$tableColumnItemName(translations);
		var itemModifiedHeader = $author$project$Translations$Delete$tableColumnLastModified(translations);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('solution-related-items solution-related-items-list')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table-header col-priority-1'),
											$elm$html$Html$Attributes$title(itemNameHeader)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(itemNameHeader)
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table-header col-priority-3'),
											$elm$html$Html$Attributes$title(itemTypeHeader)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(itemTypeHeader)
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table-header col-priority-4'),
											$elm$html$Html$Attributes$title(itemOwnerHeader)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(itemOwnerHeader)
										])),
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table-header col-priority-2'),
											$elm$html$Html$Attributes$title(itemModifiedHeader)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(itemModifiedHeader)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('scroll-table-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							($elm$core$List$length(relatedItems) < 4) ? _List_Nil : _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'width', 'calc(100% + 17px)')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('out-of-sight')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-priority-1'),
															$elm$html$Html$Attributes$id('rel-item-name')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(itemNameHeader)
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-priority-3'),
															$elm$html$Html$Attributes$id('rel-item-type')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(itemTypeHeader)
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-priority-4'),
															$elm$html$Html$Attributes$id('rel-item-owner')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(itemOwnerHeader)
														])),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-priority-2'),
															$elm$html$Html$Attributes$id('rel-item-modified')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(itemModifiedHeader)
														]))
												]))
										])),
									A2($elm$html$Html$tbody, _List_Nil, relatedItemRows)
								]))
						]))
				]));
	});
var $author$project$Main$viewDeleteModal = F4(
	function (activeDeleteCard, translations, loading, status) {
		var modalContent = function () {
			var progressLoader = A2(
				$author$project$Main$calciteLoader,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'active', ''),
						A2(
						$elm$html$Html$Attributes$attribute,
						'type',
						(activeDeleteCard.cr > 0) ? 'determinate' : 'indeterminate'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'value',
						(activeDeleteCard.cr > 0) ? $elm$core$String$fromFloat(activeDeleteCard.cr) : '')
					]),
				_List_Nil);
			if (loading) {
				return _List_fromArray(
					[
						A2(
						$author$project$Main$calciteLoader,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'active', '')
							]),
						_List_Nil)
					]);
			} else {
				switch (status) {
					case 3:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Delete$successRemainingItems(translations))
									])),
								A2($author$project$Main$viewRelatedItemsTable, activeDeleteCard.dq, translations)
							]);
					case 0:
						var confirmDeleteWithItems = _List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Delete$confirmDeleteWithItems(translations)),
										A2($author$project$Main$viewRelatedItemsTable, activeDeleteCard.dq, translations)
									]))
							]);
						var confirmDelete = _List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Delete$confirmDelete(translations))
									]))
							]);
						return $elm$core$List$isEmpty(activeDeleteCard.dq) ? confirmDelete : confirmDeleteWithItems;
					default:
						return _List_fromArray(
							[progressLoader]);
				}
			}
		}();
		var headerText = function () {
			switch (status) {
				case 3:
					return $author$project$Translations$Delete$failedHeader(translations);
				case 0:
					return A2($author$project$Translations$Delete$confirmHeader, translations, activeDeleteCard.G);
				default:
					return A2($author$project$Translations$Delete$deletingMessage, translations, activeDeleteCard.G);
			}
		}();
		var actionButtons = function () {
			switch (status) {
				case 0:
					return _List_fromArray(
						[
							A2(
							$author$project$Main$calciteButton,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
									A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
									A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
									A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
									$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Cards$cancel(translations))
								])),
							A2(
							$author$project$Main$calciteButton,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'slot', 'primary'),
									A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
									A2($elm$html$Html$Attributes$attribute, 'appearance', 'solid'),
									A2($elm$html$Html$Attributes$attribute, 'kind', 'danger'),
									$elm$html$Html$Events$onClick(
									$author$project$Main$DeleteSolution(activeDeleteCard))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Delete$confirmDeleteButton(translations))
								]))
						]);
				case 3:
					return _List_fromArray(
						[
							A2(
							$author$project$Main$calciteButton,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
									A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
									A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
									A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
									$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Cards$close(translations))
								])),
							A2(
							$author$project$Main$calciteButton,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'slot', 'primary'),
									A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
									A2($elm$html$Html$Attributes$attribute, 'appearance', 'solid'),
									A2($elm$html$Html$Attributes$attribute, 'kind', 'danger'),
									$elm$html$Html$Events$onClick(
									$author$project$Main$DeleteSolution(activeDeleteCard))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Delete$failedRetryButton(translations))
								]))
						]);
				default:
					return _List_Nil;
			}
		}();
		return A2(
			$author$project$Main$calciteModal,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'solutions-modal-title'),
						A2($elm$html$Html$Attributes$attribute, 'focus-trap-disabled', 'true'),
						A2($elm$html$Html$Attributes$attribute, 'kind', 'danger'),
						A2($elm$html$Html$Attributes$attribute, 'outside-close-disabled', 'true'),
						A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
						A2($elm$html$Html$Attributes$attribute, 'width-scale', 'l')
					]),
				((status === 1) || (status === 2)) ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'close-button-disabled', ''),
						A2($elm$html$Html$Attributes$attribute, 'escape-disabled', '')
					]) : _List_Nil),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'slot', 'header'),
								$elm$html$Html$Attributes$id('solutions-modal-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(headerText)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'slot', 'content'),
								$elm$html$Html$Attributes$id('solutions-modal-content')
							]),
						modalContent)
					]),
				actionButtons));
	});
var $author$project$Main$calcitePanel = $elm$html$Html$node('calcite-panel');
var $author$project$Main$calciteShell = $elm$html$Html$node('calcite-shell');
var $author$project$Main$calciteShellPanel = $elm$html$Html$node('calcite-shell-panel');
var $author$project$Main$viewDiagramModal = F2(
	function (activeDiagramCard, translations) {
		return A2(
			$author$project$Main$calciteModal,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('diagram-modal'),
					A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'solutions-modal-title'),
					A2($elm$html$Html$Attributes$attribute, 'focus-trap-disabled', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'outside-close-disabled', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'padding', ''),
					A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
					A2($elm$html$Html$Attributes$attribute, 'width-scale', 'l')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'slot', 'header'),
							$elm$html$Html$Attributes$id('solutions-modal-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(activeDiagramCard.G)
						])),
					A2(
					$author$project$Main$calciteShell,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('solutions-modal-content-diagram'),
							$elm$html$Html$Attributes$id('solutions-modal-content'),
							A2($elm$html$Html$Attributes$attribute, 'slot', 'content')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Main$calciteShellPanel,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('indexPanel'),
									A2($elm$html$Html$Attributes$attribute, 'slot', 'panel-start'),
									A2($elm$html$Html$Attributes$attribute, 'width-scale', 'm')
								]),
							_List_Nil),
							A2(
							$author$project$Main$calcitePanel,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('diagramPanel')
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Main$calciteButton,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
							A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
							A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
							A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
							$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Cards$close(translations))
						]))
				]));
	});
var $author$project$Main$TypeFilterToggled = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Translations$Filters$filtersHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.filtersHeading');
};
var $author$project$Translations$Filters$industriesHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industriesHeading');
};
var $author$project$Translations$Filters$newReleaseToggle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.newReleaseToggle');
};
var $author$project$Translations$Filters$suggestedForYouToggle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.suggestedForYouToggle');
};
var $author$project$Main$calciteTree = $elm$html$Html$node('calcite-tree');
var $author$project$Main$calciteTreeItem = $elm$html$Html$node('calcite-tree-item');
var $author$project$Main$renderDomains = F5(
	function (domainList, industry, domainFilters, industryFilters, translations) {
		return A2(
			$elm$core$List$map,
			function (domain) {
				var treeItemAttributes = _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-domain', domain),
						A2($elm$html$Html$Attributes$attribute, 'data-parentindustry', industry)
					]);
				return A2(
					$author$project$Main$calciteTreeItem,
					_Utils_ap(
						treeItemAttributes,
						(A2($elm$core$Set$member, domain, domainFilters) || ($elm$core$Set$isEmpty(domainFilters) && A2($elm$core$Set$member, industry, industryFilters))) ? _List_Nil : _List_Nil),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Main$getFilterValueDisplay, translations, domain))
								]))
						]));
			},
			$elm$core$Set$toList(domainList));
	});
var $author$project$Main$viewTree = F4(
	function (tree, industryFilters, domainFilters, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('category-tree-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Main$calciteTree,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('category-tree'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-label',
							$author$project$Translations$Filters$industriesHeading(translations)),
							A2($elm$html$Html$Attributes$attribute, 'lines', 'false'),
							A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
							A2($elm$html$Html$Attributes$attribute, 'selection-mode', 'children')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var industry = _v0.a;
							var domainList = _v0.b;
							var attr = 'data-industry';
							return A2(
								$author$project$Main$calciteTreeItem,
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, attr, industry),
									A2($elm$core$Set$member, industry, industryFilters) ? _List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'highlight', ''),
											A2($elm$html$Html$Attributes$attribute, 'expanded', ''),
											A2($elm$html$Html$Attributes$attribute, 'selected', '')
										]) : _List_Nil),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Main$getFilterValueDisplay, translations, industry))
											])),
										(!$elm$core$Set$isEmpty(domainList)) ? A2(
										$author$project$Main$calciteTree,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
												A2($elm$html$Html$Attributes$attribute, 'selection-mode', 'multi-children'),
												A2($elm$html$Html$Attributes$attribute, 'slot', 'children')
											]),
										A5($author$project$Main$renderDomains, domainList, industry, domainFilters, industryFilters, translations)) : $elm$html$Html$text('')
									]));
						},
						$elm$core$Dict$toList(tree)))
				]));
	});
var $author$project$Main$filterControl = F8(
	function (categories, typeFilters, domainFilters, industryFilters, showFilters, translations, isModal, hasRelatedSolutions) {
		var showFiltersText = isModal ? 'invisible hide' : 'visible';
		var newReleaseContainer = isModal ? '' : 'filters-border-top padding-leader-half';
		var industryTreeContainer = isModal ? 'filters-border-top padding-leader-half' : 'filters-border-bottom padding-leader-half padding-trailer-quarter';
		var filtersVisible = showFilters ? 'visible' : 'invisible hide';
		var attrs = isModal ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$id('filter-scroll-container'),
				$elm$html$Html$Attributes$class('filters-border-top')
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('padding-left-0 margin-right-50 filters-container ' + filtersVisible),
					A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'filters-title'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'heading')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('trailer-half leader-half filters-text ' + showFiltersText)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('filters-title'),
									$elm$html$Html$Attributes$class('line-height-2'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-label',
									$author$project$Translations$Filters$filtersHeading(translations)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'label',
									$author$project$Translations$Filters$filtersHeading(translations))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Filters$filtersHeading(translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(newReleaseContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Main$calciteLabel,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('newReleaseAvailableSwitch'),
									$elm$html$Html$Attributes$class('filters-label'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-label',
									$author$project$Translations$Filters$newReleaseToggle(translations)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'label',
									$author$project$Translations$Filters$newReleaseToggle(translations)),
									A2($elm$html$Html$Attributes$attribute, 'layout', 'inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('newReleaseSwitchLabel'),
											$elm$html$Html$Attributes$class('calcite-switch-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Filters$newReleaseToggle(translations))
										])),
									A2(
									$author$project$Main$calciteSwitch,
									_Utils_ap(
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'newReleaseSwitchLabel'),
												$elm$html$Html$Attributes$class('post-0 right newReleaseSwitchLabel'),
												$author$project$Main$onCalciteSwitchChange(
												$author$project$Main$TypeFilterToggled('New'))
											]),
										A2($elm$core$Set$member, 'New', typeFilters) ? _List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'checked', '')
											]) : _List_Nil),
									_List_Nil)
								]))
						])),
					hasRelatedSolutions ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filters-border-top padding-leader-half')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Main$calciteLabel,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('suggestedForYouSwitch'),
									$elm$html$Html$Attributes$class('filters-label'),
									A2($elm$html$Html$Attributes$attribute, 'layout', 'inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('suggestedForYouSwitchLabel'),
											$elm$html$Html$Attributes$class('calcite-switch-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Filters$suggestedForYouToggle(translations))
										])),
									A2(
									$author$project$Main$calciteSwitch,
									_Utils_ap(
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'suggestedForYouSwitchLabel'),
												$elm$html$Html$Attributes$class('post-0 right suggestedForYouSwitchLabel'),
												$author$project$Main$onCalciteSwitchChange(
												$author$project$Main$TypeFilterToggled('Suggested'))
											]),
										A2($elm$core$Set$member, 'Suggested', typeFilters) ? _List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'checked', '')
											]) : _List_Nil),
									_List_Nil)
								]))
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					attrs,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(industryTreeContainer)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('trailer-quarter calcite-switch-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Filters$industriesHeading(translations))
										])),
									A4($author$project$Main$viewTree, categories, industryFilters, domainFilters, translations)
								]))
						]))
				]));
	});
var $author$project$Main$viewFiltersModal = F6(
	function (categories, typeFilters, domainFilters, industryFilters, translations, hasRelatedSolutions) {
		return A2(
			$author$project$Main$calciteModal,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-labelledby', 'solutions-modal-title'),
					A2($elm$html$Html$Attributes$attribute, 'focus-trap-disabled', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'outside-close-disabled', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'padding', ''),
					A2($elm$html$Html$Attributes$attribute, 'scale', 'm'),
					A2($elm$html$Html$Attributes$attribute, 'width-scale', 'l')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'slot', 'header'),
							$elm$html$Html$Attributes$id('solutions-modal-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Filters$filtersHeading(translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'slot', 'content'),
							$elm$html$Html$Attributes$class('solutions-modal-content'),
							$elm$html$Html$Attributes$id('solutions-modal-content')
						]),
					_List_fromArray(
						[
							A8($author$project$Main$filterControl, categories, typeFilters, domainFilters, industryFilters, true, translations, true, hasRelatedSolutions)
						])),
					A2(
					$author$project$Main$calciteButton,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'slot', 'secondary'),
							A2($elm$html$Html$Attributes$attribute, 'width', 'full'),
							A2($elm$html$Html$Attributes$attribute, 'appearance', 'outline'),
							A2($elm$html$Html$Attributes$attribute, 'kind', 'brand'),
							$elm$html$Html$Events$onClick($author$project$Main$CloseCard)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Cards$close(translations))
						]))
				]));
	});
var $author$project$Card$SolutionTemplate = {$: 1};
var $author$project$Main$CardMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Main$OpenDeleteModal = function (a) {
	return {$: 39, a: a};
};
var $author$project$Main$OpenDiagramModal = function (a) {
	return {$: 40, a: a};
};
var $author$project$Main$OpenLink = function (a) {
	return {$: 42, a: a};
};
var $author$project$Main$TriggerBlur = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var $author$project$Main$TriggerFocus = function (a) {
	return {$: 44, a: a};
};
var $author$project$Main$ViewDetails = function (a) {
	return {$: 45, a: a};
};
var $author$project$Card$messageTranslator = F2(
	function (_v0, msg) {
		var onCardMessage = _v0.c2;
		var onOpenDeleteModal = _v0.c5;
		var onOpenDiagramModal = _v0.c6;
		var onOpenLink = _v0.c7;
		var onTriggerBlur = _v0.c9;
		var onTriggerFocus = _v0.da;
		var onViewDetails = _v0.db;
		if (!msg.$) {
			var cardMsg = msg.a;
			return onCardMessage(cardMsg);
		} else {
			switch (msg.a.$) {
				case 0:
					var card = msg.a.a;
					return onOpenDeleteModal(card);
				case 1:
					var card = msg.a.a;
					return onOpenDiagramModal(card);
				case 2:
					var link = msg.a.a;
					return onOpenLink(link);
				case 3:
					var _v2 = msg.a;
					var id = _v2.a;
					var value = _v2.b;
					return A2(onTriggerBlur, id, value);
				case 4:
					var id = msg.a.a;
					return onTriggerFocus(id);
				default:
					var card = msg.a.a;
					return onViewDetails(card);
			}
		}
	});
var $author$project$Main$cardMessageTranslator = $author$project$Card$messageTranslator(
	{c2: $author$project$Main$CardMsg, c5: $author$project$Main$OpenDeleteModal, c6: $author$project$Main$OpenDiagramModal, c7: $author$project$Main$OpenLink, c9: $author$project$Main$TriggerBlur, da: $author$project$Main$TriggerFocus, db: $author$project$Main$ViewDetails});
var $author$project$Card$ForParent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Card$ViewDetails = function (a) {
	return {$: 5, a: a};
};
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
var $author$project$Translations$Cards$agolTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.agolTooltip');
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Card$arcgisEnterpriseIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('enterpriseIcon'),
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$viewBox('23 25 82 82'),
			A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M28.23829,86.1887a.375.375,0,0,1-.18829-.32521V46.06741a.375.375,0,0,1,.18993-.32614l9.983-5.66485a3.07,3.07,0,0,1,3.06081.01757l30.745,17.916a5.86584,5.86584,0,0,1,2.92466,5.06539v3.57811a6.59939,6.59939,0,0,1-3.29144,5.7004l-7.04545,4.0677a.25.25,0,0,1-.375-.21651V66.85854a1.17976,1.17976,0,0,0-.5899-1.02172L36.31454,50.05442a.25.25,0,0,0-.375.2165V75.41608a5.28759,5.28759,0,0,0,2.70477,4.61386L57.21558,90.42611a13.57088,13.57088,0,0,0,13.56886,0L91.20551,78.99442a1.67139,1.67139,0,0,0,.855-1.45841V57.18333a9.19626,9.19626,0,0,0-4.626-7.9802L55.18338,30.73283a.25.25,0,0,1-.00076-.43345L63.813,25.31665a.375.375,0,0,1,.37421-.00045L98.32449,44.91577A3.23748,3.23748,0,0,1,99.95,47.72342V83.99093a3.60931,3.60931,0,0,1-1.81223,3.13012l-32.88319,18.8791a2.51973,2.51973,0,0,1-2.50916,0Z'),
					$elm$svg$Svg$Attributes$fill('#7842ed')
				]),
			_List_Nil)
		]));
var $author$project$Card$arcgisOnlineIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('onlineIcon'),
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$viewBox('23 25 82 82'),
			A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M88.88766,86.67428a.625.625,0,0,1,.55287,0l10.62465,5.24024a.325.325,0,0,1-.00007.583L77.71256,103.516a2.22063,2.22063,0,0,1-1.96364,0L53.3952,92.49754a.325.325,0,0,1-.00006-.583L64.021,86.67429a.625.625,0,0,1,.55285,0L75.9384,92.27811a1.79161,1.79161,0,0,0,1.58469,0ZM53.39533,73.4246a.325.325,0,0,0,0,.583L75.93871,85.118a1.79158,1.79158,0,0,0,1.58407,0l22.54215-11.11036a.325.325,0,0,0,0-.583L77.00711,62.05681a.625.625,0,0,0-.55273,0ZM46.808,56.04257c-6.774-16.52164,14.89978-25.6977,23.72952-11.364a.49981.49981,0,0,0,.63667.19113c9.57825-4.47154,17.8429,2.38737,15.53411,12.23154a.75.75,0,0,0,.39787.8438l16.33832,8.0552a.25.25,0,0,0,.35683-.26728,19.39711,19.39711,0,0,0-7.248-12.03654.5.5,0,0,1-.185-.34815A19.68957,19.68957,0,0,0,74.356,35.14a.50022.50022,0,0,1-.38727-.12719c-14.001-12.70342-35.226-3.84588-36.89439,15.18709a.50055.50055,0,0,1-.27567.40423C10.14591,63.86939,24.75134,100.51135,52.80394,83.51593,27.78661,86.83447,28.89849,58.14032,46.808,56.04257Z'),
					$elm$svg$Svg$Attributes$fill('#5763f8')
				]),
			_List_Nil)
		]));
var $author$project$Card$checkMarkIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('#5a9359'),
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$viewBox('1.2 1.2 14.6 14.6'),
			A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8.5 1.2a7.3 7.3 0 1 0 7.3 7.3 7.3 7.3 0 0 0-7.3-7.3zm-.943 11.251L4.452 9.346l1.02-1.022 2.085 2.09 4.77-4.771 1.02 1.02z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h16v16H0z'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_Nil)
		]));
var $author$project$Translations$Cards$deployed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.deployed');
};
var $author$project$Translations$Cards$enterpriseTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.enterpriseTooltip');
};
var $author$project$Card$createSemVerList = function (semVer) {
	var semVerList = A2($elm$core$String$split, '.', semVer);
	if (!semVerList.b) {
		return _List_fromArray(
			[0, 0, 0]);
	} else {
		if (!semVerList.b.b) {
			var mj = semVerList.a;
			return _List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(mj)),
					0,
					0
				]);
		} else {
			if (!semVerList.b.b.b) {
				var mj = semVerList.a;
				var _v1 = semVerList.b;
				var mn = _v1.a;
				return _List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(mj)),
						A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(mn)),
						0
					]);
			} else {
				if (!semVerList.b.b.b.b) {
					var mj = semVerList.a;
					var _v2 = semVerList.b;
					var mn = _v2.a;
					var _v3 = _v2.b;
					var pt = _v3.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mj)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mn)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(pt))
						]);
				} else {
					var mj = semVerList.a;
					var _v4 = semVerList.b;
					var mn = _v4.a;
					var _v5 = _v4.b;
					var pt = _v5.a;
					return _List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mj)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(mn)),
							A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(pt))
						]);
				}
			}
		}
	}
};
var $author$project$Card$isVersionDeployed = F2(
	function (model, deployedSeriesMostRecent) {
		return A2($elm$core$Dict$member, model.a6, deployedSeriesMostRecent) ? _Utils_eq(
			$author$project$Card$createSemVerList(
				A2(
					$elm$core$Maybe$withDefault,
					'0.0.0',
					A2($elm$core$Dict$get, model.a6, deployedSeriesMostRecent))),
			$author$project$Card$createSemVerList(model.bl)) : false;
	});
var $author$project$Card$newReleaseAvailableIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('#007ac2'),
			$elm$svg$Svg$Attributes$height('16px'),
			$elm$svg$Svg$Attributes$width('16px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
			A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15.633 6.718l-3.666 3.176 1.107 4.732a.632.632 0 0 1-.221.68.572.572 0 0 1-.34.11.72.72 0 0 1-.373-.111l-4.165-2.533-4.163 2.532a.607.607 0 0 1-.936-.676l1.107-4.734L.317 6.718a.633.633 0 0 1-.22-.68.63.63 0 0 1 .578-.418l4.824-.406 1.9-4.537a.619.619 0 0 1 1.154 0l1.898 4.537 4.824.406a.606.606 0 0 1 .358 1.098z')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Card$drawCardActions = F4(
	function (deployedSeriesMostRecent, translations, gallery, model) {
		var footer = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-bottom-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-bottom-row-tags')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-block')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('action-icon')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-date')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-bottom-row-icons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-block')
											]),
										_List_fromArray(
											[
												A2($elm$core$List$member, '/Categories/New Release', model.aP) ? A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$attribute,
																'aria-label',
																$author$project$Translations$Filters$newReleaseToggle(translations)),
																$elm$html$Html$Attributes$class('tooltip tooltip-bottom'),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('card-status-icon')
																	]),
																_List_fromArray(
																	[$author$project$Card$newReleaseAvailableIcon]))
															]))
													])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
												A2($author$project$Card$isVersionDeployed, model, deployedSeriesMostRecent) ? A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$attribute,
																'aria-label',
																$author$project$Translations$Cards$deployed(translations)),
																$elm$html$Html$Attributes$class('tooltip tooltip-bottom'),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('card-status-icon')
																	]),
																_List_fromArray(
																	[$author$project$Card$checkMarkIcon]))
															]))
													])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
												(gallery && A2($elm$core$List$member, '/Categories/ArcGIS Online', model.aP)) ? A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$attribute,
																'aria-label',
																$author$project$Translations$Cards$agolTooltip(translations)),
																$elm$html$Html$Attributes$class('tooltip tooltip-bottom'),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('card-status-icon')
																	]),
																_List_fromArray(
																	[$author$project$Card$arcgisOnlineIcon]))
															]))
													])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
												(gallery && A2($elm$core$List$member, '/Categories/ArcGIS Enterprise', model.aP)) ? A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$attribute,
																'aria-label',
																$author$project$Translations$Cards$enterpriseTooltip(translations)),
																$elm$html$Html$Attributes$class('tooltip tooltip-bottom'),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('card-status-icon')
																	]),
																_List_fromArray(
																	[$author$project$Card$arcgisEnterpriseIcon]))
															]))
													])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
											]))
									]))
							]))
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-bottom-area')
				]),
			footer);
	});
var $author$project$Card$DeployedSolution = {$: 3};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Card$calciteLoader = $elm$html$Html$node('calcite-loader');
var $author$project$Card$getProgress = function (cardType) {
	if (cardType.$ === 2) {
		var value = cardType.a;
		return value;
	} else {
		return 0;
	}
};
var $author$project$Translations$Cards$open = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.open');
};
var $elm$html$Html$sub = _VirtualDom_node('sub');
var $author$project$Translations$Cards$viewDetails = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'cards.viewDetails');
};
var $author$project$Card$drawCardImage = F2(
	function (model, translations) {
		var progress = $author$project$Card$getProgress(model.ap);
		var actionLabel = _Utils_eq(model.ap, $author$project$Card$SolutionTemplate) ? $author$project$Translations$Cards$viewDetails(translations) : (_Utils_eq(model.ap, $author$project$Card$DeployedSolution) ? $author$project$Translations$Cards$open(translations) : '');
		var actionIcon = _Utils_eq(model.ap, $author$project$Card$SolutionTemplate) ? 'icon-ui-description' : (_Utils_eq(model.ap, $author$project$Card$DeployedSolution) ? 'icon-ui-link-external' : '');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-image-wrap thumbnail-height')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$alt(model.G),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
							$elm$html$Html$Attributes$src(model.aj),
							$elm$html$Html$Attributes$class('card-image')
						]),
					_List_Nil),
					(actionIcon !== '') ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-action-deploy action-icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('centerer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-action-deploy-button avenir-bold')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$sub,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(actionIcon + ' thumbnail-download-icon')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-size--1')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(actionLabel)
												]))
										]))
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-action-deploy card-action-deploying')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('centerer')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Card$calciteLoader,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'active', ''),
											$elm$html$Html$Attributes$class('sow-loader'),
											A2(
											$elm$html$Html$Attributes$attribute,
											'type',
											(progress > 0) ? 'determinate' : 'indeterminate'),
											A2(
											$elm$html$Html$Attributes$attribute,
											'value',
											(progress > 0) ? $elm$core$String$fromInt(progress) : '')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Card$drawCard = F4(
	function (deployedSeriesMostRecent, translations, gallery, model) {
		return _List_fromArray(
			[
				A2($author$project$Card$drawCardImage, model, translations),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-title-link font-size--1 bottom-margin-1rem')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.G)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-size--2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.aW)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-bottom-area-reservation')
					]),
				_List_Nil),
				A4($author$project$Card$drawCardActions, deployedSeriesMostRecent, translations, gallery, model)
			]);
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{bX: msg, b1: true, b5: true}));
};
var $author$project$Card$keyEventDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['key']),
	$elm$json$Json$Decode$string);
var $author$project$Card$onEnterNoBubble = function (msg) {
	var isEnter = function (key) {
		return (key === 'Enter') ? $elm$json$Json$Decode$succeed(
			{bX: msg, b1: true, b5: true}) : $elm$json$Json$Decode$fail('not ENTER');
	};
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnter, $author$project$Card$keyEventDecoder));
};
var $fapian$elm_html_aria$Html$Attributes$Aria$role = $elm$html$Html$Attributes$attribute('role');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Card$drawInfoCard = F4(
	function (deployedSeriesMostRecent, translations, gallery, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card button-reset-style block tablet-leader-1 trailer-1 clearfix'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('article'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(model.G),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					$elm$html$Html$Attributes$tabindex(0),
					$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
					$author$project$Card$ForParent(
						$author$project$Card$ViewDetails(model))),
					$author$project$Card$onEnterNoBubble(
					$author$project$Card$ForParent(
						$author$project$Card$ViewDetails(model)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-obverse-side button-reset-content-style'),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					A4($author$project$Card$drawCard, deployedSeriesMostRecent, translations, gallery, model))
				]));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Main$viewRelatedCard = F4(
	function (deployedSeriesMostRecent, translations, gallery, card) {
		var classifiedCard = _Utils_update(
			card,
			{ap: $author$project$Card$SolutionTemplate});
		return A2(
			$elm$html$Html$map,
			$author$project$Main$cardMessageTranslator,
			A4($author$project$Card$drawInfoCard, deployedSeriesMostRecent, translations, gallery, classifiedCard));
	});
var $author$project$Main$viewModal = function (model) {
	var _v0 = model.ak;
	switch (_v0) {
		case 'Filters':
			return A6($author$project$Main$viewFiltersModal, model.aP, model.B, model.x, model.D, model.n, model.ad);
		case 'Delete':
			return A4($author$project$Main$viewDeleteModal, model.Q, model.n, model.F, model.aB);
		case 'Diagram':
			return A2($author$project$Main$viewDiagramModal, model.aO, model.n);
		default:
			var relatedSolutionCards = A2(
				$elm$core$List$filter,
				function (card) {
					return A2($elm$core$List$member, card.aa, model.b.dr);
				},
				model.az);
			var relatedSolutionOrderedCards = A2(
				$elm$core$List$map,
				function (id) {
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Card$emptyCard,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (card) {
									return _Utils_eq(card.aa, id);
								},
								relatedSolutionCards)));
				},
				model.b.dr);
			var relatedSolutionDisplays = A2(
				$elm$core$List$map,
				A3($author$project$Main$viewRelatedCard, model.Z, model.n, model.T),
				relatedSolutionOrderedCards);
			return $author$project$Main$viewCardModal(model.aU)(model.aP)(model.b)(model.L)(relatedSolutionDisplays)(model.ae)(model.an)(model.F)(model.n)(model.aE)(model.H)(model.T)(model.a9)(model.aT)(model.aF)(model.aw)(model.az);
	}
};
var $author$project$Main$SuppressAnnouncementPermanently = function (a) {
	return {$: 36, a: a};
};
var $author$project$Main$SuppressAnnouncementTemporarily = function (a) {
	return {$: 37, a: a};
};
var $author$project$Main$calciteAction = $elm$html$Html$node('calcite-action');
var $author$project$Main$calciteAlert = $elm$html$Html$node('calcite-alert');
var $author$project$Main$calciteTooltip = $elm$html$Html$node('calcite-tooltip');
var $author$project$Translations$Search$deployFirstSolution = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'search.deployFirstSolution');
};
var $author$project$Translations$Alerts$doNotShowThisMessageAgain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'alerts.doNotShowThisMessageAgain');
};
var $author$project$Translations$Alerts$newFeatureInArcGISSolutions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'alerts.newFeatureInArcGISSolutions');
};
var $author$project$Translations$Search$noSolutionsYet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'search.noSolutionsYet');
};
var $author$project$Translations$Search$nothingFound = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'search.nothingFound');
};
var $author$project$Translations$Filters$numberOfSolutionsFound = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'filters.numberOfSolutionsFound',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $author$project$Main$onCalciteAlertClose = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'calciteAlertBeforeClose',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Translations$Alerts$solutionDiagramFeature = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'alerts.solutionDiagramFeature');
};
var $author$project$Main$solutionsBriefcase = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
			A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M29.963 7.672a1.586 1.586 0 0 0-1.584-1.585h-5.274a.187.187 0 0 1-.188-.187V3.977A2 2 0 0 0 20.825 2h-9.672A2.095 2.095 0 0 0 9.06 4.093V5.9a.187.187 0 0 1-.187.187H3.598a1.586 1.586 0 0 0-1.584 1.585v4.016a.281.281 0 0 0 .281.28H4.9l.014-.013V9.153a.177.177 0 0 1 .177-.177h21.46a.456.456 0 0 1 .449.45v13.742A1.832 1.832 0 0 1 25.168 25h-8.892a.568.568 0 0 1-.534-.373 3.98 3.98 0 0 0-7.6.373H5.657a.757.757 0 0 1-.757-.757v-3.055A.188.188 0 0 0 4.714 21H2.028l-.014.014v4.58a2.35 2.35 0 0 0 2.347 2.346h4.161a3.963 3.963 0 0 0 6.8.256.569.569 0 0 1 .475-.256h12.065a2.102 2.102 0 0 0 2.101-2.101zM21 5.625a.375.375 0 0 1-.375.375h-9.25A.375.375 0 0 1 11 5.625V4.45a.456.456 0 0 1 .45-.45h9.1a.456.456 0 0 1 .45.45zM12 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2z'),
					$elm$svg$Svg$Attributes$fill('#ccc')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M13.273 17.994a.57.57 0 0 1 .479.262A3.73 3.73 0 0 0 17 20a3.74 3.74 0 0 0 3.403-2.006h3.41a.188.188 0 0 0 .187-.188v-2.589a.187.187 0 0 0-.188-.188H20.8A3.8 3.8 0 0 0 17 12a4.058 4.058 0 0 0-3.69 2.647.568.568 0 0 1-.537.383H1.093a.094.094 0 0 0-.093.093V17.9a.094.094 0 0 0 .094.094zM17 13.9a2.1 2.1 0 1 1-2.1 2.1 2.1 2.1 0 0 1 2.1-2.1z'),
					$elm$svg$Svg$Attributes$fill('#ccc')
				]),
			_List_Nil)
		]));
var $author$project$Card$SolutionInProgress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Card$missingImageDataURI = 'https://gis.dwa.org/portal/portalimages/solution.png';
var $author$project$Card$drawDeployingCardImage = F2(
	function (token, model) {
		var thumbnailUrl = ((token === '') || (_Utils_eq(model.aj, $author$project$Card$missingImageDataURI) || model.bq)) ? model.aj : (model.aj + ('&token=' + token));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-image-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$alt(model.G),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
							$elm$html$Html$Attributes$src(thumbnailUrl),
							$elm$html$Html$Attributes$class('card-image')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-action-deploy card-action-deploying')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('centerer')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Card$calciteLoader,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'active', ''),
											$elm$html$Html$Attributes$class('sow-loader'),
											A2(
											$elm$html$Html$Attributes$attribute,
											'type',
											(model.a7 > 0) ? 'determinate' : 'indeterminate'),
											A2(
											$elm$html$Html$Attributes$attribute,
											'value',
											(model.a7 > 0) ? $elm$core$String$fromFloat(model.a7) : '')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Card$drawDeployingCard = F2(
	function (token, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card block tablet-leader-1 trailer-1 clearfix'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('article'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(model.G),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-obverse-side-deploying')
						]),
					_List_fromArray(
						[
							A2($author$project$Card$drawDeployingCardImage, token, model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-content card-content-bottom-spacing')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-title-link font-size--1 bottom-margin-1rem')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.G)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-size--2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.aW)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-bottom-area-reservation')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Main$viewDeployingCard = F2(
	function (token, card) {
		var classifiedCard = _Utils_update(
			card,
			{
				ap: $author$project$Card$SolutionInProgress(0)
			});
		return A2(
			$elm$html$Html$map,
			$author$project$Main$cardMessageTranslator,
			A2($author$project$Card$drawDeployingCard, token, classifiedCard));
	});
var $author$project$Translations$Search$searching = F2(
	function (translations, searchTerm) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'search.searching',
			_List_fromArray(
				[
					_Utils_Tuple2('searchTerm', searchTerm)
				]));
	});
var $author$project$Main$viewPageLoader = F3(
	function (translations, searchTerm, loaderType) {
		return _List_fromArray(
			[
				A2(
				$author$project$Main$calciteLoader,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'active', ''),
						$elm$html$Html$Attributes$class(
						(loaderType === 1) ? 'scroll-card-loader' : 'card-loader')
					]),
				_List_Nil),
				((loaderType === 2) && ($elm$core$String$length(searchTerm) > 2)) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-loader-text text-center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Translations$Search$searching, translations, searchTerm))
					])) : $elm$html$Html$text('')
			]);
	});
var $author$project$Card$ForSelf = function (a) {
	return {$: 0, a: a};
};
var $author$project$Card$NoOp = {$: 0};
var $author$project$Card$OpenDeleteModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Card$OpenDiagramModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Card$OpenLink = function (a) {
	return {$: 2, a: a};
};
var $author$project$Card$TriggerBlur = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Card$TriggerFocus = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Card$calciteButton = $elm$html$Html$node('calcite-button');
var $author$project$Translations$Delete$deleteDisabledTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.deleteDisabledTooltip');
};
var $author$project$Translations$Delete$deleteTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'delete.deleteTooltip');
};
var $author$project$Card$drawLinkCardImage = F3(
	function (translations, model, token) {
		var thumbnailUrl = ((token === '') || _Utils_eq(model.aj, $author$project$Card$missingImageDataURI)) ? model.aj : (model.aj + ('&token=' + token));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-image-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$alt(model.G),
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
							$elm$html$Html$Attributes$src(thumbnailUrl),
							$elm$html$Html$Attributes$class('card-image')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-action-deploy action-icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('centerer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-action-deploy-button avenir-bold')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$sub,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('icon-ui-link-external thumbnail-download-icon')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-size--1')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Cards$open(translations))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Card$onClickNoBubble = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{bX: msg, b1: true, b5: true}));
};
var $author$project$Card$onEnter = function (msg) {
	var isEnter = function (key) {
		return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not ENTER');
	};
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnter, $author$project$Card$keyEventDecoder));
};
var $author$project$Card$onFocusOut = function (toMsg) {
	return A2(
		$elm$html$Html$Events$on,
		'focusout',
		A2($elm$json$Json$Decode$map, toMsg, $elm$json$Json$Decode$value));
};
var $author$project$Card$onTouchNoBubble = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'touchend',
		$elm$json$Json$Decode$succeed(
			{bX: msg, b1: true, b5: true}));
};
var $author$project$Translations$Diagram$showDiagramTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'diagram.showDiagramTooltip');
};
var $author$project$Card$drawLinkCard = F4(
	function (translations, selectedCardId, token, model) {
		var classes = 'card-action-button card-action-diagram-button tooltip tooltip-bottom' + (model.bT ? ' highlight-new-feature' : '');
		var showDiagramButton = model.b3 ? _List_fromArray(
			[
				A2(
				$author$project$Card$calciteButton,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(classes),
						A2($elm$html$Html$Attributes$attribute, 'appearance', 'transparent'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'aria-label',
						$author$project$Translations$Diagram$showDiagramTooltip(translations)),
						A2($elm$html$Html$Attributes$attribute, 'icon-start', 'model'),
						A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'label',
						$author$project$Translations$Diagram$showDiagramTooltip(translations)),
						$author$project$Card$onClickNoBubble(
						$author$project$Card$ForParent(
							$author$project$Card$OpenDiagramModal(model))),
						$author$project$Card$onEnterNoBubble(
						$author$project$Card$ForParent(
							$author$project$Card$OpenDiagramModal(model))),
						$author$project$Card$onTouchNoBubble(
						$author$project$Card$ForParent(
							$author$project$Card$OpenDiagramModal(model)))
					]),
				_List_Nil)
			]) : _List_Nil;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card button-reset-style block tablet-leader-1 trailer-1 clearfix'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('article'),
					$elm$html$Html$Attributes$tabindex(0),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					$elm$html$Html$Attributes$id('solution-card-id-' + model.aa),
					$elm$html$Html$Events$onClick(
					$author$project$Card$ForParent(
						$author$project$Card$OpenLink(model.aq))),
					$author$project$Card$onEnterNoBubble(
					$author$project$Card$ForParent(
						$author$project$Card$OpenLink(model.aq))),
					$author$project$Card$onTouchNoBubble(
					$author$project$Card$ForParent(
						$author$project$Card$TriggerFocus(model.aa))),
					A2($elm$html$Html$Attributes$attribute, 'role', 'menu'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', model.G)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-obverse-side button-reset-content-style'),
								$fapian$elm_html_aria$Html$Attributes$Aria$role('article'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(model.G),
								$elm$html$Html$Attributes$tabindex(-1),
								$author$project$Card$onFocusOut(
								function (event) {
									return $author$project$Card$ForParent(
										A2($author$project$Card$TriggerBlur, model.aa, event));
								}),
								A2($elm$html$Html$Attributes$attribute, 'role', 'menuitem')
							]),
						_Utils_eq(model.aa, selectedCardId) ? _List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
								A2(
								$elm$html$Html$Attributes$attribute,
								'aria-label',
								$author$project$Translations$Cards$open(translations)),
								A2(
								$elm$html$Html$Attributes$attribute,
								'label',
								$author$project$Translations$Cards$open(translations)),
								$author$project$Card$onTouchNoBubble(
								$author$project$Card$ForParent(
									$author$project$Card$OpenLink(model.aq))),
								$author$project$Card$onEnter(
								$author$project$Card$ForParent(
									$author$project$Card$OpenLink(model.aq)))
							]) : _List_Nil),
					_List_fromArray(
						[
							A3($author$project$Card$drawLinkCardImage, translations, model, token),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-content card-content-bottom-spacing')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-title-link font-size--1 bottom-margin-1rem')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.G)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-size--2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.aW)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-bottom-area-reservation')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-bottom-row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-date')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.bi)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-bottom-row-icons')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('inline-block')
														]),
													_Utils_ap(
														showDiagramButton,
														_List_fromArray(
															[
																A2(
																$author$project$Card$calciteButton,
																_Utils_ap(
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('card-action-button card-action-delete-button tooltip tooltip-bottom'),
																			A2($elm$html$Html$Attributes$attribute, 'appearance', 'transparent'),
																			A2($elm$html$Html$Attributes$attribute, 'icon-start', 'trash'),
																			A2($elm$html$Html$Attributes$attribute, 'kind', 'neutral')
																		]),
																	(!model.bh) ? _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$Attributes$attribute,
																			'aria-label',
																			$author$project$Translations$Delete$deleteDisabledTooltip(translations)),
																			A2(
																			$elm$html$Html$Attributes$attribute,
																			'label',
																			$author$project$Translations$Delete$deleteDisabledTooltip(translations)),
																			$author$project$Card$onClickNoBubble(
																			$author$project$Card$ForSelf($author$project$Card$NoOp)),
																			$elm$html$Html$Attributes$tabindex(-1),
																			$elm$html$Html$Attributes$class('button-disable')
																		]) : _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$Attributes$attribute,
																			'aria-label',
																			$author$project$Translations$Delete$deleteTooltip(translations)),
																			A2(
																			$elm$html$Html$Attributes$attribute,
																			'label',
																			$author$project$Translations$Delete$deleteTooltip(translations)),
																			$author$project$Card$onClickNoBubble(
																			$author$project$Card$ForParent(
																				$author$project$Card$OpenDeleteModal(model))),
																			$author$project$Card$onEnterNoBubble(
																			$author$project$Card$ForParent(
																				$author$project$Card$OpenDeleteModal(model))),
																			$author$project$Card$onTouchNoBubble(
																			$author$project$Card$ForParent(
																				$author$project$Card$OpenDeleteModal(model))),
																			$author$project$Card$onFocusOut(
																			function (event) {
																				return $author$project$Card$ForParent(
																					A2($author$project$Card$TriggerBlur, model.aa, event));
																			})
																		])),
																_List_Nil)
															])))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Main$viewSolutionCard = F6(
	function (translations, selectedCardId, token, showDiagramButtonVisible, suppress_solutionDiagramFeature_announcement, card) {
		var classifiedCard = _Utils_update(
			card,
			{ap: $author$project$Card$DeployedSolution, bT: !suppress_solutionDiagramFeature_announcement, b3: showDiagramButtonVisible});
		return A2(
			$elm$html$Html$map,
			$author$project$Main$cardMessageTranslator,
			A4($author$project$Card$drawLinkCard, translations, selectedCardId, token, classifiedCard));
	});
var $author$project$Main$viewSolutionsPage = function (showLoading) {
	return function (waitingDeployInfos) {
		return function (deployingCards) {
			return function (deployedCards) {
				return function (searchTerm) {
					return function (translations) {
						return function (heights) {
							return function (loaderType) {
								return function (selectedCardId) {
									return function (token) {
										return function (showDiagramButtonVisible) {
											return function (suppress_solutionDiagramFeature_announcement) {
												var myCardList = function () {
													var waitingCards = A2(
														$elm$core$List$map,
														function (deployInfo) {
															return deployInfo.t;
														},
														$elm$core$Dict$values(waitingDeployInfos));
													return _Utils_ap(
														A2(
															$elm$core$List$map,
															$author$project$Main$viewDeployingCard(token),
															waitingCards),
														_Utils_ap(
															A2(
																$elm$core$List$map,
																$author$project$Main$viewDeployingCard(token),
																$elm$core$Dict$values(deployingCards)),
															A2(
																$elm$core$List$map,
																A5($author$project$Main$viewSolutionCard, translations, selectedCardId, token, showDiagramButtonVisible, suppress_solutionDiagramFeature_announcement),
																deployedCards)));
												}();
												var cardHeight = showLoading ? 'unset' : ('calc((100% - ' + ($elm$core$String$fromInt(heights.a3) + 'px) - 2rem)'));
												var announcement = (!suppress_solutionDiagramFeature_announcement) ? _List_fromArray(
													[
														A2(
														$author$project$Main$calciteAlert,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$attribute, 'kind', 'info'),
																A2($elm$html$Html$Attributes$attribute, 'icon', 'information'),
																A2($elm$html$Html$Attributes$attribute, 'open', 'true'),
																$elm$html$Html$Attributes$id('announcementAlert'),
																$author$project$Main$onCalciteAlertClose(
																$author$project$Main$SuppressAnnouncementTemporarily('suppress_solutionDiagramFeature_announcement'))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'slot', 'title')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Alerts$newFeatureInArcGISSolutions(translations))
																	])),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'slot', 'message')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Translations$Alerts$solutionDiagramFeature(translations))
																	])),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$attribute, 'slot', 'actions-end')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Main$calciteAction,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$attribute, 'icon', 'view-hide'),
																				A2(
																				$elm$html$Html$Attributes$attribute,
																				'text',
																				$author$project$Translations$Alerts$doNotShowThisMessageAgain(translations)),
																				$elm$html$Html$Attributes$id('suppress_solutionDiagramFeature_announcement'),
																				$elm$html$Html$Events$onClick(
																				$author$project$Main$SuppressAnnouncementPermanently('suppress_solutionDiagramFeature_announcement')),
																				A2($elm$html$Html$Attributes$style, 'height', '100%')
																			]),
																		_List_Nil),
																		A2(
																		$author$project$Main$calciteTooltip,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$attribute, 'reference-element', 'suppress_solutionDiagramFeature_announcement')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$span,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Translations$Alerts$doNotShowThisMessageAgain(translations))
																					]))
																			]))
																	]))
															]))
													]) : _List_Nil;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('full-height main-section flex padding-left-0 padding-right-0')
														]),
													_Utils_ap(
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('full-height padding-left-0 padding-right-0 solutions-card-area-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('alert alert-red alert-full')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('alert')
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('my-solutions-controls')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('count-container clearfix leader-half')
																					]),
																				_List_fromArray(
																					[
																						function () {
																						if (!showLoading) {
																							var numCards = $elm$core$List$length(myCardList);
																							var message = A2(
																								$author$project$Translations$Filters$numberOfSolutionsFound,
																								translations,
																								$elm$core$String$fromInt(numCards));
																							return A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('solution-count margin-right-1 left line-height-2'),
																										$elm$html$Html$Attributes$tabindex(0),
																										A2($elm$html$Html$Attributes$attribute, 'role', 'marquee'),
																										A2($elm$html$Html$Attributes$attribute, 'aria-label', message),
																										A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(message)
																									]));
																						} else {
																							return $elm$html$Html$text('');
																						}
																					}()
																					]))
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('leader-half'),
																				A2($elm$html$Html$Attributes$style, 'height', cardHeight)
																			]),
																		_List_fromArray(
																			[
																				showLoading ? A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('spacer')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('')
																					])) : ((!(!$elm$core$List$length(myCardList))) ? A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('block-group lg-screen-block-group-4 sm-screen-block-group-3-2 tablet-block-group-2 phone-block-group-1 solutions-card-area'),
																						$elm$html$Html$Attributes$id('my-results-section'),
																						A2($elm$html$Html$Attributes$style, 'style', 'clear:both'),
																						A2($elm$html$Html$Attributes$style, 'max-height', '100%')
																					]),
																				myCardList) : A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('solutions-briefcase'),
																								A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'),
																								A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
																							]),
																						_List_fromArray(
																							[$author$project$Main$solutionsBriefcase])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('text-center leader-1 warning-text trailer-1')
																							]),
																						($elm$core$String$length(searchTerm) > 0) ? _List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Translations$Search$nothingFound(translations))
																							]) : _List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Translations$Search$noSolutionsYet(translations))
																									])),
																								$elm$html$Html$text(
																								$author$project$Translations$Search$deployFirstSolution(translations))
																							]))
																					])))
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('card-loader-parent')
																			]),
																		showLoading ? A3($author$project$Main$viewPageLoader, translations, searchTerm, loaderType) : _List_fromArray(
																			[
																				$elm$html$Html$text('')
																			]))
																	]))
															]),
														announcement));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$ScrollEvent = function (a) {
	return {$: 47, a: a};
};
var $author$project$Main$TabEvent = {$: 48};
var $author$project$Main$ScrollInfo = F3(
	function (scrollHeight, scrollTop, offsetHeight) {
		return {c1: offsetHeight, dz: scrollHeight, dA: scrollTop};
	});
var $author$project$Main$scrollInfoDecoderOn = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Main$ScrollInfo,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'offsetHeight']),
		$elm$json$Json$Decode$float));
var $author$project$Main$onScroll = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2($elm$json$Json$Decode$map, msg, $author$project$Main$scrollInfoDecoderOn));
};
var $author$project$Main$onTab = function (msg) {
	var isTab = function (key) {
		return (key === 'Tab') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not TAB');
	};
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isTab, $author$project$Main$keyEventDecoder));
};
var $author$project$Main$ClearFilters = {$: 12};
var $author$project$Main$DomainFilterRemoved = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$IndustryFilterRemoved = function (a) {
	return {$: 9, a: a};
};
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Main$activeFilter = function (filterLists) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (filterList) {
				return $elm$core$Set$size(filterList);
			},
			filterLists)) > 0;
};
var $author$project$Translations$Filters$clearFilters = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.clearFilters');
};
var $author$project$Translations$Filters$clearSingleFilter = F2(
	function (translations, filterName) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'filters.clearSingleFilter',
			_List_fromArray(
				[
					_Utils_Tuple2('filterName', filterName)
				]));
	});
var $author$project$Translations$Filters$domainFilterType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.domainFilterType');
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Main$filterChipClearButton = F2(
	function (clearFilterNote, updateMsg) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter-chip--remove'),
					$elm$html$Html$Events$onClick(updateMsg),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', clearFilterNote)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('icon-inline'),
							A2($elm$html$Html$Attributes$attribute, 'height', '16'),
							$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
							A2($elm$html$Html$Attributes$attribute, 'width', '16')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M8.718 8l5.303 5.303-.707.707L8.01 8.707 2.707 14.01 2 13.303 7.303 8 2 2.697l.707-.707L8.01 7.293l5.304-5.303.707.707z')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Main$filterChip = F4(
	function (updateMsg, filter, filterType, clearFilterNote) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter-chip margin-right-half')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filter-chip-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(filterType + (': ' + filter))
						])),
					A2($author$project$Main$filterChipClearButton, clearFilterNote, updateMsg)
				]));
	});
var $author$project$Translations$Filters$industryFilterType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.industryFilterType');
};
var $author$project$Translations$Filters$newFilterType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'filters.newFilterType');
};
var $author$project$Main$viewFilterChips = F6(
	function (showLoading, solutionCount, industryFilters, domainFilters, typeFilters, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter-chip-wrap left')
				]),
			(!showLoading) ? A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('solution-count margin-right-1 left line-height-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$Filters$numberOfSolutionsFound,
								translations,
								$elm$core$String$fromInt(solutionCount)))
						])),
				$author$project$Main$activeFilter(
					_List_fromArray(
						[industryFilters, domainFilters, typeFilters])) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('margin-right-quarter break-word filter-chips')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-size--2 margin-right-quarter filter-chips-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Filters$filtersHeading(translations))
									])),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (industryFilter) {
										var translatedIndustryFilterType = $author$project$Translations$Filters$industryFilterType(translations);
										var translatedIndustryFilter = A2($author$project$Main$getFilterValueDisplay, translations, industryFilter);
										var translatedClearIndustryFilter = A2($author$project$Translations$Filters$clearSingleFilter, translations, translatedIndustryFilter);
										return A4(
											$author$project$Main$filterChip,
											$author$project$Main$IndustryFilterRemoved(industryFilter),
											translatedIndustryFilter,
											translatedIndustryFilterType,
											translatedClearIndustryFilter);
									},
									$elm$core$Set$toList(industryFilters)),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										function (domainFilter) {
											var translatedDomainFilterType = $author$project$Translations$Filters$domainFilterType(translations);
											var translatedDomainFilter = A2($author$project$Main$getFilterValueDisplay, translations, domainFilter);
											var translatedClearDomainFilter = A2($author$project$Translations$Filters$clearSingleFilter, translations, translatedDomainFilter);
											return A4(
												$author$project$Main$filterChip,
												$author$project$Main$DomainFilterRemoved(domainFilter),
												translatedDomainFilter,
												translatedDomainFilterType,
												translatedClearDomainFilter);
										},
										$elm$core$Set$toList(domainFilters)),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (typeFilter) {
												var translatedTypeFilter = A2($author$project$Main$getFilterValueDisplay, translations, typeFilter);
												var translatedNewFilterType = $author$project$Translations$Filters$newFilterType(translations);
												var translatedClearTypeFilter = A2(
													$author$project$Translations$Filters$clearSingleFilter,
													translations,
													$author$project$Translations$Filters$newReleaseToggle(translations));
												return A4(
													$author$project$Main$filterChip,
													A2($author$project$Main$TypeFilterToggled, typeFilter, false),
													translatedTypeFilter,
													translatedNewFilterType,
													translatedClearTypeFilter);
											},
											$elm$core$Set$toList(typeFilters)),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('btn-link btn-link-off-black font-size--2 margin-right-half filter-clear-all'),
														$elm$html$Html$Events$onClick($author$project$Main$ClearFilters)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Filters$clearFilters(translations))
													]))
											]))))))
					]) : _List_fromArray(
					[
						$elm$html$Html$text('')
					])) : _List_fromArray(
				[
					$elm$html$Html$text('')
				]));
	});
var $author$project$Main$viewTemplateCard = F4(
	function (deployedSeriesMostRecent, translations, gallery, card) {
		var classifiedCard = _Utils_update(
			card,
			{ap: $author$project$Card$SolutionTemplate});
		return A2(
			$elm$html$Html$map,
			$author$project$Main$cardMessageTranslator,
			A4($author$project$Card$drawInfoCard, deployedSeriesMostRecent, translations, gallery, classifiedCard));
	});
var $author$project$Main$viewTemplatesPage = function (categories) {
	return function (typeFilters) {
		return function (domainFilters) {
			return function (industryFilters) {
				return function (showLoading) {
					return function (optionalData) {
						return function (deployedSeriesMostRecent) {
							return function (availableSolutionCards) {
								return function (searchTerm) {
									return function (translations) {
										return function (showFilters) {
											return function (heights) {
												return function (loaderType) {
													return function (gallery) {
														return function (availableSolutionError) {
															return function (hasRelatedSolutions) {
																var filterActive = showFilters ? 'filterActive' : 'filterNotActive';
																var cardList = A2(
																	$elm$core$List$map,
																	A3($author$project$Main$viewTemplateCard, deployedSeriesMostRecent, translations, gallery),
																	availableSolutionCards);
																var solutionCount = A2($elm$core$Set$member, 'New', typeFilters) ? $elm$core$List$length(cardList) : optionalData.aY;
																var cardHeight = (showLoading && (!$elm$core$List$length(cardList))) ? 'unset' : ('calc((100% - ' + ($elm$core$String$fromInt(heights.a3) + 'px) - 2rem)'));
																return A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('full-height main-section flex padding-left-0 padding-right-0')
																		]),
																	_List_fromArray(
																		[
																			A8($author$project$Main$filterControl, categories, typeFilters, domainFilters, industryFilters, showFilters, translations, false, hasRelatedSolutions),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('full-height padding-left-0 padding-right-0 solutions-card-area-container')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$id('count-container'),
																							$elm$html$Html$Attributes$class('count-container clearfix leader-half'),
																							$elm$html$Html$Attributes$tabindex(0),
																							A2($elm$html$Html$Attributes$attribute, 'role', 'marquee'),
																							A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite')
																						]),
																					_List_fromArray(
																						[
																							A6($author$project$Main$viewFilterChips, showLoading, solutionCount, industryFilters, domainFilters, typeFilters, translations)
																						])),
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('leader-half'),
																							A2($elm$html$Html$Attributes$style, 'height', cardHeight)
																						]),
																					_List_fromArray(
																						[
																							(showLoading && (!$elm$core$List$length(cardList))) ? A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('spacer')
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text('')
																								])) : ((!(!$elm$core$List$length(cardList))) ? A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('block-group lg-screen-block-group-4 sm-screen-block-group-3-2 tablet-block-group-2 phone-block-group-1 solutions-card-area'),
																									$elm$html$Html$Attributes$id('results-section'),
																									A2($elm$html$Html$Attributes$style, 'clear', 'both'),
																									A2($elm$html$Html$Attributes$style, 'max-height', '100%'),
																									A2($elm$html$Html$Attributes$attribute, filterActive, ''),
																									$author$project$Main$onScroll($author$project$Main$ScrollEvent),
																									$author$project$Main$onTab($author$project$Main$TabEvent)
																								]),
																							cardList) : A2(
																							$elm$html$Html$div,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$div,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('solutions-briefcase'),
																											A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'),
																											A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
																										]),
																									_List_fromArray(
																										[$author$project$Main$solutionsBriefcase])),
																									A2(
																									$elm$html$Html$div,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('text-center leader-1 warning-text trailer-1')
																										]),
																									($elm$core$String$length(availableSolutionError) > 0) ? _List_fromArray(
																										[
																											$elm$html$Html$text(availableSolutionError)
																										]) : _List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Translations$Search$nothingFound(translations))
																										]))
																								])))
																						])),
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('card-loader-parent')
																						]),
																					showLoading ? A3($author$project$Main$viewPageLoader, translations, searchTerm, loaderType) : _List_fromArray(
																						[
																							$elm$html$Html$text('')
																						]))
																				]))
																		]));
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$view = function (model) {
	var totalNumItems = (!model.e) ? model.i.aY : (($elm$core$Dict$size(model.I) + $elm$core$Dict$size(model.r)) + $elm$core$List$length(model.Y));
	var start = (!model.e) ? model.i.bC : model.aS;
	var paginationPadding = ((!model.e) && ((_Utils_cmp(model.K, $author$project$Main$mobileWidthThreshold) > 0) && model.W)) ? 'pagination-padding' : '';
	var paginationContainerDisplay = (model.T && (_Utils_cmp(totalNumItems, $author$project$Main$galleryItemsPerPage) > 0)) ? ((_Utils_cmp(model.K, $author$project$Main$mobileWidthThreshold) > 0) ? 'flex' : 'block') : 'none';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('wrapper')
			]),
		_List_fromArray(
			[
				(!model.e) ? $author$project$Main$searchControl(model.V)(model.au)(model.X)(model.n)(
				$author$project$Translations$Search$searchArcGISSolutions(model.n))(true)(model.W)(model.K)(model.ay)(model.e)(model.ab) : $author$project$Main$searchControl(model.U)(model.as)(model.am)(model.n)(
				$author$project$Translations$Search$searchMyArcGISSolutions(model.n))(false)(false)(model.K)(model.ay)(model.e)(model.ab),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid-container'),
						$elm$html$Html$Events$onMouseUp($author$project$Main$StopDraggingPreviewImages)
					]),
				_List_fromArray(
					[
						(!model.e) ? $author$project$Main$viewTemplatesPage(model.aP)(model.B)(model.x)(model.D)(model.aL)(model.i)(model.Z)(model.C)(model.V)(model.n)(model.W)(model.aU)(model.O)(model.T)(model.a2)(model.ad) : $author$project$Main$viewSolutionsPage(model.a8)(model.I)(model.r)(model.Y)(model.U)(model.n)(model.aU)(model.O)(model.bd)(model.aw)(
						_Utils_cmp(model.K, $author$project$Main$mobileWidthThreshold) > 0)(
						model.av || (_Utils_cmp(model.K, $author$project$Main$mobileWidthThreshold) < 1)),
						$author$project$Main$viewModal(model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid-container pagination-container'),
						A2($elm$html$Html$Attributes$style, 'display', paginationContainerDisplay)
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('padding-left-0 margin-right-50 filters-container')
								]),
							_List_Nil)
						]),
					_List_fromArray(
						[
							(!model.e) ? A2(
							$author$project$Main$calcitePagination,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'id', 'paginator'),
									$elm$html$Html$Attributes$class('pagination-control'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'text-label-previous',
									$author$project$Translations$Pagination$jumpToPreviousPage(model.n)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'text-label-next',
									$author$project$Translations$Pagination$jumpToNextPage(model.n)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'start-item',
									$elm$core$String$fromInt(start)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'page-size',
									$elm$core$String$fromInt($author$project$Main$galleryItemsPerPage)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'total-items',
									$elm$core$String$fromInt(totalNumItems)),
									$author$project$Main$onPaginationEvent($author$project$Main$PaginationChange)
								]),
							_List_Nil) : A2($elm$html$Html$div, _List_Nil, _List_Nil)
						])))
			]));
};
var $author$project$Main$main = $elm$browser$Browser$element(
	{ew: $author$project$Main$init, fh: $author$project$Main$subscriptions, fr: $author$project$Main$update, fx: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));